angular.module('callX').service('DataService', ['$http', '$rootScope', 'UserService',
  function (){
      return {
          getCountries : function (){
              var countries = [
                  {"code":"US","value":"United States"},
                  {"code":"CA","value":"Canada"},
                  {"code":"AF","value":"Afghanistan"},
                  {"code":"AL","value":"Albania"},
                  {"code":"DZ","value":"Algeria"},
                  {"code":"DS","value":"American Samoa"},
                  {"code":"AD","value":"Andorra"},
                  {"code":"AO","value":"Angola"},
                  {"code":"AI","value":"Anguilla"},
                  {"code":"AQ","value":"Antarctica"},
                  {"code":"AG","value":"Antigua and/or Barbuda"},
                  {"code":"AR","value":"Argentina"},
                  {"code":"AM","value":"Armenia"},
                  {"code":"AW","value":"Aruba"},
                  {"code":"AU","value":"Australia"},
                  {"code":"AT","value":"Austria"},
                  {"code":"AZ","value":"Azerbaijan"},
                  {"code":"BS","value":"Bahamas"},
                  {"code":"BH","value":"Bahrain"},
                  {"code":"BD","value":"Bangladesh"},
                  {"code":"BB","value":"Barbados"},
                  {"code":"BY","value":"Belarus"},
                  {"code":"BE","value":"Belgium"},
                  {"code":"BZ","value":"Belize"},
                  {"code":"BJ","value":"Benin"},
                  {"code":"BM","value":"Bermuda"},
                  {"code":"BT","value":"Bhutan"},
                  {"code":"BO","value":"Bolivia"},
                  {"code":"BA","value":"Bosnia and Herzegovina"},
                  {"code":"BW","value":"Botswana"},
                  {"code":"BV","value":"Bouvet Island"},
                  {"code":"BR","value":"Brazil"},
                  {"code":"IO","value":"British lndian Ocean Territory"},
                  {"code":"BN","value":"Brunei Darussalam"},
                  {"code":"BG","value":"Bulgaria"},
                  {"code":"BF","value":"Burkina Faso"},
                  {"code":"BI","value":"Burundi"},
                  {"code":"KH","value":"Cambodia"},
                  {"code":"CM","value":"Cameroon"},
                  {"code":"CV","value":"Cape Verde"},
                  {"code":"KY","value":"Cayman Islands"},
                  {"code":"CF","value":"Central African Republic"},
                  {"code":"TD","value":"Chad"},
                  {"code":"CL","value":"Chile"},
                  {"code":"CN","value":"China"},
                  {"code":"CX","value":"Christmas Island"},
                  {"code":"CC","value":"Cocos (Keeling) Islands"},
                  {"code":"CO","value":"Colombia"},
                  {"code":"KM","value":"Comoros"},
                  {"code":"CG","value":"Congo"},
                  {"code":"CK","value":"Cook Islands"},
                  {"code":"CR","value":"Costa Rica"},
                  {"code":"HR","value":"Croatia (Hrvatska)"},
                  {"code":"CU","value":"Cuba"},
                  {"code":"CY","value":"Cyprus"},
                  {"code":"CZ","value":"Czech Republic"},
                  {"code":"DK","value":"Denmark"},
                  {"code":"DJ","value":"Djibouti"},
                  {"code":"DM","value":"Dominica"},
                  {"code":"DO","value":"Dominican Republic"},
                  {"code":"TP","value":"East Timor"},
                  {"code":"EC","value":"Ecudaor"},
                  {"code":"EG","value":"Egypt"},
                  {"code":"SV","value":"El Salvador"},
                  {"code":"GQ","value":"Equatorial Guinea"},
                  {"code":"ER","value":"Eritrea"},
                  {"code":"EE","value":"Estonia"},
                  {"code":"ET","value":"Ethiopia"},
                  {"code":"FK","value":"Falkland Islands (Malvinas)"},
                  {"code":"FO","value":"Faroe Islands"},
                  {"code":"FJ","value":"Fiji"},
                  {"code":"FI","value":"Finland"},
                  {"code":"FR","value":"France"},
                  {"code":"FX","value":"France, Metropolitan"},
                  {"code":"GF","value":"French Guiana"},
                  {"code":"PF","value":"French Polynesia"},
                  {"code":"TF","value":"French Southern Territories"},
                  {"code":"GA","value":"Gabon"},
                  {"code":"GM","value":"Gambia"},
                  {"code":"GE","value":"Georgia"},
                  {"code":"DE","value":"Germany"},
                  {"code":"GH","value":"Ghana"},
                  {"code":"GI","value":"Gibraltar"},
                  {"code":"GR","value":"Greece"},
                  {"code":"GL","value":"Greenland"},
                  {"code":"GD","value":"Grenada"},
                  {"code":"GP","value":"Guadeloupe"},
                  {"code":"GU","value":"Guam"},
                  {"code":"GT","value":"Guatemala"},
                  {"code":"GN","value":"Guinea"},
                  {"code":"GW","value":"Guinea-Bissau"},
                  {"code":"GY","value":"Guyana"},
                  {"code":"HT","value":"Haiti"},
                  {"code":"HM","value":"Heard and Mc Donald Islands"},
                  {"code":"HN","value":"Honduras"},
                  {"code":"HK","value":"Hong Kong"},
                  {"code":"HU","value":"Hungary"},
                  {"code":"IS","value":"Iceland"},
                  {"code":"IN","value":"India"},
                  {"code":"ID","value":"Indonesia"},
                  {"code":"IR","value":"Iran (Islamic Republic of)"},
                  {"code":"IQ","value":"Iraq"},
                  {"code":"IE","value":"Ireland"},
                  {"code":"IL","value":"Israel"},
                  {"code":"IT","value":"Italy"},
                  {"code":"CI","value":"Ivory Coast"},
                  {"code":"JM","value":"Jamaica"},
                  {"code":"JP","value":"Japan"},
                  {"code":"JO","value":"Jordan"},
                  {"code":"KZ","value":"Kazakhstan"},
                  {"code":"KE","value":"Kenya"},
                  {"code":"KI","value":"Kiribati"},
                  {"code":"KP","value":"Korea, Democratic People's Republic of"},
                  {"code":"KR","value":"Korea, Republic of"},
                  {"code":"KW","value":"Kuwait"},
                  {"code":"KG","value":"Kyrgyzstan"},
                  {"code":"LA","value":"Lao People's Democratic Republic"},
                  {"code":"LV","value":"Latvia"},
                  {"code":"LB","value":"Lebanon"},
                  {"code":"LS","value":"Lesotho"},
                  {"code":"LR","value":"Liberia"},
                  {"code":"LY","value":"Libyan Arab Jamahiriya"},
                  {"code":"LI","value":"Liechtenstein"},
                  {"code":"LT","value":"Lithuania"},
                  {"code":"LU","value":"Luxembourg"},
                  {"code":"MO","value":"Macau"},
                  {"code":"MK","value":"Macedonia"},
                  {"code":"MG","value":"Madagascar"},
                  {"code":"MW","value":"Malawi"},
                  {"code":"MY","value":"Malaysia"},
                  {"code":"MV","value":"Maldives"},
                  {"code":"ML","value":"Mali"},
                  {"code":"MT","value":"Malta"},
                  {"code":"MH","value":"Marshall Islands"},
                  {"code":"MQ","value":"Martinique"},
                  {"code":"MR","value":"Mauritania"},
                  {"code":"MU","value":"Mauritius"},
                  {"code":"TY","value":"Mayotte"},
                  {"code":"MX","value":"Mexico"},
                  {"code":"FM","value":"Micronesia, Federated States of"},
                  {"code":"MD","value":"Moldova, Republic of"},
                  {"code":"MC","value":"Monaco"},
                  {"code":"MN","value":"Mongolia"},
                  {"code":"MS","value":"Montserrat"},
                  {"code":"MA","value":"Morocco"},
                  {"code":"MZ","value":"Mozambique"},
                  {"code":"MM","value":"Myanmar"},
                  {"code":"NA","value":"Namibia"},
                  {"code":"NR","value":"Nauru"},
                  {"code":"NP","value":"Nepal"},
                  {"code":"NL","value":"Netherlands"},
                  {"code":"AN","value":"Netherlands Antilles"},
                  {"code":"NC","value":"New Caledonia"},
                  {"code":"NZ","value":"New Zealand"},
                  {"code":"NI","value":"Nicaragua"},
                  {"code":"NE","value":"Niger"},
                  {"code":"NG","value":"Nigeria"},
                  {"code":"NU","value":"Niue"},
                  {"code":"NF","value":"Norfork Island"},
                  {"code":"MP","value":"Northern Mariana Islands"},
                  {"code":"NO","value":"Norway"},
                  {"code":"OM","value":"Oman"},
                  {"code":"PK","value":"Pakistan"},
                  {"code":"PW","value":"Palau"},
                  {"code":"PA","value":"Panama"},
                  {"code":"PG","value":"Papua New Guinea"},
                  {"code":"PY","value":"Paraguay"},
                  {"code":"PE","value":"Peru"},
                  {"code":"PH","value":"Philippines"},
                  {"code":"PN","value":"Pitcairn"},
                  {"code":"PL","value":"Poland"},
                  {"code":"PT","value":"Portugal"},
                  {"code":"PR","value":"Puerto Rico"},
                  {"code":"QA","value":"Qatar"},
                  {"code":"RE","value":"Reunion"},
                  {"code":"RO","value":"Romania"},
                  {"code":"RU","value":"Russian Federation"},
                  {"code":"RW","value":"Rwanda"},
                  {"code":"KN","value":"Saint Kitts and Nevis"},
                  {"code":"LC","value":"Saint Lucia"},
                  {"code":"VC","value":"Saint Vincent and the Grenadines"},
                  {"code":"WS","value":"Samoa"},
                  {"code":"SM","value":"San Marino"},
                  {"code":"ST","value":"Sao Tome and Principe"},
                  {"code":"SA","value":"Saudi Arabia"},
                  {"code":"SN","value":"Senegal"},
                  {"code":"SC","value":"Seychelles"},
                  {"code":"SL","value":"Sierra Leone"},
                  {"code":"SG","value":"Singapore"},
                  {"code":"SK","value":"Slovakia"},
                  {"code":"SI","value":"Slovenia"},
                  {"code":"SB","value":"Solomon Islands"},
                  {"code":"SO","value":"Somalia"},
                  {"code":"ZA","value":"South Africa"},
                  {"code":"GS","value":"South Georgia South Sandwich Islands"},
                  {"code":"ES","value":"Spain"},
                  {"code":"LK","value":"Sri Lanka"},
                  {"code":"SH","value":"St. Helena"},
                  {"code":"PM","value":"St. Pierre and Miquelon"},
                  {"code":"SD","value":"Sudan"},
                  {"code":"SR","value":"Suriname"},
                  {"code":"SJ","value":"Svalbarn and Jan Mayen Islands"},
                  {"code":"SZ","value":"Swaziland"},
                  {"code":"SE","value":"Sweden"},
                  {"code":"CH","value":"Switzerland"},
                  {"code":"SY","value":"Syrian Arab Republic"},
                  {"code":"TW","value":"Taiwan"},
                  {"code":"TJ","value":"Tajikistan"},
                  {"code":"TZ","value":"Tanzania, United Republic of"},
                  {"code":"TH","value":"Thailand"},
                  {"code":"TG","value":"Togo"},
                  {"code":"TK","value":"Tokelau"},
                  {"code":"TO","value":"Tonga"},
                  {"code":"TT","value":"Trinidad and Tobago"},
                  {"code":"TN","value":"Tunisia"},
                  {"code":"TR","value":"Turkey"},
                  {"code":"TM","value":"Turkmenistan"},
                  {"code":"TC","value":"Turks and Caicos Islands"},
                  {"code":"TV","value":"Tuvalu"},
                  {"code":"UG","value":"Uganda"},
                  {"code":"UA","value":"Ukraine"},
                  {"code":"AE","value":"United Arab Emirates"},
                  {"code":"GB","value":"United Kingdom"},
                  {"code":"UM","value":"United States minor outlying islands"},
                  {"code":"UY","value":"Uruguay"},
                  {"code":"UZ","value":"Uzbekistan"},
                  {"code":"VU","value":"Vanuatu"},
                  {"code":"VA","value":"Vatican City State"},
                  {"code":"VE","value":"Venezuela"},
                  {"code":"VN","value":"Vietnam"},
                  {"code":"VG","value":"Virigan Islands (British)"},
                  {"code":"VI","value":"Virgin Islands (U.S.)"},
                  {"code":"WF","value":"Wallis and Futuna Islands"},
                  {"code":"EH","value":"Western Sahara"},
                  {"code":"YE","value":"Yemen"},
                  {"code":"YU","value":"Yugoslavia"},
                  {"code":"ZR","value":"Zaire"},
                  {"code":"ZM","value":"Zambia"},
                  {"code":"ZW","value":"Zimbabwe"}
              ];

              return countries;
          },

          getProvince : function() {
              var province = [
                  {"code":"AD-02", "value" :"Canillo" },
                  {"code":"AD-03", "value" :"Encamp" },
                  {"code":"AD-04", "value" :"La Massana" },
                  {"code":"AD-05", "value" :"Ordino" },
                  {"code":"AD-06", "value" :"Sant Julià de Lòria" },
                  {"code":"AD-07", "value" :"Andorra La Vella" },
                  {"code":"AD-08", "value" :"Escaldes-Engordany" },
                  {"code":"AE-AJ", "value" :"Ajman" },
                  {"code":"AE-AZ", "value" :"Abu Dhabi" },
                  {"code":"AE-DU", "value" :"Dubai" },
                  {"code":"AE-FU", "value" :"Fujairah" },
                  {"code":"AE-RK", "value" :"Ras Al Khaimah" },
                  {"code":"AE-SH", "value" :"Sharjah" },
                  {"code":"AE-UQ", "value" :"Um Al Quwain" },
                  {"code":"AF-BAL", "value" :"Balkh" },
                  {"code":"AF-BAM", "value" :"Bamyan"  },
                  {"code":"AF-BDG", "value" :"Badghis"  },
                  {"code":"AF-BDS", "value" :"Badakhshan"  },
                  {"code":"AF-BGL", "value" :"Baghlan"  },
                  {"code":"AF-DAY", "value" :"Daykundi"  },
                  {"code":"AF-FRA", "value" :"Farah"  },
                  {"code":"AF-FYB", "value" :"Faryab"  },
                  {"code":"AF-GHA", "value" :"Ghazni"  },
                  {"code":"AF-GHO", "value" :"Ghor"  },
                  {"code":"AF-HEL", "value" :"Helmand"  },
                  {"code":"AF-HER", "value" :"Herat"  },
                  {"code":"AF-JOW", "value" :"Jowzjan"  },
                  {"code":"AF-KAB", "value" :"Kabul"  },
                  {"code":"AF-KAN", "value" :"Kandahar"  },
                  {"code":"AF-KAP", "value" :"Kapisa"  },
                  {"code":"AF-KDZ", "value" :"Kunduz"  },
                  {"code":"AF-KHO", "value" :"Khost"  },
                  {"code":"AF-KNR", "value" :"Kunar"  },
                  {"code":"AF-LAG", "value" :"Laghman"  },
                  {"code":"AF-LOW", "value" :"Logar"  },
                  {"code":"AF-NAN", "value" :"Nangarhar"  },
                  {"code":"AF-NIM", "value" :"Nimruz"  },
                  {"code":"AF-NUR", "value" :"Nurestan"  },
                  {"code":"AF-ORU", "value" :"Oruzgan"  },
                  {"code":"AF-PAN", "value" :"Panjshir"  },
                  {"code":"AF-PAR", "value" :"Parwan"  },
                  {"code":"AF-PIA", "value" :"Paktia"  },
                  {"code":"AF-PKA", "value" :"Paktika"  },
                  {"code":"AF-SAM", "value" :"Samangan"  },
                  {"code":"AF-SAR", "value" :"Sar-e Pol"  },
                  {"code":"AF-TAK", "value" :"Takhar"  },
                  {"code":"AF-WAR", "value" :"Wardak"  },
                  {"code":"AF-ZAB", "value" :"Zabul"  },
                  {"code":"AG-03", "value" :"Saint George"   },
                  {"code":"AG-04", "value" :"Saint John ' s"   },
                  {"code":"AG-05", "value" :"Saint Mary"   },
                  {"code":"AG-06", "value" :"Saint Paul"   },
                  {"code":"AG-07", "value" :"Saint Peter"   },
                  {"code":"AG-08", "value" :"Saint Philip"   },
                  {"code":"AG-10", "value" :"Barbuda"   },
                  {"code":"AG-11", "value" :"Redonda"   },
                  {"code":"AL-BR", "value" :"Berat"   },
                  {"code":"AL-BU", "value" :"Bulqizë"   },
                  {"code":"AL-DI", "value" :"Dibër"   },
                  {"code":"AL-DL", "value" :"Delvinë"   },
                  {"code":"AL-DR", "value" :"Durrës"   },
                  {"code":"AL-DV", "value" :"Devoll"   },
                  {"code":"AL-EL", "value" :"Elbasan"   },
                  {"code":"AL-ER", "value" :"Kolonjë"   },
                  {"code":"AL-FR", "value" :"Fier"   },
                  {"code":"AL-GJ", "value" :"Gjirokastër"   },
                  {"code":"AL-GR", "value" :"Gramsh"   },
                  {"code":"AL-HA", "value" :"Has"   },
                  {"code":"AL-KA", "value" :"Kavajë"   },
                  {"code":"AL-KB", "value" :"Kurbin"   },
                  {"code":"AL-KC", "value" :"Kuçovë"   },
                  {"code":"AL-KO", "value" :"Korçë"   },
                  {"code":"AL-KR", "value" :"Krujë"   },
                  {"code":"AL-KU", "value" :"Kukës"   },
                  {"code":"AL-LB", "value" :"Librazhd"   },
                  {"code":"AL-LE", "value" :"Lezhë"   },
                  {"code":"AL-LU", "value" :"Lushnje"   },
                  {"code":"AL-MK", "value" :"Mallakastër"   },
                  {"code":"AL-MM", "value" :"Malësi e Madhe"   },
                  {"code":"AL-MR", "value" :"Mirditë"   },
                  {"code":"AL-MT", "value" :"Mat"   },
                  {"code":"AL-PG", "value" :"Pogradec"   },
                  {"code":"AL-PQ", "value" :"Peqin"   },
                  {"code":"AL-PR", "value" :"Përmet"   },
                  {"code":"AL-PU", "value" :"Pukë"   },
                  {"code":"AL-SH", "value" :"Shkodër"   },
                  {"code":"AL-SK", "value" :"Skrapar"   },
                  {"code":"AL-SR", "value" :"Sarandë"   },
                  {"code":"AL-TE", "value" :"Tepelenë"   },
                  {"code":"AL-TP", "value" :"Tropojë"   },
                  {"code":"AL-TR", "value" :"Tiranë"   },
                  {"code":"AL-VL", "value" :"Vlorë"   },
                  {"code":"AM-AG", "value" :"Aragatsotn"   },
                  {"code":"AM-AR", "value" :"Ararat"   },
                  {"code":"AM-AV", "value" :"Armavir"   },
                  {"code":"AM-ER", "value" :"Yerevan"   },
                  {"code":"AM-GR", "value" :"Gegharkunik"   },
                  {"code":"AM-KT", "value" :"Kotayk"   },
                  {"code":"AM-LO", "value" :"Lori"   },
                  {"code":"AM-SH", "value" :"Shirak"   },
                  {"code":"AM-SU", "value" :"Syunik"   },
                  {"code":"AM-TV", "value" :"Tavush"   },
                  {"code":"AM-VD", "value" :"Vayots Dzor"   },
                  {"code":"AO-BGO", "value" :"Bengo"   },
                  {"code":"AO-BGU", "value" :"Benguela"   },
                  {"code":"AO-BIE", "value" :"Bié"   },
                  {"code":"AO-CAB", "value" :"Cabinda"   },
                  {"code":"AO-CCU", "value" :"Cuando Cubango"   },
                  {"code":"AO-CNN", "value" :"Cunene"   },
                  {"code":"AO-CNO", "value" :"Cuanza Norte"   },
                  {"code":"AO-CUS", "value" :"Cuanza Sul"   },
                  {"code":"AO-HUA", "value" :"Huambo"   },
                  {"code":"AO-HUI", "value" :"Huíla"   },
                  {"code":"AO-LNO", "value" :"Lunda Norte"   },
                  {"code":"AO-LSU", "value" :"Lunda Sul"   },
                  {"code":"AO-LUA", "value" :"Luanda"   },
                  {"code":"AO-MAL", "value" :"Malanje"   },
                  {"code":"AO-MOX", "value" :"Moxico"   },
                  {"code":"AO-NAM", "value" :"Namibe"   },
                  {"code":"AO-UIG", "value" :"Uíge"   },
                  {"code":"AO-ZAI", "value" :"Zaire"   },
                  {"code":"AR-A", "value" :"Salta"   },
                  {"code":"AR-B", "value" :"Buenos Aires"   },
                  {"code":"AR-C", "value" :"Capital Federal"   },
                  {"code":"AR-D", "value" :"San Luis"   },
                  {"code":"AR-E", "value" :"Entre Ríos"   },
                  {"code":"AR-F", "value" :"La Rioja"   },
                  {"code":"AR-G", "value" :"Santiago del Estero"   },
                  {"code":"AR-H", "value" :"Chaco"   },
                  {"code":"AR-J", "value" :"San Juan"   },
                  {"code":"AR-K", "value" :"Catamarca"   },
                  {"code":"AR-L", "value" :"La Pampa"   },
                  {"code":"AR-M", "value" :"Mendoza"   },
                  {"code":"AR-N", "value" :"Misiones"   },
                  {"code":"AR-P", "value" :"Formosa"   },
                  {"code":"AR-Q", "value" :"Neuquén"   },
                  {"code":"AR-R", "value" :"Río Negro"   },
                  {"code":"AR-S", "value" :"Santa Fe"   },
                  {"code":"AR-T", "value" :"Tucumán"   },
                  {"code":"AR-U", "value" :"Chubut"   },
                  {"code":"AR-V", "value" :"Tierra del Fuego"   },
                  {"code":"AR-W", "value" :"Corrientes"   },
                  {"code":"AR-X", "value" :"Córdoba"   },
                  {"code":"AR-Y", "value" :"Jujuy"   },
                  {"code":"AR-Z", "value" :"Santa Cruz"   },
                  {"code":"AT-1", "value" :"Burgenland"   },
                  {"code":"AT-2", "value" :"Kärnten"   },
                  {"code":"AT-3", "value" :"Niederösterreich"   },
                  {"code":"AT-4", "value" :"Oberösterreich"   },
                  {"code":"AT-5", "value" :"Salzburg"   },
                  {"code":"AT-6", "value" :"Steiermark"   },
                  {"code":"AT-7", "value" :"Tirol"   },
                  {"code":"AT-8", "value" :"Vorarlberg"   },
                  {"code":"AT-9", "value" :"Wien"   },
                  {"code":"AU-ACT", "value" :"Australian Capital Territory"},
                  {"code":"AU-NSW", "value" :"New South Wales"  },
                  {"code":"AU-NT", "value" :"Northern Territory"  },
                  {"code":"AU-QLD", "value" :"Queensland"  },
                  {"code":"AU-SA", "value" :"South Australia"  },
                  {"code":"AU-TAS", "value" :"Tasmania"  },
                  {"code":"AU-VIC", "value" :"Victoria"  },
                  {"code":"AU-WA", "value" :"Western Australia"  },
                  {"code":"AZ-AB", "value" :"Əli-Bayramlı"   },
                  {"code":"AZ-ABS", "value" :"Abşeron"   },
                  {"code":"AZ-AGA", "value" :"Ağstafa"   },
                  {"code":"AZ-AGC", "value" :"Ağcabədi"   },
                  {"code":"AZ-AGM", "value" :"Ağdam"   },
                  {"code":"AZ-AGS", "value" :"Ağdaş"   },
                  {"code":"AZ-AGU", "value" :"Ağsu"   },
                  {"code":"AZ-AST", "value" :"Astara"   },
                  {"code":"AZ-BA", "value" :"Bakı"   },
                  {"code":"AZ-BAB", "value" :"Babək"   },
                  {"code":"AZ-BAL", "value" :"Balakən"   },
                  {"code":"AZ-BAR", "value" :"Bərdə"   },
                  {"code":"AZ-BEY", "value" :"Beyləqan"   },
                  {"code":"AZ-BIL", "value" :"Biləsuvar"   },
                  {"code":"AZ-CAB", "value" :"Cəbrayıl"   },
                  {"code":"AZ-CAL", "value" :"Cəlilabad"   },
                  {"code":"AZ-CUL", "value" :"Culfa"   },
                  {"code":"AZ-DAS", "value" :"Daşkəsən"   },
                  {"code":"AZ-DAV", "value" :"Dəvəçi"   },
                  {"code":"AZ-FUZ", "value" :"Füzuli"   },
                  {"code":"AZ-GA", "value" :"Gəncə"   },
                  {"code":"AZ-GAD", "value" :"Gədəbəy"   },
                  {"code":"AZ-GOR", "value" :"Goranboy"   },
                  {"code":"AZ-GOY", "value" :"Göyçay"   },
                  {"code":"AZ-HAC", "value" :"Hacıqabul"   },
                  {"code":"AZ-IMI", "value" :"İmişli"   },
                  {"code":"AZ-ISM", "value" :"İsmayıllı"   },
                  {"code":"AZ-KAL", "value" :"Kəlbəcər"   },
                  {"code":"AZ-KUR", "value" :"Kürdəmir"   },
                  {"code":"AZ-LA", "value" :"Lənkəran City"   },
                  {"code":"AZ-LAC", "value" :"Laçın"   },
                  {"code":"AZ-LAN", "value" :"Lənkəran"   },
                  {"code":"AZ-LER", "value" :"Lerik"   },
                  {"code":"AZ-MAS", "value" :"Masallı"   },
                  {"code":"AZ-MI", "value" :"Mingəçevir"   },
                  {"code":"AZ-NA", "value" :"Naftalan"   },
                  {"code":"AZ-NEF", "value" :"Neftçala"   },
                  {"code":"AZ-NX", "value" :"Naxçıvan"   },
                  {"code":"AZ-OGU", "value" :"Oğuz"   },
                  {"code":"AZ-ORD", "value" :"Ordubad"   },
                  {"code":"AZ-QAB", "value" :"Qəbələ"   },
                  {"code":"AZ-QAX", "value" :"Qax"   },
                  {"code":"AZ-QAZ", "value" :"Qazax"   },
                  {"code":"AZ-QBA", "value" :"Quba"   },
                  {"code":"AZ-QBI", "value" :"Qubadlı"   },
                  {"code":"AZ-QOB", "value" :"Qobustan"   },
                  {"code":"AZ-QUS", "value" :"Qusar"   },
                  {"code":"AZ-SA", "value" :"Şəki City"   },
                  {"code":"AZ-SAB", "value" :"Sabirabad"   },
                  {"code":"AZ-SAD", "value" :"Sədərək"   },
                  {"code":"AZ-SAH", "value" :"Şahbuz"   },
                  {"code":"AZ-SAK", "value" :"Şəki"   },
                  {"code":"AZ-SAL", "value" :"Salyan"   },
                  {"code":"AZ-SAR", "value" :"Şərur"   },
                  {"code":"AZ-SAT", "value" :"Saatlı"   },
                  {"code":"AZ-SIY", "value" :"Siyəzən"   },
                  {"code":"AZ-SKR", "value" :"Şəmkir"   },
                  {"code":"AZ-SM", "value" :"Sumqayit"   },
                  {"code":"AZ-SMI", "value" :"Şamaxı"   },
                  {"code":"AZ-SMX", "value" :"Samux"   },
                  {"code":"AZ-SS", "value" :"Şuşa City"   },
                  {"code":"AZ-SUS", "value" :"Şuşa"   },
                  {"code":"AZ-TAR", "value" :"Tər-Tər"   },
                  {"code":"AZ-TOV", "value" :"Tovuz"   },
                  {"code":"AZ-UCA", "value" :"Ucar"   },
                  {"code":"AZ-XA", "value" :"Xankəndi"   },
                  {"code":"AZ-XAC", "value" :"Xaçmaz"   },
                  {"code":"AZ-XAN", "value" :"Goygol"   },
                  {"code":"AZ-XCI", "value" :"Xocalı"   },
                  {"code":"AZ-XIZ", "value" :"Xızı"   },
                  {"code":"AZ-XVD", "value" :"Xocavənd"   },
                  {"code":"AZ-YAR", "value" :"Yardımlı"   },
                  {"code":"AZ-YE", "value" :"Yevlax City"   },
                  {"code":"AZ-YEV", "value" :"Yevlax"   },
                  {"code":"AZ-ZAN", "value" :"Zəngilan"   },
                  {"code":"AZ-ZAQ", "value" :"Zaqatala"   },
                  {"code":"AZ-ZAR", "value" :"Zərdab"   },
                  {"code":"BA-BIH", "value" :"Federacija Bosne i Hercegovine" },
                  {"code":"BA-BRC", "value" :"Brčko Distrikt" },
                  {"code":"BA-SRP", "value" :"Republika Srpska" },
                  {"code":"BB-01", "value" :"Christ Church" },
                  {"code":"BB-02", "value" :"Saint Andrew" },
                  {"code":"BB-03", "value" :"Saint George" },
                  {"code":"BB-04", "value" :"Saint James" },
                  {"code":"BB-05", "value" :"Saint John" },
                  {"code":"BB-06", "value" :"Saint Joseph" },
                  {"code":"BB-07", "value" :"Saint Lucy" },
                  {"code":"BB-08", "value" :"Saint Michael" },
                  {"code":"BB-09", "value" :"Saint Peter" },
                  {"code":"BB-10", "value" :"Saint Philip" },
                  {"code":"BB-11", "value" :"Saint Thomas" },
                  {"code":"BD-01", "value" :"Bandarban"   },
                  {"code":"BD-02", "value" :"Barguna"   },
                  {"code":"BD-03", "value" :"Bogra"   },
                  {"code":"BD-04", "value" :"Brahmanbaria"   },
                  {"code":"BD-05", "value" :"Bagerhat"   },
                  {"code":"BD-06", "value" :"Barisal"   },
                  {"code":"BD-07", "value" :"Bhola"   },
                  {"code":"BD-08", "value" :"Comilla"   },
                  {"code":"BD-09", "value" :"Chandpur"   },
                  {"code":"BD-10", "value" :"Chittagong"   },
                  {"code":"BD-11", "value" :"Cox's Bazar"   },
                  {"code":"BD-12", "value" :"Chuadanga"   },
                  {"code":"BD-13", "value" :"Dhaka"   },
                  {"code":"BD-14", "value" :"Dinajpur"   },
                  {"code":"BD-15", "value" :"Faridpur"   },
                  {"code":"BD-16", "value" :"Feni"   },
                  {"code":"BD-17", "value" :"Gopalganj"   },
                  {"code":"BD-18", "value" :"Gazipur"   },
                  {"code":"BD-19", "value" :"Gaibandha"   },
                  {"code":"BD-20", "value" :"Hobiganj"   },
                  {"code":"BD-21", "value" :"Jamalpur"   },
                  {"code":"BD-22", "value" :"Jessore"   },
                  {"code":"BD-23", "value" :"Jinaidaha"   },
                  {"code":"BD-24", "value" :"Joypurhat"   },
                  {"code":"BD-25", "value" :"Jhalokati"   },
                  {"code":"BD-26", "value" :"Kishoreganj"   },
                  {"code":"BD-27", "value" :"Khulna"   },
                  {"code":"BD-28", "value" :"Kurigram"   },
                  {"code":"BD-29", "value" :"Khagrachari"   },
                  {"code":"BD-30", "value" :"Kustia"   },
                  {"code":"BD-31", "value" :"Lakshmipur"   },
                  {"code":"BD-32", "value" :"Lalmonirhat"   },
                  {"code":"BD-33", "value" :"Manikganj"   },
                  {"code":"BD-34", "value" :"Mymensingh"   },
                  {"code":"BD-35", "value" :"Munshiganj"   },
                  {"code":"BD-36", "value" :"Madaripur"   },
                  {"code":"BD-37", "value" :"Magura"   },
                  {"code":"BD-38", "value" :"Moulvibazar"   },
                  {"code":"BD-39", "value" :"Meherpur"   },
                  {"code":"BD-40", "value" :"Narayanganj"   },
                  {"code":"BD-41", "value" :"Netrakona"   },
                  {"code":"BD-42", "value" :"Narshingdi"   },
                  {"code":"BD-43", "value" :"Narail"   },
                  {"code":"BD-44", "value" :"Natore"   },
                  {"code":"BD-45", "value" :"Chapai Nawabganj"   },
                  {"code":"BD-46", "value" :"Nilphamari"   },
                  {"code":"BD-47", "value" :"Noakhali"   },
                  {"code":"BD-48", "value" :"Naogaon"   },
                  {"code":"BD-49", "value" :"Pabna"   },
                  {"code":"BD-50", "value" :"Pirojpur"   },
                  {"code":"BD-51", "value" :"Potuakhali"   },
                  {"code":"BD-52", "value" :"Panchagarh"   },
                  {"code":"BD-53", "value" :"Rajbari"   },
                  {"code":"BD-54", "value" :"Rajshahi"   },
                  {"code":"BD-55", "value" :"Rangpur"   },
                  {"code":"BD-56", "value" :"Rangamati"   },
                  {"code":"BD-57", "value" :"Sherpur"   },
                  {"code":"BD-58", "value" :"Satkhira"   },
                  {"code":"BD-59", "value" :"Sirajganj"   },
                  {"code":"BD-60", "value" :"Sylhet"   },
                  {"code":"BD-61", "value" :"Sunamganj"   },
                  {"code":"BD-62", "value" :"Shariatpur"   },
                  {"code":"BD-63", "value" :"Tangail"   },
                  {"code":"BD-64", "value" :"Thakurgaon"   },
                  {"code":"BE-BRU", "value" :"Bruxelles-Capitale"  },
                  {"code":"BE-VAN", "value" :"Anvers"  },
                  {"code":"BE-VBR", "value" :"Brabant Flamand"  },
                  {"code":"BE-VLI", "value" :"Limbourg"  },
                  {"code":"BE-VOV", "value" :"Flandre Orientale"  },
                  {"code":"BE-VWV", "value" :"Flandre Occidentale"  },
                  {"code":"BE-WBR", "value" :"Brabant Wallon"  },
                  {"code":"BE-WHT", "value" :"Hainaut"  },
                  {"code":"BE-WLG", "value" :"Liège"  },
                  {"code":"BE-WLX", "value" :"Luxembourg"  },
                  {"code":"BE-WNA", "value" :"Namur"  },
                  {"code":"BF-BAL", "value" :"Balé"   },
                  {"code":"BF-BAM", "value" :"Bam"   },
                  {"code":"BF-BAN", "value" :"Banwa"   },
                  {"code":"BF-BAZ", "value" :"Bazèga"   },
                  {"code":"BF-BGR", "value" :"Bougouriba"   },
                  {"code":"BF-BLG", "value" :"Boulgou"   },
                  {"code":"BF-BLK", "value" :"Boulkiemdé"   },
                  {"code":"BF-COM", "value" :"Comoé"   },
                  {"code":"BF-GAN", "value" :"Ganzourgou"   },
                  {"code":"BF-GNA", "value" :"Gnagna"   },
                  {"code":"BF-GOU", "value" :"Gourma"   },
                  {"code":"BF-HOU", "value" :"Houet"   },
                  {"code":"BF-IOB", "value" :"Ioba"   },
                  {"code":"BF-KAD", "value" :"Kadiogo"   },
                  {"code":"BF-KEN", "value" :"Kénédougou"   },
                  {"code":"BF-KMD", "value" :"Komondjari"   },
                  {"code":"BF-KMP", "value" :"Kompienga"   },
                  {"code":"BF-KOP", "value" :"Koulpélogo"   },
                  {"code":"BF-KOS", "value" :"Kossi"   },
                  {"code":"BF-KOT", "value" :"Kouritenga"   },
                  {"code":"BF-KOW", "value" :"Kourwéogo"   },
                  {"code":"BF-LER", "value" :"Léraba"   },
                  {"code":"BF-LOR", "value" :"Loroum"   },
                  {"code":"BF-MOU", "value" :"Mouhoun"   },
                  {"code":"BF-NAM", "value" :"Namentenga"   },
                  {"code":"BF-NAO", "value" :"Nahouri"   },
                  {"code":"BF-NAY", "value" :"Nayala"   },
                  {"code":"BF-NOU", "value" :"Noumbiel"   },
                  {"code":"BF-OUB", "value" :"Oubritenga"   },
                  {"code":"BF-OUD", "value" :"Oudalan"   },
                  {"code":"BF-PAS", "value" :"Passoré"   },
                  {"code":"BF-PON", "value" :"Poni"   },
                  {"code":"BF-SEN", "value" :"Séno"   },
                  {"code":"BF-SIS", "value" :"Sissili"   },
                  {"code":"BF-SMT", "value" :"Sanmatenga"   },
                  {"code":"BF-SNG", "value" :"Sanguié"   },
                  {"code":"BF-SOM", "value" :"Soum"   },
                  {"code":"BF-SOR", "value" :"Sourou"   },
                  {"code":"BF-TAP", "value" :"Tapoa"   },
                  {"code":"BF-TUI", "value" :"Tui"   },
                  {"code":"BF-YAG", "value" :"Yagha"   },
                  {"code":"BF-YAT", "value" :"Yatenga"   },
                  {"code":"BF-ZIR", "value" :"Ziro"   },
                  {"code":"BF-ZON", "value" :"Zondoma"   },
                  {"code":"BF-ZOU", "value" :"Zoundwéogo"   },
                  {"code":"BG-01", "value" :"Blagoevgrad"   },
                  {"code":"BG-02", "value" :"Burgas"   },
                  {"code":"BG-03", "value" :"Varna"   },
                  {"code":"BG-04", "value" :"Veliko Turnovo"   },
                  {"code":"BG-05", "value" :"Vidin"   },
                  {"code":"BG-06", "value" :"Vratsa"   },
                  {"code":"BG-07", "value" :"Gabrovo"   },
                  {"code":"BG-08", "value" :"Dobrich"   },
                  {"code":"BG-09", "value" :"Kurdzhali"   },
                  {"code":"BG-10", "value" :"Kjustendil"   },
                  {"code":"BG-11", "value" :"Lovech"   },
                  {"code":"BG-12", "value" :"Montana"   },
                  {"code":"BG-13", "value" :"Pazardzhik"   },
                  {"code":"BG-14", "value" :"Pernik"   },
                  {"code":"BG-15", "value" :"Pleven"   },
                  {"code":"BG-16", "value" :"Plovdiv"   },
                  {"code":"BG-17", "value" :"Razgrad"   },
                  {"code":"BG-18", "value" :"Ruse"   },
                  {"code":"BG-19", "value" :"Silistra"   },
                  {"code":"BG-20", "value" :"Sliven"   },
                  {"code":"BG-21", "value" :"Smoljan"   },
                  {"code":"BG-22", "value" :"Sofia City"   },
                  {"code":"BG-23", "value" :"Sofia"   },
                  {"code":"BG-24", "value" :"Stara Zagora"   },
                  {"code":"BG-25", "value" :"Turgovishhe"   },
                  {"code":"BG-26", "value" :"Khaskovo"   },
                  {"code":"BG-27", "value" :"Shumen"   },
                  {"code":"BG-28", "value" :"Jambol"   },
                  {"code":"BH-13", "value" :"Capital Governorate"   },
                  {"code":"BH-14", "value" :"Southern Governorate"   },
                  {"code":"BH-15", "value" :"Muharraq Governorate"   },
                  {"code":"BH-16", "value" :"Central Governorate"   },
                  {"code":"BH-17", "value" :"Northern Governorate"   },
                  {"code":"BI-BB", "value" :"Bubanza"   },
                  {"code":"BI-BL", "value" :"Bujumbura Rural"   },
                  {"code":"BI-BM", "value" :"Bujumbura Mairie"   },
                  {"code":"BI-BR", "value" :"Bururi"   },
                  {"code":"BI-CA", "value" :"Cankuzo"   },
                  {"code":"BI-CI", "value" :"Cibitoke"   },
                  {"code":"BI-GI", "value" :"Gitega"   },
                  {"code":"BI-KI", "value" :"Kirundo"   },
                  {"code":"BI-KR", "value" :"Karuzi"   },
                  {"code":"BI-KY", "value" :"Kayanza"   },
                  {"code":"BI-MA", "value" :"Makamba"   },
                  {"code":"BI-MU", "value" :"Muramvya"   },
                  {"code":"BI-MW", "value" :"Mwaro"   },
                  {"code":"BI-MY", "value" :"Muyinga"   },
                  {"code":"BI-NG", "value" :"Ngozi"   },
                  {"code":"BI-RT", "value" :"Rutana"   },
                  {"code":"BI-RY", "value" :"Ruyigi"   },
                  {"code":"BJ-AK", "value" :"Atacora"   },
                  {"code":"BJ-AL", "value" :"Alibori"   },
                  {"code":"BJ-AQ", "value" :"Atlantique"   },
                  {"code":"BJ-BO", "value" :"Borgou"   },
                  {"code":"BJ-CO", "value" :"Collines"   },
                  {"code":"BJ-DO", "value" :"Donga"   },
                  {"code":"BJ-KO", "value" :"Couffo"   },
                  {"code":"BJ-LI", "value" :"Littoral"   },
                  {"code":"BJ-MO", "value" :"Mono"   },
                  {"code":"BJ-OU", "value" :"Ouémé"   },
                  {"code":"BJ-PL", "value" :"Plateau"   },
                  {"code":"BJ-ZO", "value" :"Zou"   },
                  {"code":"BN-BE", "value" :"Belait"   },
                  {"code":"BN-BM", "value" :"Brunei Muara"   },
                  {"code":"BN-TE", "value" :"Temburong"   },
                  {"code":"BN-TU", "value" :"Tutong"   },
                  {"code":"BO-B", "value" :"Beni"   },
                  {"code":"BO-C", "value" :"Cochabamba"   },
                  {"code":"BO-H", "value" :"Chuquisaca"   },
                  {"code":"BO-L", "value" :"La Paz"   },
                  {"code":"BO-N", "value" :"Pando"   },
                  {"code":"BO-O", "value" :"Oruro"   },
                  {"code":"BO-P", "value" :"Potosí"   },
                  {"code":"BO-S", "value" :"Santa Cruz"   },
                  {"code":"BO-T", "value" :"Tarija"   },
                  {"code":"BR-AC", "value" :"Acre"   },
                  {"code":"BR-AL", "value" :"Alagoas"   },
                  {"code":"BR-AM", "value" :"Amazonas"   },
                  {"code":"BR-AP", "value" :"Amapá"   },
                  {"code":"BR-BA", "value" :"Bahia"   },
                  {"code":"BR-CE", "value" :"Ceará"   },
                  {"code":"BR-DF", "value" :"Distrito Federal"   },
                  {"code":"BR-ES", "value" :"Espírito Santo"   },
                  {"code":"BR-GO", "value" :"Goiás"   },
                  {"code":"BR-MA", "value" :"Maranhão"   },
                  {"code":"BR-MG", "value" :"Minas Gerais"   },
                  {"code":"BR-MS", "value" :"Mato Grosso do Sul"   },
                  {"code":"BR-MT", "value" :"Mato Grosso"   },
                  {"code":"BR-PA", "value" :"Pará"   },
                  {"code":"BR-PB", "value" :"Paraíba"   },
                  {"code":"BR-PE", "value" :"Pernambuco"   },
                  {"code":"BR-PI", "value" :"Piauí"   },
                  {"code":"BR-PR", "value" :"Paraná"   },
                  {"code":"BR-RJ", "value" :"Rio de Janeiro"   },
                  {"code":"BR-RN", "value" :"Rio Grande do Norte"   },
                  {"code":"BR-RO", "value" :"Rondônia"   },
                  {"code":"BR-RR", "value" :"Roraima"   },
                  {"code":"BR-RS", "value" :"Rio Grande do Sul"   },
                  {"code":"BR-SC", "value" :"Santa Catarina"   },
                  {"code":"BR-SE", "value" :"Sergipe"   },
                  {"code":"BR-SP", "value" :"São Paulo"   },
                  {"code":"BR-TO", "value" :"Tocantins"   },
                  {"code":"BS-AC", "value" :"Acklins and Crooked Islands"   },
                  {"code":"BS-BI", "value" :"Bimini"   },
                  {"code":"BS-CI", "value" :"Cat Island"   },
                  {"code":"BS-EX", "value" :"Exuma"   },
                  {"code":"BS-FC", "value" :"Fresh Creek"   },
                  {"code":"BS-FP", "value" :"Freeport"   },
                  {"code":"BS-GH", "value" :"Governor ' s Harbour"   },
                  {"code":"BS-GT", "value" :"Green Turtle Cay"   },
                  {"code":"BS-HI", "value" :"Harbour Island"   },
                  {"code":"BS-HR", "value" :"High Rock"   },
                  {"code":"BS-IN", "value" :"Inagua"   },
                  {"code":"BS-KB", "value" :"Kemps Bay"   },
                  {"code":"BS-LI", "value" :"Long Island"   },
                  {"code":"BS-MG", "value" :"Mayaguana"   },
                  {"code":"BS-MH", "value" :"Marsh Harbour"   },
                  {"code":"BS-NB", "value" :"Nicholls Town and Berry Islands"   },
                  {"code":"BS-NP", "value" :"New Providence"   },
                  {"code":"BS-RI", "value" :"Ragged Island"   },
                  {"code":"BS-RS", "value" :"Rock Sound"   },
                  {"code":"BS-SP", "value" :"Sandy Point"   },
                  {"code":"BS-SR", "value" :"San Salvador and Rum Cay"   },
                  {"code":"BT-11", "value" :"Paro"   },
                  {"code":"BT-12", "value" :"Chhukha"   },
                  {"code":"BT-13", "value" :"Ha"   },
                  {"code":"BT-14", "value" :"Samtse"   },
                  {"code":"BT-15", "value" :"Thimphu"   },
                  {"code":"BT-21", "value" :"Tsirang"   },
                  {"code":"BT-22", "value" :"Dagana"   },
                  {"code":"BT-23", "value" :"Punakha"   },
                  {"code":"BT-24", "value" :"Wangdue Phodrang"   },
                  {"code":"BT-31", "value" :"Sarpang"   },
                  {"code":"BT-32", "value" :"Trongsa"   },
                  {"code":"BT-33", "value" :"Bumthang"   },
                  {"code":"BT-34", "value" :"Zhemgang"   },
                  {"code":"BT-41", "value" :"Trashigang"   },
                  {"code":"BT-42", "value" :"Mongar"   },
                  {"code":"BT-43", "value" :"Pemagatshel"   },
                  {"code":"BT-44", "value" :"Lhuntse"   },
                  {"code":"BT-45", "value" :"Samdrup Jongkhar"   },
                  {"code":"BT-GA", "value" :"Gasa"   },
                  {"code":"BT-TY", "value" :"Trashiyangtse"   },
                  {"code":"BW-CE", "value" :"Central"   },
                  {"code":"BW-GH", "value" :"Ghanzi"   },
                  {"code":"BW-KG", "value" :"Kgalagadi"   },
                  {"code":"BW-KL", "value" :"Kgatleng"   },
                  {"code":"BW-KW", "value" :"Kweneng"   },
                  {"code":"BW-NE", "value" :"North-East"   },
                  {"code":"BW-NW", "value" :"North-West"   },
                  {"code":"BW-SE", "value" :"South-East"   },
                  {"code":"BW-SO", "value" :"Southern"   },
                  {"code":"BY-BR", "value" :"Brest voblast"   },
                  {"code":"BY-HO", "value" :"Homiel voblast"   },
                  {"code":"BY-HR", "value" :"Hrodna voblast"   },
                  {"code":"BY-MA", "value" :"Mahilyow voblast"   },
                  {"code":"BY-MI", "value" :"Minsk voblast"   },
                  {"code":"BY-VI", "value" :"Vitsebsk voblast"   },
                  {"code":"BZ-BZ", "value" :"Belize"   },
                  {"code":"BZ-CY", "value" :"Cayo"   },
                  {"code":"BZ-CZL", "value" :"Corozal"   },
                  {"code":"BZ-OW", "value" :"Orange Walk"   },
                  {"code":"BZ-SC", "value" :"Stann Creek"   },
                  {"code":"BZ-TOL", "value" :"Toledo"   },
                  {"code":"CA-AB", "value" :"Alberta"   },
                  {"code":"CA-BC", "value" :"British Columbia / Colombie Britanique"   },
                  {"code":"CA-MB", "value" :"Manitoba"   },
                  {"code":"CA-NB", "value" :"New Brunswick / Nouveau-Brunswick"   },
                  {"code":"CA-NL", "value" :"Newfoundland & Labrador / Terre-Neuve-et-Labrador"   },
                  {"code":"CA-NS", "value" :"Nova Scotia / Nouvelle-Écosse"   },
                  {"code":"CA-NT", "value" :"Northwest Territories"   },
                  {"code":"CA-NU", "value" :"Nunavut"   },
                  {"code":"CA-ON", "value" :"Ontario"   },
                  {"code":"CA-PE", "value" :"Prince Edward Island / Île-du-Prince-Édouard"   },
                  {"code":"CA-QC", "value" :"Quebec / Québec"   },
                  {"code":"CA-SK", "value" :"Saskatchewan"   },
                  {"code":"CA-YT", "value" :"Yukon"   },
                  {"code":"CD-BC", "value" :"Bas-Congo"   },
                  {"code":"CD-BN", "value" :"Bandundu"   },
                  {"code":"CD-EQ", "value" :"Équateur"   },
                  {"code":"CD-KA", "value" :"Katanga"   },
                  {"code":"CD-KE", "value" :"Kasai-Oriental"   },
                  {"code":"CD-KN", "value" :"Kinshasa"   },
                  {"code":"CD-KW", "value" :"Kasai-Occidental"   },
                  {"code":"CD-MA", "value" :"Maniema"   },
                  {"code":"CD-NK", "value" :"Nord-Kivu"   },
                  {"code":"CD-OR", "value" :"Orientale"   },
                  {"code":"CD-SK", "value" :"Sud-Kivu"   },
                  {"code":"CF-AC", "value" :"Ouham"   },
                  {"code":"CF-BB", "value" :"Bamingui-Bangoran"   },
                  {"code":"CF-BGF", "value" :"Bangui"   },
                  {"code":"CF-BK", "value" :"Basse-Kotto"   },
                  {"code":"CF-HK", "value" :"Haute-Kotto"   },
                  {"code":"CF-HM", "value" :"Haut-Mbomou"   },
                  {"code":"CF-HS", "value" :"Mambéré-Kadéï"   },
                  {"code":"CF-KB", "value" :"Nana-Grébizi"   },
                  {"code":"CF-KG", "value" :"Kémo"   },
                  {"code":"CF-LB", "value" :"Lobaye"   },
                  {"code":"CF-MB", "value" :"Mbomou"   },
                  {"code":"CF-MP", "value" :"Ombella-Mpoko"   },
                  {"code":"CF-NM", "value" :"Nana-Mambéré"   },
                  {"code":"CF-OP", "value" :"Ouham-Pendé"   },
                  {"code":"CF-SE", "value" :"Sangha-Mbaéré"   },
                  {"code":"CF-UK", "value" :"Ouaka"   },
                  {"code":"CF-VK", "value" :"Vakaga"   },
                  {"code":"CG-11", "value" :"Bouenza"   },
                  {"code":"CG-12", "value" :"Pool"   },
                  {"code":"CG-13", "value" :"Sangha"   },
                  {"code":"CG-14", "value" :"Plateaux"   },
                  {"code":"CG-15", "value" :"Cuvette-Ouest"   },
                  {"code":"CG-2", "value" :"Lékoumou"   },
                  {"code":"CG-5", "value" :"Kouilou"   },
                  {"code":"CG-7", "value" :"Likouala"   },
                  {"code":"CG-8", "value" :"Cuvette"   },
                  {"code":"CG-9", "value" :"Niari"   },
                  {"code":"CG-BZV", "value" :"Brazzaville"   },
                  {"code":"CH-AG", "value" :"Aargau"   },
                  {"code":"CH-AI", "value" :"Appenzell Innerrhoden"   },
                  {"code":"CH-AR", "value" :"Appenzell Ausserrhoden"   },
                  {"code":"CH-BE", "value" :"Bern"   },
                  {"code":"CH-BL", "value" :"Basel-Landschaft"   },
                  {"code":"CH-BS", "value" :"Basel-Stadt"   },
                  {"code":"CH-FR", "value" :"Freiburg"   },
                  {"code":"CH-GE", "value" :"Genf"   },
                  {"code":"CH-GL", "value" :"Glarus"   },
                  {"code":"CH-GR", "value" :"Graubünden"   },
                  {"code":"CH-JU", "value" :"Jura"   },
                  {"code":"CH-LU", "value" :"Luzern"   },
                  {"code":"CH-NE", "value" :"Neuenburg"   },
                  {"code":"CH-NW", "value" :"Nidwalden"   },
                  {"code":"CH-OW", "value" :"Obwalden"   },
                  {"code":"CH-SG", "value" :"Sankt Gallen"   },
                  {"code":"CH-SH", "value" :"Schaffhausen"   },
                  {"code":"CH-SO", "value" :"Solothurn"   },
                  {"code":"CH-SZ", "value" :"Schwyz"   },
                  {"code":"CH-TG", "value" :"Thurgau"   },
                  {"code":"CH-TI", "value" :"Ticino"   },
                  {"code":"CH-UR", "value" :"Uri"   },
                  {"code":"CH-VD", "value" :"Waadt"   },
                  {"code":"CH-VS", "value" :"Wallis"   },
                  {"code":"CH-ZG", "value" :"Zug"   },
                  {"code":"CH-ZH", "value" :"Zürich"   },
                  {"code":"CI-01", "value" :"Lagunes"   },
                  {"code":"CI-02", "value" :"Haut-Sassandra"   },
                  {"code":"CI-03", "value" :"Savanes"   },
                  {"code":"CI-04", "value" :"Vallée du Bandama"   },
                  {"code":"CI-05", "value" :"Moyen-Comoé"   },
                  {"code":"CI-06", "value" :"Dix-huit Montagnes"   },
                  {"code":"CI-07", "value" :"Lacs"   },
                  {"code":"CI-08", "value" :"Zanzan"   },
                  {"code":"CI-09", "value" :"Bas-Sassandra"   },
                  {"code":"CI-10", "value" :"Denguélé"   },
                  {"code":"CI-11", "value" :"N ' zi-Comoé"   },
                  {"code":"CI-12", "value" :"Marahoué"   },
                  {"code":"CI-13", "value" :"Sud-Comoé"   },
                  {"code":"CI-14", "value" :"Worodougou"   },
                  {"code":"CI-15", "value" :"Sud-Bandama"   },
                  {"code":"CI-16", "value" :"Agnéby"   },
                  {"code":"CI-17", "value" :"Bafing"   },
                  {"code":"CI-18", "value" :"Fromager"   },
                  {"code":"CI-19", "value" :"Moyen-Cavally"   },
                  {"code":"CL-AI", "value" :"Aysen del General Carlos Ibáñez del Campo"   },
                  {"code":"CL-AN", "value" :"Antofagasta"   },
                  {"code":"CL-AP", "value" :"Arica y Parinacota"   },
                  {"code":"CL-AR", "value" :"La Araucanía"   },
                  {"code":"CL-AT", "value" :"Atacama"   },
                  {"code":"CL-BI", "value" :"Bío-Bío"   },
                  {"code":"CL-CO", "value" :"Coquimbo"   },
                  {"code":"CL-LI", "value" :"Libertador General Bernardo O'Higgins"   },
                  {"code":"CL-LL", "value" :"Los Lagos"   },
                  {"code":"CL-LR", "value" :"Los Ríos"   },
                  {"code":"CL-MA", "value" :"Magallanes y de La Antártica Chilena"   },
                  {"code":"CL-ML", "value" :"Maule"   },
                  {"code":"CL-RM", "value" :"Región Metropolitana de Santiago"   },
                  {"code":"CL-TA", "value" :"Tarapacá"   },
                  {"code":"CL-VS", "value" :"Valparaíso"   },
                  {"code":"CM-AD", "value" :"Adamaoua"   },
                  {"code":"CM-CE", "value" :"Centre"   },
                  {"code":"CM-EN", "value" :"Extrême-Nord"   },
                  {"code":"CM-ES", "value" :"Est"   },
                  {"code":"CM-LT", "value" :"Littoral"   },
                  {"code":"CM-NO", "value" :"Nord"   },
                  {"code":"CM-NW", "value" :"Nord-Ouest"   },
                  {"code":"CM-OU", "value" :"Ouest"   },
                  {"code":"CM-SU", "value" :"Sud"   },
                  {"code":"CM-SW", "value" :"Sud-Ouest"   },
                  {"code":"CN-11", "value" :"Beijing"   },
                  {"code":"CN-12", "value" :"Tianjin"   },
                  {"code":"CN-13", "value" :"Hebei"   },
                  {"code":"CN-14", "value" :"Shanxi"   },
                  {"code":"CN-15", "value" :"Inner Mongolia"   },
                  {"code":"CN-21", "value" :"Liaoning"   },
                  {"code":"CN-22", "value" :"Jilin"   },
                  {"code":"CN-23", "value" :"Heilongjiang"   },
                  {"code":"CN-31", "value" :"Shanghai"   },
                  {"code":"CN-32", "value" :"Jiangsu"   },
                  {"code":"CN-33", "value" :"Zhejiang"   },
                  {"code":"CN-34", "value" :"Anhui"   },
                  {"code":"CN-35", "value" :"Fujian"   },
                  {"code":"CN-36", "value" :"Jiangxi"   },
                  {"code":"CN-37", "value" :"Shandong"   },
                  {"code":"CN-41", "value" :"Henan"   },
                  {"code":"CN-42", "value" :"Hubei"   },
                  {"code":"CN-43", "value" :"Hunan"   },
                  {"code":"CN-44", "value" :"Guangdong"   },
                  {"code":"CN-45", "value" :"Guangxi"   },
                  {"code":"CN-46", "value" :"Hainan"   },
                  {"code":"CN-50", "value" :"Chongqing"   },
                  {"code":"CN-51", "value" :"Sichuan"   },
                  {"code":"CN-52", "value" :"Guizhou"   },
                  {"code":"CN-53", "value" :"Yunnan"   },
                  {"code":"CN-54", "value" :"Tibet"   },
                  {"code":"CN-61", "value" :"Shaanxi"   },
                  {"code":"CN-62", "value" :"Gansu"   },
                  {"code":"CN-63", "value" :"Qinghai"   },
                  {"code":"CN-64", "value" :"Ningxia"   },
                  {"code":"CN-65", "value" :"Xinjiang"   },
                  {"code":"CN-91", "value" :"Hong Kong"   },
                  {"code":"CN-92", "value" :"Macau"   },
                  {"code":"CO-AMA", "value" :"Amazonas"   },
                  {"code":"CO-ANT", "value" :"Antioquia"   },
                  {"code":"CO-ARA", "value" :"Arauca"   },
                  {"code":"CO-ATL", "value" :"Atlántico"   },
                  {"code":"CO-BOL", "value" :"Bolívar"   },
                  {"code":"CO-BOY", "value" :"Boyacá"   },
                  {"code":"CO-CAL", "value" :"Caldas"   },
                  {"code":"CO-CAQ", "value" :"Caquetá"   },
                  {"code":"CO-CAS", "value" :"Casanare"   },
                  {"code":"CO-CAU", "value" :"Cauca"   },
                  {"code":"CO-CES", "value" :"Cesar"   },
                  {"code":"CO-CHO", "value" :"Chocó"   },
                  {"code":"CO-COR", "value" :"Córdoba"   },
                  {"code":"CO-CUN", "value" :"Cundinamarca"   },
                  {"code":"CO-DC", "value" :"Bogotá D.C."   },
                  {"code":"CO-GUA", "value" :"Guainía"   },
                  {"code":"CO-GUV", "value" :"Guaviare"   },
                  {"code":"CO-HUI", "value" :"Huila"   },
                  {"code":"CO-LAG", "value" :"La Guajira"   },
                  {"code":"CO-MAG", "value" :"Magdalena"   },
                  {"code":"CO-MET", "value" :"Meta"   },
                  {"code":"CO-NAR", "value" :"Nariño"   },
                  {"code":"CO-NSA", "value" :"Norte de Santander"   },
                  {"code":"CO-PUT", "value" :"Putumayo"   },
                  {"code":"CO-QUI", "value" :"Quindío"   },
                  {"code":"CO-RIS", "value" :"Risaralda"   },
                  {"code":"CO-SAN", "value" :"Santander"   },
                  {"code":"CO-SAP", "value" :"Archipiélago de San Andrés"   },
                  {"code":"CO-SUC", "value" :"Sucre"   },
                  {"code":"CO-TOL", "value" :"Tolima"   },
                  {"code":"CO-VAC", "value" :"Valle del Cauca"   },
                  {"code":"CO-VAU", "value" :"Vaupés"   },
                  {"code":"CO-VID", "value" :"Vichada"   },
                  {"code":"CR-A", "value" :"Alajuela"   },
                  {"code":"CR-C", "value" :"Cartago"   },
                  {"code":"CR-G", "value" :"Guanacaste"   },
                  {"code":"CR-H", "value" :"Heredia"   },
                  {"code":"CR-L", "value" :"Limón"   },
                  {"code":"CR-P", "value" :"Puntarenas"   },
                  {"code":"CR-SJ", "value" :"San José"   },
                  {"code":"CU-01", "value" :"Pinar del Río"   },
                  {"code":"CU-02", "value" :"La Habana"   },
                  {"code":"CU-03", "value" :"Ciudad de La Habana"   },
                  {"code":"CU-04", "value" :"Matanzas"   },
                  {"code":"CU-05", "value" :"Villa Clara"   },
                  {"code":"CU-06", "value" :"Cienfuegos"   },
                  {"code":"CU-07", "value" :"Sancti Spíritus"   },
                  {"code":"CU-08", "value" :"Ciego de Ávila"   },
                  {"code":"CU-09", "value" :"Camagüey"   },
                  {"code":"CU-10", "value" :"Las Tunas"   },
                  {"code":"CU-11", "value" :"Holguín"   },
                  {"code":"CU-12", "value" :"Granma"   },
                  {"code":"CU-13", "value" :"Santiago de Cuba"   },
                  {"code":"CU-14", "value" :"Guantánamo"   },
                  {"code":"CU-99", "value" :"Isla de la Juventud"   },
                  {"code":"CV-BR", "value" :"Brava"   },
                  {"code":"CV-BV", "value" :"Boa Vista"   },
                  {"code":"CV-CA", "value" :"Santa Catarina"   },
                  {"code":"CV-CF", "value" :"Santa Catarina do Fogo"   },
                  {"code":"CV-CM", "value" :"São Miguel"   },
                  {"code":"CV-CR", "value" :"Santa Cruz"   },
                  {"code":"CV-MA", "value" :"Maio"   },
                  {"code":"CV-MO", "value" :"Mosteiros"   },
                  {"code":"CV-PA", "value" :"Paúl"   },
                  {"code":"CV-PN", "value" :"Porto Novo"   },
                  {"code":"CV-PR", "value" :"Praia"   },
                  {"code":"CV-RB", "value" :"Ribeira Brava"   },
                  {"code":"CV-RG", "value" :"Ribeira Grande"   },
                  {"code":"CV-RS", "value" :"Ribeira Grande de Santiago"   },
                  {"code":"CV-SD", "value" :"São Domingos"   },
                  {"code":"CV-SF", "value" :"São Filipe"   },
                  {"code":"CV-SL", "value" :"Sal"   },
                  {"code":"CV-SO", "value" :"São Lourenço dos Órgãos"   },
                  {"code":"CV-SS", "value" :"São Salvador do Mundo"   },
                  {"code":"CV-SV", "value" :"São Vicente"   },
                  {"code":"CV-TA", "value" :"Tarrafal"   },
                  {"code":"CV-TS", "value" :"Tarrafal de São Nicolau"   },
                  {"code":"CY-01", "value" :"Lefkosia"   },
                  {"code":"CY-02", "value" :"Lemesos"   },
                  {"code":"CY-03", "value" :"Larnaka"   },
                  {"code":"CY-04", "value" :"Ammochostos"   },
                  {"code":"CY-05", "value" :"Pafos"   },
                  {"code":"CY-06", "value" :"Keryneia"   },
                  {"code":"CZ-JC", "value" :"Jihočeský Kraj"   },
                  {"code":"CZ-JM", "value" :"Jihomoravský Kraj"   },
                  {"code":"CZ-KA", "value" :"Karlovarský Kraj"   },
                  {"code":"CZ-KR", "value" :"Královéhradecký Kraj"   },
                  {"code":"CZ-LI", "value" :"Liberecký Kraj"   },
                  {"code":"CZ-MO", "value" :"Moravskoslezský Kraj"   },
                  {"code":"CZ-OL", "value" :"Olomoucký Kraj"   },
                  {"code":"CZ-PA", "value" :"Pardubický Kraj"   },
                  {"code":"CZ-PL", "value" :"Plzeňský Kraj"   },
                  {"code":"CZ-PR", "value" :"Hlavní město Praha"   },
                  {"code":"CZ-ST", "value" :"Středočeský Kraj"   },
                  {"code":"CZ-US", "value" :"Ústecký Kraj"   },
                  {"code":"CZ-VY", "value" :"Vysočina"   },
                  {"code":"CZ-ZL", "value" :"Zlínský Kraj"   },
                  {"code":"DE-BB", "value" :"Brandenburg"   },
                  {"code":"DE-BE", "value" :"Berlin"   },
                  {"code":"DE-BW", "value" :"Baden-Württemberg"   },
                  {"code":"DE-BY", "value" :"Bayern"   },
                  {"code":"DE-HB", "value" :"Bremen"   },
                  {"code":"DE-HE", "value" :"Hessen"   },
                  {"code":"DE-HH", "value" :"Hamburg"   },
                  {"code":"DE-MV", "value" :"Mecklenburg-Vorpommern"   },
                  {"code":"DE-NI", "value" :"Niedersachsen"   },
                  {"code":"DE-NW", "value" :"Nordrhein-Westfalen"   },
                  {"code":"DE-RP", "value" :"Rheinland-Pfalz"   },
                  {"code":"DE-SH", "value" :"Schleswig-Holstein"   },
                  {"code":"DE-SL", "value" :"Saarland"   },
                  {"code":"DE-SN", "value" :"Sachsen"   },
                  {"code":"DE-ST", "value" :"Sachsen-Anhalt"   },
                  {"code":"DE-TH", "value" :"Thüringen"   },
                  {"code":"DJ-AR", "value" :"Arta"   },
                  {"code":"DJ-AS", "value" :"Ali Sabieh"   },
                  {"code":"DJ-DI", "value" :"Dikhil"   },
                  {"code":"DJ-DJ", "value" :"Djibouti"   },
                  {"code":"DJ-OB", "value" :"Obock"   },
                  {"code":"DJ-TA", "value" :"Tadjourah"   },
                  {"code":"DK-81", "value" :"Nordjylland"   },
                  {"code":"DK-82", "value" :"Midtjylland"   },
                  {"code":"DK-83", "value" :"Syddanmark"   },
                  {"code":"DK-84", "value" :"Hovedstaden"   },
                  {"code":"DK-85", "value" :"Sjælland"   },
                  {"code":"DM-02", "value" :"Saint Andrew"   },
                  {"code":"DM-03", "value" :"Saint David"   },
                  {"code":"DM-04", "value" :"Saint George"   },
                  {"code":"DM-05", "value" :"Saint John"   },
                  {"code":"DM-06", "value" :"Saint Joseph"   },
                  {"code":"DM-07", "value" :"Saint Luke"   },
                  {"code":"DM-08", "value" :"Saint Mark"   },
                  {"code":"DM-09", "value" :"Saint Patrick"   },
                  {"code":"DM-10", "value" :"Saint Paul"   },
                  {"code":"DM-11", "value" :"Saint Peter"   },
                  {"code":"DO-01", "value" :"Distrito Nacional (Santo Domingo)"   },
                  {"code":"DO-02", "value" :"Azua"   },
                  {"code":"DO-03", "value" :"Bahoruco"   },
                  {"code":"DO-04", "value" :"Barahona"   },
                  {"code":"DO-05", "value" :"Dajabón"   },
                  {"code":"DO-06", "value" :"Duarte"   },
                  {"code":"DO-07", "value" :"Elías Piña"   },
                  {"code":"DO-08", "value" :"El Seibo"   },
                  {"code":"DO-09", "value" :"Espaillat"   },
                  {"code":"DO-10", "value" :"Independencia"   },
                  {"code":"DO-11", "value" :"La Altagracia"   },
                  {"code":"DO-12", "value" :"La Romana"   },
                  {"code":"DO-13", "value" :"La Vega"   },
                  {"code":"DO-14", "value" :"María Trinidad Sánchez"   },
                  {"code":"DO-15", "value" :"Monte Cristi"   },
                  {"code":"DO-16", "value" :"Pedernales"   },
                  {"code":"DO-17", "value" :"Peravia"   },
                  {"code":"DO-18", "value" :"Puerto Plata"   },
                  {"code":"DO-19", "value" :"Hermanas Mirabal"   },
                  {"code":"DO-20", "value" :"Samaná"   },
                  {"code":"DO-21", "value" :"San Cristóbal"   },
                  {"code":"DO-22", "value" :"San Juan"   },
                  {"code":"DO-23", "value" :"San Pedro de Macorís"   },
                  {"code":"DO-24", "value" :"Sánchez Ramírez"   },
                  {"code":"DO-25", "value" :"Santiago"   },
                  {"code":"DO-26", "value" :"Santiago Rodríguez"   },
                  {"code":"DO-27", "value" :"Valverde"   },
                  {"code":"DO-28", "value" :"Monseñor Nouel"   },
                  {"code":"DO-29", "value" :"Monte Plata"   },
                  {"code":"DO-30", "value" :"Hato Mayor"   },
                  {"code":"DO-31", "value" :"San José de Ocoa"   },
                  {"code":"DO-32", "value" :"Santo Domingo"   },
                  {"code":"DZ-01", "value" :"Adrar"   },
                  {"code":"DZ-02", "value" :"Chlef"   },
                  {"code":"DZ-03", "value" :"Laghouat"   },
                  {"code":"DZ-04", "value" :"Oum-El-Bouaghi"   },
                  {"code":"DZ-05", "value" :"Batna"   },
                  {"code":"DZ-06", "value" :"Béjaïa"   },
                  {"code":"DZ-07", "value" :"Biskra"   },
                  {"code":"DZ-08", "value" :"Béchar"   },
                  {"code":"DZ-09", "value" :"Blida"   },
                  {"code":"DZ-10", "value" :"Bouira"   },
                  {"code":"DZ-11", "value" :"Tamanrasset"   },
                  {"code":"DZ-12", "value" :"Tébessa"   },
                  {"code":"DZ-13", "value" :"Tlemcen"   },
                  {"code":"DZ-14", "value" :"Tiaret"   },
                  {"code":"DZ-15", "value" :"Tizi-Ouzou"   },
                  {"code":"DZ-16", "value" :"Alger"   },
                  {"code":"DZ-17", "value" :"Djelfa"   },
                  {"code":"DZ-18", "value" :"Jijel"   },
                  {"code":"DZ-19", "value" :"Sétif"   },
                  {"code":"DZ-20", "value" :"Saida"   },
                  {"code":"DZ-21", "value" :"Skikda"   },
                  {"code":"DZ-22", "value" :"Sidi-Bel-Abbès"   },
                  {"code":"DZ-23", "value" :"Annaba"   },
                  {"code":"DZ-24", "value" :"Guelma"   },
                  {"code":"DZ-25", "value" :"Constantine"   },
                  {"code":"DZ-26", "value" :"Médéa"   },
                  {"code":"DZ-27", "value" :"Mostaganem"   },
                  {"code":"DZ-28", "value" :"M'Sila"   },
                  {"code":"DZ-29", "value" :"Mascara"   },
                  {"code":"DZ-30", "value" :"Ouargla"   },
                  {"code":"DZ-31", "value" :"Oran"   },
                  {"code":"DZ-32", "value" :"El-Bayadh"   },
                  {"code":"DZ-33", "value" :"Illizi"   },
                  {"code":"DZ-34", "value" :"Bordj-Bou-Arreridj"   },
                  {"code":"DZ-35", "value" :"Boumerdès"   },
                  {"code":"DZ-36", "value" :"El-Taref"   },
                  {"code":"DZ-37", "value" :"Tindouf"   },
                  {"code":"DZ-38", "value" :"Tissemsilt"   },
                  {"code":"DZ-39", "value" :"El-Oued"   },
                  {"code":"DZ-40", "value" :"Khenchela"   },
                  {"code":"DZ-41", "value" :"Souk-Ahras"   },
                  {"code":"DZ-42", "value" :"Tipaza"   },
                  {"code":"DZ-43", "value" :"Mila"   },
                  {"code":"DZ-44", "value" :"Aïn-Defla"   },
                  {"code":"DZ-45", "value" :"Naâma"   },
                  {"code":"DZ-46", "value" :"Aïn-Témouchent"   },
                  {"code":"DZ-47", "value" :"Ghardaia"   },
                  {"code":"DZ-48", "value" :"Relizane"   },
                  {"code":"EC-A", "value" :"Azuay"   },
                  {"code":"EC-B", "value" :"Bolívar"   },
                  {"code":"EC-C", "value" :"Carchi"   },
                  {"code":"EC-D", "value" :"Orellana"   },
                  {"code":"EC-E", "value" :"Esmeraldas"   },
                  {"code":"EC-F", "value" :"Cañar"   },
                  {"code":"EC-G", "value" :"Guayas"   },
                  {"code":"EC-H", "value" :"Chimborazo"   },
                  {"code":"EC-I", "value" :"Imbabura"   },
                  {"code":"EC-L", "value" :"Loja"   },
                  {"code":"EC-M", "value" :"Manabí"   },
                  {"code":"EC-N", "value" :"Napo"   },
                  {"code":"EC-O", "value" :"El Oro"   },
                  {"code":"EC-P", "value" :"Pichincha"   },
                  {"code":"EC-R", "value" :"Los Ríos"   },
                  {"code":"EC-S", "value" :"Morona-Santiago"   },
                  {"code":"EC-SD", "value" :"Santo Domingo de los Tsáchilas"   },
                  {"code":"EC-SE", "value" :"Santa Elena"   },
                  {"code":"EC-T", "value" :"Tungurahua"   },
                  {"code":"EC-U", "value" :"Sucumbíos"   },
                  {"code":"EC-W", "value" :"Galápagos"   },
                  {"code":"EC-X", "value" :"Cotopaxi"   },
                  {"code":"EC-Y", "value" :"Pastaza"   },
                  {"code":"EC-Z", "value" :"Zamora-Chinchipe"   },
                  {"code":"EE-37", "value" :"Harjumaa"   },
                  {"code":"EE-39", "value" :"Hiiumaa"   },
                  {"code":"EE-44", "value" :"Ida-Virumaa"   },
                  {"code":"EE-49", "value" :"Jõgevamaa"   },
                  {"code":"EE-51", "value" :"Järvamaa"   },
                  {"code":"EE-57", "value" :"Läänemaa"   },
                  {"code":"EE-59", "value" :"Lääne-Virumaa"   },
                  {"code":"EE-65", "value" :"Põlvamaa"   },
                  {"code":"EE-67", "value" :"Pärnumaa"   },
                  {"code":"EE-70", "value" :"Raplamaa"   },
                  {"code":"EE-74", "value" :"Saaremaa"   },
                  {"code":"EE-78", "value" :"Tartumaa"   },
                  {"code":"EE-82", "value" :"Valgamaa"   },
                  {"code":"EE-84", "value" :"Viljandimaa"   },
                  {"code":"EE-86", "value" :"Võrumaa"   },
                  {"code":"EG-ALX", "value" :"Alexandria"   },
                  {"code":"EG-ASN", "value" :"Aswan"   },
                  {"code":"EG-AST", "value" :"Asyut"   },
                  {"code":"EG-BA", "value" :"Red Sea"   },
                  {"code":"EG-BH", "value" :"Beheira"   },
                  {"code":"EG-BNS", "value" :"Beni Suef"   },
                  {"code":"EG-C", "value" :"Cairo"   },
                  {"code":"EG-DK", "value" :"Dakahlia"   },
                  {"code":"EG-DT", "value" :"Damietta"   },
                  {"code":"EG-FYM", "value" :"Faiyum"   },
                  {"code":"EG-GH", "value" :"Gharbia"   },
                  {"code":"EG-GZ", "value" :"Giza"   },
                  {"code":"EG-HU", "value" :"Hulwan"   },
                  {"code":"EG-IS", "value" :"Ismailia"   },
                  {"code":"EG-JS", "value" :"South Sinai"   },
                  {"code":"EG-KB", "value" :"Qalyubia"   },
                  {"code":"EG-KFS", "value" :"Kafr el-Sheikh"   },
                  {"code":"EG-KN", "value" :"Qena"   },
                  {"code":"EG-LX", "value" :"Luxor"   },
                  {"code":"EG-MN", "value" :"Minya"   },
                  {"code":"EG-MNF", "value" :"Monufia"   },
                  {"code":"EG-MT", "value" :"Matruh"   },
                  {"code":"EG-PTS", "value" :"Port Said"   },
                  {"code":"EG-SHG", "value" :"Sohag"   },
                  {"code":"EG-SHR", "value" :"Sharqia"   },
                  {"code":"EG-SIN", "value" :"North Sinai"   },
                  {"code":"EG-SU", "value" :"As Sadis min Uktubar"   },
                  {"code":"EG-SUZ", "value" :"Suez"   },
                  {"code":"EG-WAD", "value" :"New Valley"   },
                  {"code":"EH-BOD", "value" :"Boujdour"  },
                  {"code":"EH-ESM", "value" :"Es Semara"  },
                  {"code":"EH-LAA", "value" :"Laayoune"  },
                  {"code":"EH-OUD", "value" :"Oued el Dahab"  },
                  {"code":"ER-AN", "value" :"Anseba"  },
                  {"code":"ER-DK", "value" :"Southern Red Sea"  },
                  {"code":"ER-DU", "value" :"Southern"  },
                  {"code":"ER-GB", "value" :"Gash-Barka"  },
                  {"code":"ER-MA", "value" :"Central"  },
                  {"code":"ER-SK", "value" :"Northern Red Sea"  },
                  {"code":"ES-A", "value" :"Alicante"  },
                  {"code":"ES-AB", "value" :"Albacete"  },
                  {"code":"ES-AL", "value" :"Almería"  },
                  {"code":"ES-AV", "value" :"Ávila"  },
                  {"code":"ES-B", "value" :"Barcelona"  },
                  {"code":"ES-BA", "value" :"Badajoz"  },
                  {"code":"ES-BI", "value" :"Vizcaya"  },
                  {"code":"ES-BU", "value" :"Burgos"  },
                  {"code":"ES-C", "value" :"La Coruña"  },
                  {"code":"ES-CA", "value" :"Cádiz"  },
                  {"code":"ES-CC", "value" :"Cáceres"  },
                  {"code":"ES-CE", "value" :"Ceuta"  },
                  {"code":"ES-CO", "value" :"Córdoba"  },
                  {"code":"ES-CR", "value" :"Ciudad Real"  },
                  {"code":"ES-CS", "value" :"Castellón"  },
                  {"code":"ES-CU", "value" :"Cuenca"  },
                  {"code":"ES-GC", "value" :"Las Palmas"  },
                  {"code":"ES-GI", "value" :"Girona"  },
                  {"code":"ES-GR", "value" :"Granada"  },
                  {"code":"ES-GU", "value" :"Guadalajara"  },
                  {"code":"ES-H", "value" :"Huelva"  },
                  {"code":"ES-HU", "value" :"Huesca"  },
                  {"code":"ES-J", "value" :"Jaén"  },
                  {"code":"ES-L", "value" :"Lleida"  },
                  {"code":"ES-LE", "value" :"León"  },
                  {"code":"ES-LO", "value" :"La Rioja"  },
                  {"code":"ES-LU", "value" :"Lugo"  },
                  {"code":"ES-M", "value" :"Madrid"  },
                  {"code":"ES-MA", "value" :"Málaga"  },
                  {"code":"ES-ML", "value" :"Melilla"  },
                  {"code":"ES-MU", "value" :"Murcia"  },
                  {"code":"ES-NA", "value" :"Navarra"  },
                  {"code":"ES-O", "value" :"Asturias"  },
                  {"code":"ES-OR", "value" :"Ourense"  },
                  {"code":"ES-P", "value" :"Palencia"  },
                  {"code":"ES-PM", "value" :"Islas Baleares"  },
                  {"code":"ES-PO", "value" :"Pontevedra"  },
                  {"code":"ES-S", "value" :"Cantabria"  },
                  {"code":"ES-SA", "value" :"Salamanca"  },
                  {"code":"ES-SE", "value" :"Sevilla"  },
                  {"code":"ES-SG", "value" :"Segovia"  },
                  {"code":"ES-SO", "value" :"Soria"  },
                  {"code":"ES-SS", "value" :"Guipúzcoa"  },
                  {"code":"ES-T", "value" :"Tarragona"  },
                  {"code":"ES-TE", "value" :"Teruel"  },
                  {"code":"ES-TF", "value" :"Santa Cruz de Tenerife"  },
                  {"code":"ES-TO", "value" :"Toledo"  },
                  {"code":"ES-V", "value" :"Valencia"  },
                  {"code":"ES-VA", "value" :"Valladolid"  },
                  {"code":"ES-VI", "value" :"Álava"  },
                  {"code":"ES-Z", "value" :"Zaragoza"  },
                  {"code":"ES-ZA", "value" :"Zamora"  },
                  {"code":"ET-AA", "value" :"Addis Ababa"  },
                  {"code":"ET-AF", "value" :"Afar"  },
                  {"code":"ET-AM", "value" :"Amhara"  },
                  {"code":"ET-BE", "value" :"Benishangul-Gumuz"  },
                  {"code":"ET-DD", "value" :"Dire Dawa"  },
                  {"code":"ET-GA", "value" :"Gambela"  },
                  {"code":"ET-HA", "value" :"Harari"  },
                  {"code":"ET-OR", "value" :"Oromia"  },
                  {"code":"ET-SN", "value" :"Southern Nations"  },
                  {"code":"ET-SO", "value" :"Somali"  },
                  {"code":"ET-TI", "value" :"Tigray"  },
                  {"code":"FI-AL", "value" :"Ahvenanmaan lääni"  },
                  {"code":"FI-ES", "value" :"Etelä-Suomen lääni"  },
                  {"code":"FI-IS", "value" :"Itä-Suomen lääni"  },
                  {"code":"FI-LL", "value" :"Lapin lääni"  },
                  {"code":"FI-LS", "value" :"Länsi-Suomen lääni"  },
                  {"code":"FI-OL", "value" :"Oulun lääni"  },
                  {"code":"FJ-C", "value" :"Central"  },
                  {"code":"FJ-E", "value" :"Eastern"  },
                  {"code":"FJ-N", "value" :"Northern"  },
                  {"code":"FJ-R", "value" :"Rotuma"  },
                  {"code":"FJ-W", "value" :"Western"  },
                  {"code":"FM-KSA", "value" :"Kosrae"  },
                  {"code":"FM-PNI", "value" :"Pohnpei"  },
                  {"code":"FM-TRK", "value" :"Chuuk"  },
                  {"code":"FM-YAP", "value" :"Yap"  },
                  {"code":"FR-01", "value" :"Ain"  },
                  {"code":"FR-02", "value" :"Aisne"  },
                  {"code":"FR-03", "value" :"Allier"  },
                  {"code":"FR-04", "value" :"Alpes-de-Haute-Provence"  },
                  {"code":"FR-05", "value" :"Hautes-Alpes"  },
                  {"code":"FR-06", "value" :"Alpes-Maritimes"  },
                  {"code":"FR-07", "value" :"Ardèche"  },
                  {"code":"FR-08", "value" :"Ardennes"  },
                  {"code":"FR-09", "value" :"Ariège"  },
                  {"code":"FR-10", "value" :"Aube"  },
                  {"code":"FR-11", "value" :"Aude"  },
                  {"code":"FR-12", "value" :"Aveyron"  },
                  {"code":"FR-13", "value" :"Bouches-du-Rhône"  },
                  {"code":"FR-14", "value" :"Calvados"  },
                  {"code":"FR-15", "value" :"Cantal"  },
                  {"code":"FR-16", "value" :"Charente"  },
                  {"code":"FR-17", "value" :"Charente-Maritime"  },
                  {"code":"FR-18", "value" :"Cher"  },
                  {"code":"FR-19", "value" :"Corrèze"  },
                  {"code":"FR-21", "value" :"Côte-d ' Or"  },
                  {"code":"FR-22", "value" :"Côtes-d 'Armor"  },
                  {"code":"FR-23", "value" :"Creuse"  },
                  {"code":"FR-24", "value" :"Dordogne"  },
                  {"code":"FR-25", "value" :"Doubs"  },
                  {"code":"FR-26", "value" :"Drôme"  },
                  {"code":"FR-27", "value" :"Eure"  },
                  {"code":"FR-28", "value" :"Eure-et-Loir"  },
                  {"code":"FR-29", "value" :"Finistère"  },
                  {"code":"FR-2A", "value" :"Corse-du-Sud"  },
                  {"code":"FR-2B", "value" :"Haute-Corse"  },
                  {"code":"FR-30", "value" :"Gard"  },
                  {"code":"FR-31", "value" :"Haute-Garonne"  },
                  {"code":"FR-32", "value" :"Gers"  },
                  {"code":"FR-33", "value" :"Gironde"  },
                  {"code":"FR-34", "value" :"Hérault"  },
                  {"code":"FR-35", "value" :"Ille-et-Vilaine"  },
                  {"code":"FR-36", "value" :"Indre"  },
                  {"code":"FR-37", "value" :"Indre-et-Loire"  },
                  {"code":"FR-38", "value" :"Isère"  },
                  {"code":"FR-39", "value" :"Jura"  },
                  {"code":"FR-40", "value" :"Landes"  },
                  {"code":"FR-41", "value" :"Loir-et-Cher"  },
                  {"code":"FR-42", "value" :"Loire"  },
                  {"code":"FR-43", "value" :"Haute-Loire"  },
                  {"code":"FR-44", "value" :"Loire-Atlantique"  },
                  {"code":"FR-45", "value" :"Loiret"  },
                  {"code":"FR-46", "value" :"Lot"  },
                  {"code":"FR-47", "value" :"Lot-et-Garonne"  },
                  {"code":"FR-48", "value" :"Lozère"  },
                  {"code":"FR-49", "value" :"Maine-et-Loire"  },
                  {"code":"FR-50", "value" :"Manche"  },
                  {"code":"FR-51", "value" :"Marne"  },
                  {"code":"FR-52", "value" :"Haute-Marne"  },
                  {"code":"FR-53", "value" :"Mayenne"  },
                  {"code":"FR-54", "value" :"Meurthe-et-Moselle"  },
                  {"code":"FR-55", "value" :"Meuse"  },
                  {"code":"FR-56", "value" :"Morbihan"  },
                  {"code":"FR-57", "value" :"Moselle"  },
                  {"code":"FR-58", "value" :"Nièvre"  },
                  {"code":"FR-59", "value" :"Nord"  },
                  {"code":"FR-60", "value" :"Oise"  },
                  {"code":"FR-61", "value" :"Orne"  },
                  {"code":"FR-62", "value" :"Pas-de-Calais"  },
                  {"code":"FR-63", "value" :"Puy-de-Dôme"  },
                  {"code":"FR-64", "value" :"Pyrénées-Atlantiques"  },
                  {"code":"FR-65", "value" :"Hautes-Pyrénées"  },
                  {"code":"FR-66", "value" :"Pyrénées-Orientales"  },
                  {"code":"FR-67", "value" :"Bas-Rhin"  },
                  {"code":"FR-68", "value" :"Haut-Rhin"  },
                  {"code":"FR-69", "value" :"Rhône"  },
                  {"code":"FR-70", "value" :"Haute-Saône"  },
                  {"code":"FR-71", "value" :"Saône-et-Loire"  },
                  {"code":"FR-72", "value" :"Sarthe"  },
                  {"code":"FR-73", "value" :"Savoie"  },
                  {"code":"FR-74", "value" :"Haute-Savoie"  },
                  {"code":"FR-75", "value" :"Paris"  },
                  {"code":"FR-76", "value" :"Seine-Maritime"  },
                  {"code":"FR-77", "value" :"Seine-et-Marne"  },
                  {"code":"FR-78", "value" :"Yvelines"  },
                  {"code":"FR-79", "value" :"Deux-Sèvres"  },
                  {"code":"FR-80", "value" :"Somme"  },
                  {"code":"FR-81", "value" :"Tarn"  },
                  {"code":"FR-82", "value" :"Tarn-et-Garonne"  },
                  {"code":"FR-83", "value" :"Var"  },
                  {"code":"FR-84", "value" :"Vaucluse"  },
                  {"code":"FR-85", "value" :"Vendée"  },
                  {"code":"FR-86", "value" :"Vienne"  },
                  {"code":"FR-87", "value" :"Haute-Vienne"  },
                  {"code":"FR-88", "value" :"Vosges"  },
                  {"code":"FR-89", "value" :"Yonne"  },
                  {"code":"FR-90", "value" :"Territoire de Belfort"  },
                  {"code":"FR-91", "value" :"Essonne"  },
                  {"code":"FR-92", "value" :"Hauts-de-Seine"  },
                  {"code":"FR-93", "value" :"Seine-Saint-Denis"  },
                  {"code":"FR-94", "value" :"Val-de-Marne"  },
                  {"code":"FR-95", "value" :"Val-d 'Oise"  },
                  {"code":"FR-BL", "value" :"Saint-Barthélemy"  },
                  {"code":"FR-GF", "value" :"Guyane"  },
                  {"code":"FR-GP", "value" :"Guadeloupe"  },
                  {"code":"FR-MF", "value" :"Saint-Martin"  },
                  {"code":"FR-MQ", "value" :"Martinique"  },
                  {"code":"FR-NC", "value" :"Nouvelle-Calédonie"  },
                  {"code":"FR-PF", "value" :"Polynésie Française"  },
                  {"code":"FR-PM", "value" :"Saint-Pierre et Miquelon"  },
                  {"code":"FR-RE", "value" :"La Réunion"  },
                  {"code":"FR-TF", "value" :"Terres australes et antarctiques"  },
                  {"code":"FR-WF", "value" :"Wallis et Futuna"  },
                  {"code":"FR-YT", "value" :"Mayotte"  },
                  {"code":"GA-1", "value" :"Estuaire"  },
                  {"code":"GA-2", "value" :"Haut-Ogooué"  },
                  {"code":"GA-3", "value" :"Moyen-Ogooué"  },
                  {"code":"GA-4", "value" :"Ngounié"  },
                  {"code":"GA-5", "value" :"Nyanga"  },
                  {"code":"GA-6", "value" :"Ogooué-Ivindo"  },
                  {"code":"GA-7", "value" :"Ogooué-Lolo"  },
                  {"code":"GA-8", "value" :"Ogooué-Maritime"  },
                  {"code":"GA-9", "value" :"Woleu-Ntem"  },
                  {"code":"GB-ABD", "value" :"Aberdeenshire"  },
                  {"code":"GB-ABE", "value" :"Aberdeen City"  },
                  {"code":"GB-AGB", "value" :"Argyll and Bute"  },
                  {"code":"GB-AGY", "value" :"Isle of Anglesey"  },
                  {"code":"GB-ANS", "value" :"Angus"  },
                  {"code":"GB-ANT", "value" :"Antrim"  },
                  {"code":"GB-ARD", "value" :"Ards"  },
                  {"code":"GB-ARM", "value" :"Armagh"  },
                  {"code":"GB-BAS", "value" :"Bath and North East Somerset"  },
                  {"code":"GB-BBD", "value" :"Blackburn with Darwen"  },
                  {"code":"GB-BDF", "value" :"Bedford"  },
                  {"code":"GB-BDG", "value" :"Barking and Dagenham"  },
                  {"code":"GB-BEN", "value" :"Brent"  },
                  {"code":"GB-BEX", "value" :"Bexley"  },
                  {"code":"GB-BFS", "value" :"Belfast City"  },
                  {"code":"GB-BGE", "value" :"Bridgend"  },
                  {"code":"GB-BGW", "value" :"Blaenau Gwent"  },
                  {"code":"GB-BIR", "value" :"Birmingham"  },
                  {"code":"GB-BKM", "value" :"Buckinghamshire"  },
                  {"code":"GB-BLA", "value" :"Ballymena"  },
                  {"code":"GB-BLY", "value" :"Ballymoney"  },
                  {"code":"GB-BMH", "value" :"Bournemouth"  },
                  {"code":"GB-BNB", "value" :"Banbridge"  },
                  {"code":"GB-BNE", "value" :"Barnet"  },
                  {"code":"GB-BNH", "value" :"The City of Brighton and Hove"  },
                  {"code":"GB-BNS", "value" :"Barnsley"  },
                  {"code":"GB-BOL", "value" :"Bolton"  },
                  {"code":"GB-BPL", "value" :"Blackpool"  },
                  {"code":"GB-BRC", "value" :"Bracknell Forest"  },
                  {"code":"GB-BRD", "value" :"Bradford"  },
                  {"code":"GB-BRY", "value" :"Bromley"  },
                  {"code":"GB-BST", "value" :"City of Bristol"  },
                  {"code":"GB-BUR", "value" :"Bury"  },
                  {"code":"GB-CAM", "value" :"Cambridgeshire"  },
                  {"code":"GB-CAY", "value" :"Caerphilly"  },
                  {"code":"GB-CBF", "value" :"Central Bedfordshire"  },
                  {"code":"GB-CGN", "value" :"Ceredigion"  },
                  {"code":"GB-CGV", "value" :"Craigavon"  },
                  {"code":"GB-CHE", "value" :"Cheshire East"  },
                  {"code":"GB-CHW", "value" :"Cheshire West and Chester"  },
                  {"code":"GB-CKF", "value" :"Carrickfergus"  },
                  {"code":"GB-CKT", "value" :"Cookstown"  },
                  {"code":"GB-CLD", "value" :"Calderdale"  },
                  {"code":"GB-CLK", "value" :"Clackmannanshire"  },
                  {"code":"GB-CLR", "value" :"Coleraine"  },
                  {"code":"GB-CMA", "value" :"Cumbria"  },
                  {"code":"GB-CMD", "value" :"Camden"  },
                  {"code":"GB-CMN", "value" :"Carmarthenshire "  },
                  {"code":"GB-CON", "value" :"Cornwall"  },
                  {"code":"GB-COV", "value" :"Coventry"  },
                  {"code":"GB-CRF", "value" :"Cardiff"  },
                  {"code":"GB-CRY", "value" :"Croydon"  },
                  {"code":"GB-CSR", "value" :"Castlereagh"  },
                  {"code":"GB-CWY", "value" :"Conwy"  },
                  {"code":"GB-DAL", "value" :"Darlington"  },
                  {"code":"GB-DBY", "value" :"Derbyshire"  },
                  {"code":"GB-DEN", "value" :"Denbighshire"  },
                  {"code":"GB-DER", "value" :"City of Derby"  },
                  {"code":"GB-DEV", "value" :"Devon"  },
                  {"code":"GB-DGN", "value" :"Dungannon and South Tyrone"  },
                  {"code":"GB-DGY", "value" :"Dumfries and Galloway"  },
                  {"code":"GB-DNC", "value" :"Doncaster"  },
                  {"code":"GB-DND", "value" :"Dundee City"  },
                  {"code":"GB-DOR", "value" :"Dorset"  },
                  {"code":"GB-DOW", "value" :"Down"  },
                  {"code":"GB-DRY", "value" :"Derry City"  },
                  {"code":"GB-DUD", "value" :"Dudley"  },
                  {"code":"GB-DUR", "value" :"Durham"  },
                  {"code":"GB-EAL", "value" :"Ealing"  },
                  {"code":"GB-EAY", "value" :"East Ayrshire"  },
                  {"code":"GB-EDH", "value" :"City of Edinburgh"  },
                  {"code":"GB-EDU", "value" :"East Dunbartonshire"  },
                  {"code":"GB-ELN", "value" :"East Lothian"  },
                  {"code":"GB-ELS", "value" :"Outer Hebrides"  },
                  {"code":"GB-ENF", "value" :"Enfield"  },
                  {"code":"GB-ERW", "value" :"East Renfrewshire"  },
                  {"code":"GB-ERY", "value" :"East Riding of Yorkshire"  },
                  {"code":"GB-ESS", "value" :"Essex"  },
                  {"code":"GB-ESX", "value" :"East Sussex"  },
                  {"code":"GB-FAL", "value" :"Falkirk"  },
                  {"code":"GB-FER", "value" :"Fermanagh"  },
                  {"code":"GB-FIF", "value" :"Fife"  },
                  {"code":"GB-FLN", "value" :"Flintshire"  },
                  {"code":"GB-GAT", "value" :"Gateshead"  },
                  {"code":"GB-GLG", "value" :"Glasgow City"  },
                  {"code":"GB-GLS", "value" :"Gloucestershire"  },
                  {"code":"GB-GRE", "value" :"Greenwich"  },
                  {"code":"GB-GWN", "value" :"Gwynedd"  },
                  {"code":"GB-HAL", "value" :"Halton"  },
                  {"code":"GB-HAM", "value" :"Hampshire"  },
                  {"code":"GB-HAV", "value" :"Havering"  },
                  {"code":"GB-HCK", "value" :"Hackney"  },
                  {"code":"GB-HEF", "value" :"Herefordshire"  },
                  {"code":"GB-HIL", "value" :"Hillingdon"  },
                  {"code":"GB-HLD", "value" :"Highland"  },
                  {"code":"GB-HMF", "value" :"Hammersmith and Fulham"  },
                  {"code":"GB-HNS", "value" :"Hounslow"  },
                  {"code":"GB-HPL", "value" :"Hartlepool"  },
                  {"code":"GB-HRT", "value" :"Hertfordshire"  },
                  {"code":"GB-HRW", "value" :"Harrow"  },
                  {"code":"GB-HRY", "value" :"Haringey"  },
                  {"code":"GB-IOW", "value" :"Isle of Wight"  },
                  {"code":"GB-ISL", "value" :"Islington"  },
                  {"code":"GB-IVC", "value" :"Inverclyde"  },
                  {"code":"GB-KEC", "value" :"Kensington and Chelsea"  },
                  {"code":"GB-KEN", "value" :"Kent"  },
                  {"code":"GB-KHL", "value" :"Kingston upon Hull"  },
                  {"code":"GB-KIR", "value" :"Kirklees"  },
                  {"code":"GB-KTT", "value" :"Kingston upon Thames"  },
                  {"code":"GB-KWL", "value" :"Knowsley"  },
                  {"code":"GB-LAN", "value" :"Lancashire"  },
                  {"code":"GB-LBH", "value" :"Lambeth"  },
                  {"code":"GB-LCE", "value" :"City of Leicester"  },
                  {"code":"GB-LDS", "value" :"Leeds"  },
                  {"code":"GB-LEC", "value" :"Leicestershire"  },
                  {"code":"GB-LEW", "value" :"Lewisham"  },
                  {"code":"GB-LIN", "value" :"Lincolnshire"  },
                  {"code":"GB-LIV", "value" :"Liverpool"  },
                  {"code":"GB-LMV", "value" :"Limavady"  },
                  {"code":"GB-LND", "value" :"City of London"  },
                  {"code":"GB-LRN", "value" :"Larne"  },
                  {"code":"GB-LSB", "value" :"Lisburn"  },
                  {"code":"GB-LUT", "value" :"Luton"  },
                  {"code":"GB-MAN", "value" :"City of Manchester"  },
                  {"code":"GB-MDB", "value" :"Middlesbrough"  },
                  {"code":"GB-MDW", "value" :"Medway"  },
                  {"code":"GB-MFT", "value" :"Magherafelt"  },
                  {"code":"GB-MIK", "value" :"Milton Keynes"  },
                  {"code":"GB-MLN", "value" :"Midlothian"  },
                  {"code":"GB-MON", "value" :"Monmouthshire"  },
                  {"code":"GB-MRT", "value" :"Merton"  },
                  {"code":"GB-MRY", "value" :"Moray"  },
                  {"code":"GB-MTY", "value" :"Merthyr Tydfil"  },
                  {"code":"GB-MYL", "value" :"Moyle"  },
                  {"code":"GB-NAY", "value" :"North Ayrshire"  },
                  {"code":"GB-NBL", "value" :"Northumberland"  },
                  {"code":"GB-NDN", "value" :"North Down"  },
                  {"code":"GB-NEL", "value" :"North East Lincolnshire"  },
                  {"code":"GB-NET", "value" :"Newcastle upon Tyne"  },
                  {"code":"GB-NFK", "value" :"Norfolk"  },
                  {"code":"GB-NGM", "value" :"City of Nottingham"  },
                  {"code":"GB-NLK", "value" :"North Lanarkshire"  },
                  {"code":"GB-NLN", "value" :"North Lincolnshire"  },
                  {"code":"GB-NSM", "value" :"North Somerset"  },
                  {"code":"GB-NTA", "value" :"Newtownabbey"  },
                  {"code":"GB-NTH", "value" :"Northamptonshire"  },
                  {"code":"GB-NTL", "value" :"Neath Port Talbot"  },
                  {"code":"GB-NTT", "value" :"Nottinghamshire"  },
                  {"code":"GB-NTY", "value" :"North Tyneside"  },
                  {"code":"GB-NWM", "value" :"Newham"  },
                  {"code":"GB-NWP", "value" :"Newport"  },
                  {"code":"GB-NYK", "value" :"North Yorkshire"  },
                  {"code":"GB-NYM", "value" :"Newry and Mourne"  },
                  {"code":"GB-OLD", "value" :"Oldham"  },
                  {"code":"GB-OMH", "value" :"Omagh"  },
                  {"code":"GB-ORK", "value" :"Orkney Islands"  },
                  {"code":"GB-OXF", "value" :"Oxfordshire"  },
                  {"code":"GB-PEM", "value" :"Pembrokeshire"  },
                  {"code":"GB-PKN", "value" :"Perth and Kinross"  },
                  {"code":"GB-PLY", "value" :"City of Plymouth"  },
                  {"code":"GB-POL", "value" :"Poole"  },
                  {"code":"GB-POR", "value" :"City of Portsmouth"  },
                  {"code":"GB-POW", "value" :"Powys"  },
                  {"code":"GB-PTE", "value" :"City of Peterborough"  },
                  {"code":"GB-RCC", "value" :"Redcar and Cleveland"  },
                  {"code":"GB-RCH", "value" :"Rochdale"  },
                  {"code":"GB-RCT", "value" :"Rhondda Cynon Taf"  },
                  {"code":"GB-RDB", "value" :"Redbridge"  },
                  {"code":"GB-RDG", "value" :"Reading"  },
                  {"code":"GB-RFW", "value" :"Renfrewshire"  },
                  {"code":"GB-RIC", "value" :"Richmond upon Thames"  },
                  {"code":"GB-ROT", "value" :"Rotherham"  },
                  {"code":"GB-RUT", "value" :"Rutland"  },
                  {"code":"GB-SAW", "value" :"Sandwell"  },
                  {"code":"GB-SAY", "value" :"South Ayrshire"  },
                  {"code":"GB-SCB", "value" :"Scottish Borders"  },
                  {"code":"GB-SFK", "value" :"Suffolk"  },
                  {"code":"GB-SFT", "value" :"Sefton"  },
                  {"code":"GB-SGC", "value" :"South Gloucestershire"  },
                  {"code":"GB-SHF", "value" :"Sheffield"  },
                  {"code":"GB-SHN", "value" :"St. Helens"  },
                  {"code":"GB-SHR", "value" :"Shropshire"  },
                  {"code":"GB-SKP", "value" :"Stockport"  },
                  {"code":"GB-SLF", "value" :"City of Salford"  },
                  {"code":"GB-SLG", "value" :"Slough"  },
                  {"code":"GB-SLK", "value" :"South Lanarkshire"  },
                  {"code":"GB-SND", "value" :"Sunderland"  },
                  {"code":"GB-SOL", "value" :"Solihull"  },
                  {"code":"GB-SOM", "value" :"Somerset"  },
                  {"code":"GB-SOS", "value" :"Southend-on-Sea"  },
                  {"code":"GB-SRY", "value" :"Surrey"  },
                  {"code":"GB-STB", "value" :"Strabane"  },
                  {"code":"GB-STE", "value" :"City of Stoke-on-Trent"  },
                  {"code":"GB-STG", "value" :"Stirling"  },
                  {"code":"GB-STH", "value" :"City of Southampton"  },
                  {"code":"GB-STN", "value" :"Sutton"  },
                  {"code":"GB-STS", "value" :"Staffordshire"  },
                  {"code":"GB-STT", "value" :"Stockton-on-Tees"  },
                  {"code":"GB-STY", "value" :"South Tyneside"  },
                  {"code":"GB-SWA", "value" :"Swansea"  },
                  {"code":"GB-SWD", "value" :"Swindon"  },
                  {"code":"GB-SWK", "value" :"Southwark"  },
                  {"code":"GB-TAM", "value" :"Tameside"  },
                  {"code":"GB-TFW", "value" :"Telford and Wrekin"  },
                  {"code":"GB-THR", "value" :"Thurrock"  },
                  {"code":"GB-TOB", "value" :"Torbay"  },
                  {"code":"GB-TOF", "value" :"Torfaen"  },
                  {"code":"GB-TRF", "value" :"Trafford"  },
                  {"code":"GB-TWH", "value" :"Tower Hamlets"  },
                  {"code":"GB-VGL", "value" :"Vale of Glamorgan"  },
                  {"code":"GB-WAR", "value" :"Warwickshire"  },
                  {"code":"GB-WBK", "value" :"West Berkshire"  },
                  {"code":"GB-WDU", "value" :"West Dunbartonshire"  },
                  {"code":"GB-WFT", "value" :"Waltham Forest"  },
                  {"code":"GB-WGN", "value" :"Wigan"  },
                  {"code":"GB-WIL", "value" :"Wiltshire"  },
                  {"code":"GB-WKF", "value" :"Wakefield"  },
                  {"code":"GB-WLL", "value" :"Walsall"  },
                  {"code":"GB-WLN", "value" :"West Lothian"  },
                  {"code":"GB-WLV", "value" :"City of Wolverhampton"  },
                  {"code":"GB-WND", "value" :"Wandsworth"  },
                  {"code":"GB-WNM", "value" :"Windsor and Maidenhead"  },
                  {"code":"GB-WOK", "value" :"Wokingham"  },
                  {"code":"GB-WOR", "value" :"Worcestershire"  },
                  {"code":"GB-WRL", "value" :"Wirral"  },
                  {"code":"GB-WRT", "value" :"Warrington"  },
                  {"code":"GB-WRX", "value" :"Wrexham"  },
                  {"code":"GB-WSM", "value" :"City of Westminster"  },
                  {"code":"GB-WSX", "value" :"West Sussex"  },
                  {"code":"GB-YOR", "value" :"York"  },
                  {"code":"GB-ZET", "value" :"Shetland Islands"  },
                  {"code":"GD-01", "value" :"Saint Andrew"  },
                  {"code":"GD-02", "value" :"Saint David"  },
                  {"code":"GD-03", "value" :"Saint George"  },
                  {"code":"GD-04", "value" :"Saint John"  },
                  {"code":"GD-05", "value" :"Saint Mark"  },
                  {"code":"GD-06", "value" :"Saint Patrick"  },
                  {"code":"GD-10", "value" :"Southern Grenadine Islands"  },
                  {"code":"GE-AB", "value" :"Abkhazia"  },
                  {"code":"GE-AJ", "value" :"Adjara"  },
                  {"code":"GE-GU", "value" :"Guria"  },
                  {"code":"GE-IM", "value" :"Imereti"  },
                  {"code":"GE-KA", "value" :"Kakheti"  },
                  {"code":"GE-KK", "value" :"Kvemo Kartli"  },
                  {"code":"GE-MM", "value" :"Mtskheta-Mtianeti"  },
                  {"code":"GE-RL", "value" :"Racha-Lechkhumi and Kvemo Svaneti"  },
                  {"code":"GE-SJ", "value" :"Samtskhe-Javakheti"  },
                  {"code":"GE-SK", "value" :"Shida Kartli"  },
                  {"code":"GE-SZ", "value" :"Samegrelo-Zemo Svaneti"  },
                  {"code":"GE-TB", "value" :"Tbilisi"  },
                  {"code":"GH-AA", "value" :"Greater Accra"  },
                  {"code":"GH-AH", "value" :"Ashanti"  },
                  {"code":"GH-BA", "value" :"Brong-Ahafo"  },
                  {"code":"GH-CP", "value" :"Central"  },
                  {"code":"GH-EP", "value" :"Eastern"  },
                  {"code":"GH-NP", "value" :"Northern"  },
                  {"code":"GH-TV", "value" :"Volta"  },
                  {"code":"GH-UE", "value" :"Upper East"  },
                  {"code":"GH-UW", "value" :"Upper West"  },
                  {"code":"GH-WP", "value" :"Western"  },
                  {"code":"GL-KU", "value" :"Kommune Kujalleq"  },
                  {"code":"GL-QA", "value" :"Qaasuitsup Kommunia"  },
                  {"code":"GL-QE", "value" :"Qeqqata Kommunia"  },
                  {"code":"GL-SM", "value" :"Kommuneqarfik Sermersooq"  },
                  {"code":"GM-B", "value" :"Banjul"  },
                  {"code":"GM-L", "value" :"Lower River"  },
                  {"code":"GM-M", "value" :"MacCarthy Island"  },
                  {"code":"GM-N", "value" :"North Bank"  },
                  {"code":"GM-U", "value" :"Upper River"  },
                  {"code":"GM-W", "value" :"Western"  },
                  {"code":"GN-BE", "value" :"Beyla"  },
                  {"code":"GN-BF", "value" :"Boffa"  },
                  {"code":"GN-BK", "value" :"Boké"  },
                  {"code":"GN-C", "value" :"Conakry"  },
                  {"code":"GN-CO", "value" :"Coyah"  },
                  {"code":"GN-DB", "value" :"Dabola"  },
                  {"code":"GN-DI", "value" :"Dinguiraye"  },
                  {"code":"GN-DL", "value" :"Dalaba"  },
                  {"code":"GN-DU", "value" :"Dubréka"  },
                  {"code":"GN-FA", "value" :"Faranah"  },
                  {"code":"GN-FO", "value" :"Forécariah"  },
                  {"code":"GN-FR", "value" :"Fria"  },
                  {"code":"GN-GA", "value" :"Gaoual"  },
                  {"code":"GN-GU", "value" :"Guékédou"  },
                  {"code":"GN-KA", "value" :"Kankan"  },
                  {"code":"GN-KB", "value" :"Koubia"  },
                  {"code":"GN-KD", "value" :"Kindia"  },
                  {"code":"GN-KE", "value" :"Kérouané"  },
                  {"code":"GN-KN", "value" :"Koundara"  },
                  {"code":"GN-KO", "value" :"Kouroussa"  },
                  {"code":"GN-KS", "value" :"Kissidougou"  },
                  {"code":"GN-LA", "value" :"Labé"  },
                  {"code":"GN-LE", "value" :"Lélouma"  },
                  {"code":"GN-LO", "value" :"Lola"  },
                  {"code":"GN-MC", "value" :"Macenta"  },
                  {"code":"GN-MD", "value" :"Mandiana"  },
                  {"code":"GN-ML", "value" :"Mali"  },
                  {"code":"GN-MM", "value" :"Mamou"  },
                  {"code":"GN-NZ", "value" :"Nzérékoré"  },
                  {"code":"GN-PI", "value" :"Pita"  },
                  {"code":"GN-SI", "value" :"Siguiri"  },
                  {"code":"GN-TE", "value" :"Télimélé"  },
                  {"code":"GN-TO", "value" :"Tougué"  },
                  {"code":"GN-YO", "value" :"Yomou"  },
                  {"code":"GQ-AN", "value" :"Annobón"  },
                  {"code":"GQ-BN", "value" :"Bioko Norte"  },
                  {"code":"GQ-BS", "value" :"Bioko Sur"  },
                  {"code":"GQ-C", "value" :"Región Continental"  },
                  {"code":"GQ-CS", "value" :"Centro Sur"  },
                  {"code":"GQ-I", "value" :"Región Insular"  },
                  {"code":"GQ-KN", "value" :"Kie-Ntem"  },
                  {"code":"GQ-LI", "value" :"Litoral"  },
                  {"code":"GQ-WN", "value" :"Wele-Nzás"  },
                  {"code":"GR-01", "value" :"Aetolia-Acarnania"  },
                  {"code":"GR-03", "value" :"Boeotia"  },
                  {"code":"GR-04", "value" :"Euboea"  },
                  {"code":"GR-05", "value" :"Evrytania"  },
                  {"code":"GR-06", "value" :"Phthiotis"  },
                  {"code":"GR-07", "value" :"Phocis"  },
                  {"code":"GR-11", "value" :"Argolis"  },
                  {"code":"GR-12", "value" :"Arcadia"  },
                  {"code":"GR-13", "value" :"Achaea"  },
                  {"code":"GR-14", "value" :"Ilia"  },
                  {"code":"GR-15", "value" :"Corinthia"  },
                  {"code":"GR-16", "value" :"Laconia"  },
                  {"code":"GR-17", "value" :"Messinia"  },
                  {"code":"GR-21", "value" :"Zakynthos"  },
                  {"code":"GR-22", "value" :"Corfu"  },
                  {"code":"GR-23", "value" :"Kefalonia and Ithaca"  },
                  {"code":"GR-24", "value" :"Lefkada"  },
                  {"code":"GR-31", "value" :"Arta"  },
                  {"code":"GR-32", "value" :"Thesprotia"  },
                  {"code":"GR-33", "value" :"Ioannina"  },
                  {"code":"GR-34", "value" :"Preveza"  },
                  {"code":"GR-41", "value" :"Karditsa"  },
                  {"code":"GR-42", "value" :"Larissa"  },
                  {"code":"GR-43", "value" :"Magnesia"  },
                  {"code":"GR-44", "value" :"Trikala"  },
                  {"code":"GR-51", "value" :"Grevena"  },
                  {"code":"GR-52", "value" :"Drama"  },
                  {"code":"GR-53", "value" :"Imathia"  },
                  {"code":"GR-54", "value" :"Thessaloniki"  },
                  {"code":"GR-55", "value" :"Kavala"  },
                  {"code":"GR-56", "value" :"Kastoria"  },
                  {"code":"GR-57", "value" :"Kilkis"  },
                  {"code":"GR-58", "value" :"Kozani"  },
                  {"code":"GR-59", "value" :"Pella"  },
                  {"code":"GR-61", "value" :"Pieria"  },
                  {"code":"GR-62", "value" :"Serres"  },
                  {"code":"GR-63", "value" :"Florina"  },
                  {"code":"GR-64", "value" :"Chalkidiki"  },
                  {"code":"GR-69", "value" :"Piraeus"  },
                  {"code":"GR-71", "value" :"Evros"  },
                  {"code":"GR-72", "value" :"Xanthi"  },
                  {"code":"GR-73", "value" :"Rhodope"  },
                  {"code":"GR-81", "value" :"Dodecanese"  },
                  {"code":"GR-82", "value" :"Cyclades"  },
                  {"code":"GR-83", "value" :"Lesbos"  },
                  {"code":"GR-84", "value" :"Samos"  },
                  {"code":"GR-85", "value" :"Chios"  },
                  {"code":"GR-91", "value" :"Heraklion"  },
                  {"code":"GR-92", "value" :"Lasithi"  },
                  {"code":"GR-93", "value" :"Rethymno"  },
                  {"code":"GR-94", "value" :"Chania"  },
                  {"code":"GR-A1", "value" :"Attica" },
                  {"code":"GT-AV", "value" :"Alta Verapaz"  },
                  {"code":"GT-BV", "value" :"Baja Verapaz"  },
                  {"code":"GT-CM", "value" :"Chimaltenango"  },
                  {"code":"GT-CQ", "value" :"Chiquimula"  },
                  {"code":"GT-ES", "value" :"Escuintla"  },
                  {"code":"GT-GU", "value" :"Guatemala"  },
                  {"code":"GT-HU", "value" :"Huehuetenango"  },
                  {"code":"GT-IZ", "value" :"Izabal"  },
                  {"code":"GT-JA", "value" :"Jalapa"  },
                  {"code":"GT-JU", "value" :"Jutiapa"  },
                  {"code":"GT-PE", "value" :"Petén"  },
                  {"code":"GT-PR", "value" :"El Progreso"  },
                  {"code":"GT-QC", "value" :"Quiché"  },
                  {"code":"GT-QZ", "value" :"Quetzaltenango"  },
                  {"code":"GT-RE", "value" :"Retalhuleu"  },
                  {"code":"GT-SA", "value" :"Sacatepéquez"  },
                  {"code":"GT-SM", "value" :"San Marcos"  },
                  {"code":"GT-SO", "value" :"Sololá"  },
                  {"code":"GT-SR", "value" :"Santa Rosa"  },
                  {"code":"GT-SU", "value" :"Suchitepéquez"  },
                  {"code":"GT-TO", "value" :"Totonicapán"  },
                  {"code":"GT-ZA", "value" :"Zacapa"  },
                  {"code":"GW-BA", "value" :"Bafatá"  },
                  {"code":"GW-BL", "value" :"Bolama"  },
                  {"code":"GW-BM", "value" :"Biombo"  },
                  {"code":"GW-BS", "value" :"Bissau"  },
                  {"code":"GW-CA", "value" :"Cacheu"  },
                  {"code":"GW-GA", "value" :"Gabú"  },
                  {"code":"GW-OI", "value" :"Oio"  },
                  {"code":"GW-QU", "value" :"Quinara"  },
                  {"code":"GW-TO", "value" :"Tombali"  },
                  {"code":"GY-BA", "value" :"Barima-Waini"  },
                  {"code":"GY-CU", "value" :"Cuyuni-Mazaruni"  },
                  {"code":"GY-DE", "value" :"Demerara-Mahaica"  },
                  {"code":"GY-EB", "value" :"East Berbice-Corentyne"  },
                  {"code":"GY-ES", "value" :"Essequibo Islands-West Demerara"  },
                  {"code":"GY-MA", "value" :"Mahaica-Berbice"  },
                  {"code":"GY-PM", "value" :"Pomeroon-Supenaam"  },
                  {"code":"GY-PT", "value" :"Potaro-Siparuni"  },
                  {"code":"GY-UD", "value" :"Upper Demerara-Berbice"  },
                  {"code":"GY-UT", "value" :"Upper Takutu-Upper Essequibo"  },
                  {"code":"HN-AT", "value" :"Atlántida"  },
                  {"code":"HN-CH", "value" :"Choluteca"  },
                  {"code":"HN-CL", "value" :"Colón"  },
                  {"code":"HN-CM", "value" :"Comayagua"  },
                  {"code":"HN-CP", "value" :"Copán"  },
                  {"code":"HN-CR", "value" :"Cortés"  },
                  {"code":"HN-EP", "value" :"El Paraíso"  },
                  {"code":"HN-FM", "value" :"Francisco Morazán"  },
                  {"code":"HN-GD", "value" :"Gracias a Dios"  },
                  {"code":"HN-IB", "value" :"Islas de la Bahía"  },
                  {"code":"HN-IN", "value" :"Intibucá"  },
                  {"code":"HN-LE", "value" :"Lempira"  },
                  {"code":"HN-LP", "value" :"La Paz"  },
                  {"code":"HN-OC", "value" :"Ocotepeque"  },
                  {"code":"HN-OL", "value" :"Olancho"  },
                  {"code":"HN-SB", "value" :"Santa Bárbara"  },
                  {"code":"HN-VA", "value" :"Valle"  },
                  {"code":"HN-YO", "value" :"Yoro"  },
                  {"code":"HR-01", "value" :"Zagrebačka"  },
                  {"code":"HR-02", "value" :"Krapinsko-Zagorska"  },
                  {"code":"HR-03", "value" :"Sisačko-Moslavačka"  },
                  {"code":"HR-04", "value" :"Karlovačka"  },
                  {"code":"HR-05", "value" :"Varaždinska"  },
                  {"code":"HR-06", "value" :"Koprivničko-Križevačka"  },
                  {"code":"HR-07", "value" :"Bjelovarsko-Bilogorska"  },
                  {"code":"HR-08", "value" :"Primorsko-Goranska"  },
                  {"code":"HR-09", "value" :"Ličko-Senjska"  },
                  {"code":"HR-10", "value" :"Virovitičko-Podravska"  },
                  {"code":"HR-11", "value" :"Požeško-Slavonska"  },
                  {"code":"HR-12", "value" :"Brodsko-Posavska"  },
                  {"code":"HR-13", "value" :"Zadarska"  },
                  {"code":"HR-14", "value" :"Osječko-Baranjska"  },
                  {"code":"HR-15", "value" :"Šibensko-Kninska"  },
                  {"code":"HR-16", "value" :"Vukovarsko-Srijemska"  },
                  {"code":"HR-17", "value" :"Splitsko-Dalmatinska"  },
                  {"code":"HR-18", "value" :"Istarska"  },
                  {"code":"HR-19", "value" :"Dubrovačko-Neretvanska"  },
                  {"code":"HR-20", "value" :"Međimurska"  },
                  {"code":"HR-21", "value" :"Grad Zagreb"  },
                  {"code":"HT-AR", "value" :"Artibonite"  },
                  {"code":"HT-CE", "value" :"Centre"  },
                  {"code":"HT-GA", "value" :"Grand 'Anse"  },
                  {"code":"HT-ND", "value" :"Nord"  },
                  {"code":"HT-NE", "value" :"Nord-Est"  },
                  {"code":"HT-NI", "value" :"Nippes"  },
                  {"code":"HT-NO", "value" :"Nord-Ouest"  },
                  {"code":"HT-OU", "value" :"Ouest"  },
                  {"code":"HT-SD", "value" :"Sud"  },
                  {"code":"HT-SE", "value" :"Sud-Est"  },
                  {"code":"HU-BA", "value" :"Baranya"  },
                  {"code":"HU-BC", "value" :"Békéscsabai"  },
                  {"code":"HU-BE", "value" :"Békés"  },
                  {"code":"HU-BK", "value" :"Bács-Kiskun"  },
                  {"code":"HU-BU", "value" :"Budapesti"  },
                  {"code":"HU-BZ", "value" :"Borsod-Abaúj-Zemplén"  },
                  {"code":"HU-CS", "value" :"Csongrád"  },
                  {"code":"HU-DE", "value" :"Debreceni"  },
                  {"code":"HU-DU", "value" :"Dunaújvárosi"  },
                  {"code":"HU-EG", "value" :"Egri"  },
                  {"code":"HU-ER", "value" :"Budaörsi"  },
                  {"code":"HU-FE", "value" :"Fejér"  },
                  {"code":"HU-GS", "value" :"Győr-Moson-Sopron"  },
                  {"code":"HU-GY", "value" :"Győri"  },
                  {"code":"HU-HB", "value" :"Hajdú-Bihar"  },
                  {"code":"HU-HE", "value" :"Heves"  },
                  {"code":"HU-HV", "value" :"Hódmezővásárhelyi"  },
                  {"code":"HU-JN", "value" :"Jász-Nagykun-Szolnok"  },
                  {"code":"HU-KE", "value" :"Komárom-Esztergom"  },
                  {"code":"HU-KM", "value" :"Kecskeméti"  },
                  {"code":"HU-KV", "value" :"Kaposvári"  },
                  {"code":"HU-MI", "value" :"Miskolci"  },
                  {"code":"HU-NK", "value" :"Nagykanizsai"  },
                  {"code":"HU-NO", "value" :"Nógrád"  },
                  {"code":"HU-NY", "value" :"Nyíregyházai"  },
                  {"code":"HU-PE", "value" :"Pest"  },
                  {"code":"HU-PS", "value" :"Pécsi"  },
                  {"code":"HU-SD", "value" :"Szegedi"  },
                  {"code":"HU-SF", "value" :"Székesfehérvári"  },
                  {"code":"HU-SH", "value" :"Szombathelyi"  },
                  {"code":"HU-SK", "value" :"Szolnoki"  },
                  {"code":"HU-SN", "value" :"Sopron-Fertődi"  },
                  {"code":"HU-SO", "value" :"Somogy"  },
                  {"code":"HU-SS", "value" :"Szekszárdi"  },
                  {"code":"HU-ST", "value" :"Salgótarjáni"  },
                  {"code":"HU-SZ", "value" :"Szabolcs-Szatmár-Bereg"  },
                  {"code":"HU-TB", "value" :"Tatabányai"  },
                  {"code":"HU-TO", "value" :"Tolna"  },
                  {"code":"HU-VA", "value" :"Vas"  },
                  {"code":"HU-VE", "value" :"Veszprém"  },
                  {"code":"HU-VM", "value" :"Veszprémi"  },
                  {"code":"HU-ZA", "value" :"Zala"  },
                  {"code":"HU-ZE", "value" :"Zalaegerszegi"  },
                  {"code":"ID-AC", "value" :"Aceh"  },
                  {"code":"ID-BA", "value" :"Bali"  },
                  {"code":"ID-BB", "value" :"Bangka-Belitung"  },
                  {"code":"ID-BE", "value" :"Bengkulu"  },
                  {"code":"ID-BT", "value" :"Banten"  },
                  {"code":"ID-GO", "value" :"Gorontalo"  },
                  {"code":"ID-JA", "value" :"Jambi"  },
                  {"code":"ID-JB", "value" :"West Java"  },
                  {"code":"ID-JI", "value" :"East Java"  },
                  {"code":"ID-JK", "value" :"Jakarta"  },
                  {"code":"ID-JT", "value" :"Central Java"  },
                  {"code":"ID-KB", "value" :"West Kalimantan"  },
                  {"code":"ID-KI", "value" :"East Kalimantan"  },
                  {"code":"ID-KR", "value" :"Riau Islands"  },
                  {"code":"ID-KS", "value" :"South Kalimantan"  },
                  {"code":"ID-KT", "value" :"Central Kalimantan"  },
                  {"code":"ID-LA", "value" :"Lampung"  },
                  {"code":"ID-MA", "value" :"Maluku"  },
                  {"code":"ID-MU", "value" :"North Maluku"  },
                  {"code":"ID-NB", "value" :"West Nusa Tenggara"  },
                  {"code":"ID-NT", "value" :"East Nusa Tenggara"  },
                  {"code":"ID-PA", "value" :"Papua"  },
                  {"code":"ID-PB", "value" :"West Papua"  },
                  {"code":"ID-RI", "value" :"Riau"  },
                  {"code":"ID-SA", "value" :"North Sulawesi"  },
                  {"code":"ID-SB", "value" :"West Sumatra"  },
                  {"code":"ID-SG", "value" :"South East Sulawesi"  },
                  {"code":"ID-SN", "value" :"South Sulawesi"  },
                  {"code":"ID-SR", "value" :"West Sulawesi"  },
                  {"code":"ID-SS", "value" :"South Sumatra"  },
                  {"code":"ID-ST", "value" :"Central Sulawesi"  },
                  {"code":"ID-SU", "value" :"North Sumatra"  },
                  {"code":"ID-YO", "value" :"Yogyakarta"  },
                  {"code":"IE-C", "value" :"Cork"  },
                  {"code":"IE-CE", "value" :"Clare"  },
                  {"code":"IE-CN", "value" :"Cavan"  },
                  {"code":"IE-CW", "value" :"Carlow"  },
                  {"code":"IE-D", "value" :"Dublin"  },
                  {"code":"IE-DL", "value" :"Donegal"  },
                  {"code":"IE-G", "value" :"Galway"  },
                  {"code":"IE-KE", "value" :"Kildare"  },
                  {"code":"IE-KK", "value" :"Kilkenny"  },
                  {"code":"IE-KY", "value" :"Kerry"  },
                  {"code":"IE-LD", "value" :"Longford"  },
                  {"code":"IE-LH", "value" :"Louth"  },
                  {"code":"IE-LK", "value" :"Limerick"  },
                  {"code":"IE-LM", "value" :"Leitrim"  },
                  {"code":"IE-LS", "value" :"Laois"  },
                  {"code":"IE-MH", "value" :"Meath"  },
                  {"code":"IE-MN", "value" :"Monaghan"  },
                  {"code":"IE-MO", "value" :"Mayo"  },
                  {"code":"IE-OY", "value" :"Offaly"  },
                  {"code":"IE-RN", "value" :"Roscommon"  },
                  {"code":"IE-SO", "value" :"Sligo"  },
                  {"code":"IE-TA", "value" :"Tipperary"  },
                  {"code":"IE-WD", "value" :"Waterford"  },
                  {"code":"IE-WH", "value" :"Westmeath"  },
                  {"code":"IE-WW", "value" :"Wicklow"  },
                  {"code":"IE-WX", "value" :"Wexford"  },
                  {"code":"IL-D", "value" :"South"  },
                  {"code":"IL-HA", "value" :"Haifa"  },
                  {"code":"IL-JM", "value" :"Jerusalem"  },
                  {"code":"IL-M", "value" :"Center"  },
                  {"code":"IL-TA", "value" :"Tel Aviv"  },
                  {"code":"IL-Z", "value" :"North"  },
                  {"code":"IN-AN", "value" :"Andaman and Nicobar Islands"  },
                  {"code":"IN-AP", "value" :"Andhra Pradesh"  },
                  {"code":"IN-AR", "value" :"Arunachal Pradesh"  },
                  {"code":"IN-AS", "value" :"Assam"  },
                  {"code":"IN-BR", "value" :"Bihar"  },
                  {"code":"IN-CH", "value" :"Chandigarh"  },
                  {"code":"IN-CT", "value" :"Chhattisgarh"  },
                  {"code":"IN-DD", "value" :"Daman and Diu"  },
                  {"code":"IN-DL", "value" :"Delhi"  },
                  {"code":"IN-DN", "value" :"Dadra and Nagar Haveli"  },
                  {"code":"IN-GA", "value" :"Goa"  },
                  {"code":"IN-GJ", "value" :"Gujarat"  },
                  {"code":"IN-HP", "value" :"Himachal Pradesh"  },
                  {"code":"IN-HR", "value" :"Haryana"  },
                  {"code":"IN-JH", "value" :"Jharkhand"  },
                  {"code":"IN-JK", "value" :"Jammu and Kashmir"  },
                  {"code":"IN-KA", "value" :"Karnataka"  },
                  {"code":"IN-KL", "value" :"Kerala"  },
                  {"code":"IN-LD", "value" :"Lakshadweep"  },
                  {"code":"IN-MH", "value" :"Maharashtra"  },
                  {"code":"IN-ML", "value" :"Meghalaya"  },
                  {"code":"IN-MN", "value" :"Manipur"  },
                  {"code":"IN-MP", "value" :"Madhya Pradesh"  },
                  {"code":"IN-MZ", "value" :"Mizoram"  },
                  {"code":"IN-NL", "value" :"Nagaland"  },
                  {"code":"IN-OR", "value" :"Orissa"  },
                  {"code":"IN-PB", "value" :"Punjab"  },
                  {"code":"IN-PY", "value" :"Puducherry"  },
                  {"code":"IN-RJ", "value" :"Rajasthan"  },
                  {"code":"IN-SK", "value" :"Sikkim"  },
                  {"code":"IN-TN", "value" :"Tamil Nadu"  },
                  {"code":"IN-TR", "value" :"Tripura"  },
                  {"code":"IN-UL", "value" :"Uttarakhand"  },
                  {"code":"IN-UP", "value" :"Uttar Pradesh"  },
                  {"code":"IN-WB", "value" :"West Bengal"  },
                  {"code":"IQ-AN", "value" :"Al Anbar"  },
                  {"code":"IQ-AR", "value" :"Arbil"  },
                  {"code":"IQ-BA", "value" :"Al Basrah"  },
                  {"code":"IQ-BB", "value" :"Babil"  },
                  {"code":"IQ-BG", "value" :"Baghdad"  },
                  {"code":"IQ-DA", "value" :"Dahouk"  },
                  {"code":"IQ-DI", "value" :"Deyala"  },
                  {"code":"IQ-DQ", "value" :"Thi Qar"  },
                  {"code":"IQ-KA", "value" :"Karbala"  },
                  {"code":"IQ-MA", "value" :"Maysan"  },
                  {"code":"IQ-MU", "value" :"Al Muthanna"  },
                  {"code":"IQ-NA", "value" :"Al Najaf"  },
                  {"code":"IQ-NI", "value" :"Mousl (Nainawa)"  },
                  {"code":"IQ-QA", "value" :"Al Quadisiya"  },
                  {"code":"IQ-SD", "value" :"Salah Al Deen"  },
                  {"code":"IQ-SU", "value" :"Al Sulaymaniah"  },
                  {"code":"IQ-TS", "value" :"Al Ta 'amim"  },
                  {"code":"IQ-WA", "value" :"Wasit"  },
                  {"code":"IR-01", "value" :"East Azarbaijan"  },
                  {"code":"IR-02", "value" :"West Azarbaijan"  },
                  {"code":"IR-03", "value" :"Ardabil"  },
                  {"code":"IR-04", "value" :"Isfahan"  },
                  {"code":"IR-05", "value" :"Ilam"  },
                  {"code":"IR-06", "value" :"Bushehr"  },
                  {"code":"IR-07", "value" :"Tehran"  },
                  {"code":"IR-08", "value" :"Chahar Mahaal and Bakhtiari"  },
                  {"code":"IR-09", "value" :"Khorasan"  },
                  {"code":"IR-10", "value" :"Khuzestan"  },
                  {"code":"IR-11", "value" :"Zanjan"  },
                  {"code":"IR-12", "value" :"Semnan"  },
                  {"code":"IR-13", "value" :"Sistan and Baluchestan"  },
                  {"code":"IR-14", "value" :"Fars"  },
                  {"code":"IR-15", "value" :"Kerman"  },
                  {"code":"IR-16", "value" :"Kurdistan"  },
                  {"code":"IR-17", "value" :"Kermanshah"  },
                  {"code":"IR-18", "value" :"Kohgiluyeh and Boyer-Ahmad"  },
                  {"code":"IR-19", "value" :"Gilan"  },
                  {"code":"IR-20", "value" :"Lorestan"  },
                  {"code":"IR-21", "value" :"Mazandaran"  },
                  {"code":"IR-22", "value" :"Markazi"  },
                  {"code":"IR-23", "value" :"Hormozgan"  },
                  {"code":"IR-24", "value" :"Hamadan"  },
                  {"code":"IR-25", "value" :"Yazd"  },
                  {"code":"IR-26", "value" :"Qom"  },
                  {"code":"IR-27", "value" :"Golestan"  },
                  {"code":"IR-28", "value" :"Qazvin"  },
                  {"code":"IR-29", "value" :"South Khorasan"  },
                  {"code":"IR-30", "value" :"Razavi Khorasan"  },
                  {"code":"IR-31", "value" :"North Khorasan"  },
                  {"code":"IS-1", "value" :"Höfuðborgarsvæði"   },
                  {"code":"IS-2", "value" :"Suðurnes"   },
                  {"code":"IS-3", "value" :"Vesturland"   },
                  {"code":"IS-4", "value" :"Vestfirðir"   },
                  {"code":"IS-5", "value" :"Norðurland vestra"   },
                  {"code":"IS-6", "value" :"Norðurland eystra"   },
                  {"code":"IS-7", "value" :"Austurland"   },
                  {"code":"IS-8", "value" :"Suðurland"   },
                  {"code":"IT-AG", "value" :"Agrigento"   },
                  {"code":"IT-AL", "value" :"Alessandria"   },
                  {"code":"IT-AN", "value" :"Ancona"   },
                  {"code":"IT-AO", "value" :"Valle d 'Aosta"   },
                  {"code":"IT-AP", "value" :"Ascoli Piceno"   },
                  {"code":"IT-AQ", "value" :"L'Aquila"   },
                  {"code":"IT-AR", "value" :"Arezzo"   },
                  {"code":"IT-AT", "value" :"Asti"   },
                  {"code":"IT-AV", "value" :"Avellino"   },
                  {"code":"IT-BA", "value" :"Bari"   },
                  {"code":"IT-BG", "value" :"Bergamo"   },
                  {"code":"IT-BI", "value" :"Biella"   },
                  {"code":"IT-BL", "value" :"Belluno"   },
                  {"code":"IT-BN", "value" :"Benevento"   },
                  {"code":"IT-BO", "value" :"Bologna"   },
                  {"code":"IT-BR", "value" :"Brindisi"   },
                  {"code":"IT-BS", "value" :"Brescia"   },
                  {"code":"IT-BT", "value" :"Barletta-Andria-Trani"   },
                  {"code":"IT-BZ", "value" :"Bolzano"   },
                  {"code":"IT-CA", "value" :"Cagliari"   },
                  {"code":"IT-CB", "value" :"Campobasso"   },
                  {"code":"IT-CE", "value" :"Caserta"   },
                  {"code":"IT-CH", "value" :"Chieti"   },
                  {"code":"IT-CI", "value" :"Carbonia-Iglesias"   },
                  {"code":"IT-CL", "value" :"Caltanissetta"   },
                  {"code":"IT-CN", "value" :"Cuneo"   },
                  {"code":"IT-CO", "value" :"Como"   },
                  {"code":"IT-CR", "value" :"Cremona"   },
                  {"code":"IT-CS", "value" :"Cosenza"   },
                  {"code":"IT-CT", "value" :"Catania"   },
                  {"code":"IT-CZ", "value" :"Catanzaro"   },
                  {"code":"IT-EN", "value" :"Enna"   },
                  {"code":"IT-FC", "value" :"Forlì-Cesena"   },
                  {"code":"IT-FE", "value" :"Ferrara"   },
                  {"code":"IT-FG", "value" :"Foggia"   },
                  {"code":"IT-FI", "value" :"Firenze"   },
                  {"code":"IT-FM", "value" :"Fermo"   },
                  {"code":"IT-FR", "value" :"Frosinone"   },
                  {"code":"IT-GE", "value" :"Genova"   },
                  {"code":"IT-GO", "value" :"Gorizia"   },
                  {"code":"IT-GR", "value" :"Grosseto"   },
                  {"code":"IT-IM", "value" :"Imperia"   },
                  {"code":"IT-IS", "value" :"Isernia"   },
                  {"code":"IT-KR", "value" :"Crotone"   },
                  {"code":"IT-LC", "value" :"Lecco"   },
                  {"code":"IT-LE", "value" :"Lecce"   },
                  {"code":"IT-LI", "value" :"Livorno"   },
                  {"code":"IT-LO", "value" :"Lodi"   },
                  {"code":"IT-LT", "value" :"Latina"   },
                  {"code":"IT-LU", "value" :"Lucca"   },
                  {"code":"IT-MB", "value" :"Monza e della Brianza"   },
                  {"code":"IT-MC", "value" :"Macerata"   },
                  {"code":"IT-ME", "value" :"Messina"   },
                  {"code":"IT-MI", "value" :"Milano"   },
                  {"code":"IT-MN", "value" :"Mantova"   },
                  {"code":"IT-MO", "value" :"Modena"   },
                  {"code":"IT-MS", "value" :"Massa-Carrara"   },
                  {"code":"IT-MT", "value" :"Matera"   },
                  {"code":"IT-NA", "value" :"Napoli"   },
                  {"code":"IT-NO", "value" :"Novara"   },
                  {"code":"IT-NU", "value" :"Nuoro"   },
                  {"code":"IT-OG", "value" :"Ogliastra"   },
                  {"code":"IT-OR", "value" :"Oristano"   },
                  {"code":"IT-OT", "value" :"Olbia-Tempio"   },
                  {"code":"IT-PA", "value" :"Palermo"   },
                  {"code":"IT-PC", "value" :"Piacenza"   },
                  {"code":"IT-PD", "value" :"Padova"   },
                  {"code":"IT-PE", "value" :"Pescara"   },
                  {"code":"IT-PG", "value" :"Perugia"   },
                  {"code":"IT-PI", "value" :"Pisa"   },
                  {"code":"IT-PN", "value" :"Pordenone"   },
                  {"code":"IT-PO", "value" :"Prato"   },
                  {"code":"IT-PR", "value" :"Parma"   },
                  {"code":"IT-PT", "value" :"Pistoia"   },
                  {"code":"IT-PU", "value" :"Pesaro e Urbino"   },
                  {"code":"IT-PV", "value" :"Pavia"   },
                  {"code":"IT-PZ", "value" :"Potenza"   },
                  {"code":"IT-RA", "value" :"Ravenna"   },
                  {"code":"IT-RC", "value" :"Reggio di Calabria"   },
                  {"code":"IT-RE", "value" :"Reggio Nell'Emilia"   },
                  {"code":"IT-RG", "value" :"Ragusa"   },
                  {"code":"IT-RI", "value" :"Rieti"   },
                  {"code":"IT-RM", "value" :"Roma"   },
                  {"code":"IT-RN", "value" :"Rimini"   },
                  {"code":"IT-RO", "value" :"Rovigo"   },
                  {"code":"IT-SA", "value" :"Salerno"   },
                  {"code":"IT-SI", "value" :"Siena"   },
                  {"code":"IT-SO", "value" :"Sondrio"   },
                  {"code":"IT-SP", "value" :"La Spezia"   },
                  {"code":"IT-SR", "value" :"Siracusa"   },
                  {"code":"IT-SS", "value" :"Sassari"   },
                  {"code":"IT-SV", "value" :"Savona"   },
                  {"code":"IT-TA", "value" :"Taranto"   },
                  {"code":"IT-TE", "value" :"Teramo"   },
                  {"code":"IT-TN", "value" :"Trento"   },
                  {"code":"IT-TO", "value" :"Torino"   },
                  {"code":"IT-TP", "value" :"Trapani"   },
                  {"code":"IT-TR", "value" :"Terni"   },
                  {"code":"IT-TS", "value" :"Trieste"   },
                  {"code":"IT-TV", "value" :"Treviso"   },
                  {"code":"IT-UD", "value" :"Udine"   },
                  {"code":"IT-VA", "value" :"Varese"   },
                  {"code":"IT-VB", "value" :"Verbano-Cusio-Ossola"   },
                  {"code":"IT-VC", "value" :"Vercelli"   },
                  {"code":"IT-VE", "value" :"Venezia"   },
                  {"code":"IT-VI", "value" :"Vicenza"   },
                  {"code":"IT-VR", "value" :"Verona"   },
                  {"code":"IT-VS", "value" :"Medio Campidano"   },
                  {"code":"IT-VT", "value" :"Viterbo"   },
                  {"code":"IT-VV", "value" :"Vibo Valentia"   },
                  {"code":"JM-01", "value" :"Kingston"   },
                  {"code":"JM-02", "value" :"Saint Andrew"   },
                  {"code":"JM-03", "value" :"Saint Thomas"   },
                  {"code":"JM-04", "value" :"Portland"   },
                  {"code":"JM-05", "value" :"Saint Mary"   },
                  {"code":"JM-06", "value" :"Saint Ann"   },
                  {"code":"JM-07", "value" :"Trelawny"   },
                  {"code":"JM-08", "value" :"Saint James"   },
                  {"code":"JM-09", "value" :"Hanover"   },
                  {"code":"JM-10", "value" :"Westmoreland"   },
                  {"code":"JM-11", "value" :"Saint Elizabeth"   },
                  {"code":"JM-12", "value" :"Manchester"   },
                  {"code":"JM-13", "value" :"Clarendon"   },
                  {"code":"JM-14", "value" :"Saint Catherine"   },
                  {"code":"JO-AJ", "value" :"Ajlun"   },
                  {"code":"JO-AM", "value" :"Amman"   },
                  {"code":"JO-AQ", "value" :"Aqaba"   },
                  {"code":"JO-AT", "value" :"Tafilah"   },
                  {"code":"JO-AZ", "value" :"Zarqa"   },
                  {"code":"JO-BA", "value" :"Balqa"   },
                  {"code":"JO-IR", "value" :"Irbid"   },
                  {"code":"JO-JA", "value" :"Jarash"   },
                  {"code":"JO-KA", "value" :"Karak"   },
                  {"code":"JO-MA", "value" :"Mafraq"   },
                  {"code":"JO-MD", "value" :"Madaba"   },
                  {"code":"JO-MN", "value" :"Ma'an"   },
                  {"code":"JP-01", "value" :"Hokkaidō"   },
                  {"code":"JP-02", "value" :"Aomori"   },
                  {"code":"JP-03", "value" :"Iwate"   },
                  {"code":"JP-04", "value" :"Miyagi"   },
                  {"code":"JP-05", "value" :"Akita"   },
                  {"code":"JP-06", "value" :"Yamagata"   },
                  {"code":"JP-07", "value" :"Fukushima"   },
                  {"code":"JP-08", "value" :"Ibaraki"   },
                  {"code":"JP-09", "value" :"Tochigi"   },
                  {"code":"JP-10", "value" :"Gunma"   },
                  {"code":"JP-11", "value" :"Saitama"   },
                  {"code":"JP-12", "value" :"Chiba"   },
                  {"code":"JP-13", "value" :"Tōkyō"   },
                  {"code":"JP-14", "value" :"Kanagawa"   },
                  {"code":"JP-15", "value" :"Niigata"   },
                  {"code":"JP-16", "value" :"Toyama"   },
                  {"code":"JP-17", "value" :"Ishikawa"   },
                  {"code":"JP-18", "value" :"Fukui"   },
                  {"code":"JP-19", "value" :"Yamanashi"   },
                  {"code":"JP-20", "value" :"Nagano"   },
                  {"code":"JP-21", "value" :"Gifu"   },
                  {"code":"JP-22", "value" :"Shizuoka"   },
                  {"code":"JP-23", "value" :"Aichi"   },
                  {"code":"JP-24", "value" :"Mie"   },
                  {"code":"JP-25", "value" :"Shiga"   },
                  {"code":"JP-26", "value" :"Kyōto"   },
                  {"code":"JP-27", "value" :"Ōsaka"   },
                  {"code":"JP-28", "value" :"Hyōgo"   },
                  {"code":"JP-29", "value" :"Nara"   },
                  {"code":"JP-30", "value" :"Wakayama"   },
                  {"code":"JP-31", "value" :"Tottori"   },
                  {"code":"JP-32", "value" :"Shimane"   },
                  {"code":"JP-33", "value" :"Okayama"   },
                  {"code":"JP-34", "value" :"Hiroshima"   },
                  {"code":"JP-35", "value" :"Yamaguchi"   },
                  {"code":"JP-36", "value" :"Tokushima"   },
                  {"code":"JP-37", "value" :"Kagawa"   },
                  {"code":"JP-38", "value" :"Ehime"   },
                  {"code":"JP-39", "value" :"Kōchi"   },
                  {"code":"JP-40", "value" :"Fukuoka"   },
                  {"code":"JP-41", "value" :"Saga"   },
                  {"code":"JP-42", "value" :"Nagasaki"   },
                  {"code":"JP-43", "value" :"Kumamoto"   },
                  {"code":"JP-44", "value" :"Ōita"   },
                  {"code":"JP-45", "value" :"Miyazaki"   },
                  {"code":"JP-46", "value" :"Kagoshima"   },
                  {"code":"JP-47", "value" :"Okinawa"   },
                  {"code":"KE-110", "value" :"Nairobi"   },
                  {"code":"KE-200", "value" :"Central"   },
                  {"code":"KE-300", "value" :"Coast"   },
                  {"code":"KE-400", "value" :"Eastern"   },
                  {"code":"KE-500", "value" :"North-Eastern"   },
                  {"code":"KE-600", "value" :"Nyanza"   },
                  {"code":"KE-700", "value" :"Rift Valley"   },
                  {"code":"KE-900", "value" :"Western"   },
                  {"code":"KG-B", "value" :"Batken Province"   },
                  {"code":"KG-C", "value" :"Chuy Province"   },
                  {"code":"KG-GB", "value" :"Bishkek City"   },
                  {"code":"KG-J", "value" :"Jalal-Abad Province"   },
                  {"code":"KG-N", "value" :"Naryn Province"   },
                  {"code":"KG-O", "value" :"Osh City"   },
                  {"code":"KG-T", "value" :"Talas Province"   },
                  {"code":"KG-Y", "value" :"Issyk Kul Province"   },
                  {"code":"KH-1", "value" :"Banteay Meanchey"   },
                  {"code":"KH-10", "value" :"Kratie"   },
                  {"code":"KH-11", "value" :"Mondol Kiri"   },
                  {"code":"KH-12", "value" :"Phnom Penh"   },
                  {"code":"KH-13", "value" :"Preah Vihear"   },
                  {"code":"KH-14", "value" :"Prey Veng"   },
                  {"code":"KH-15", "value" :"Pursat"   },
                  {"code":"KH-16", "value" :"RatanaKiri"   },
                  {"code":"KH-17", "value" :"Siem Reap"   },
                  {"code":"KH-18", "value" :"Krong Preah Sihanouk"   },
                  {"code":"KH-19", "value" :"Stung Treng"   },
                  {"code":"KH-2", "value" :"Battambang"   },
                  {"code":"KH-20", "value" :"Svay Rieng"   },
                  {"code":"KH-21", "value" :"Takeo"   },
                  {"code":"KH-22", "value" :"Oudor MeanChey"   },
                  {"code":"KH-23", "value" :"Krong Kep"   },
                  {"code":"KH-24", "value" :"Krong Pailin"   },
                  {"code":"KH-3", "value" :"Kampong Cham"   },
                  {"code":"KH-4", "value" :"Kampong Chhnang"   },
                  {"code":"KH-5", "value" :"Kampong Speu"   },
                  {"code":"KH-6", "value" :"Kampong Thom"   },
                  {"code":"KH-7", "value" :"Kampot"   },
                  {"code":"KH-8", "value" :"Kandal"   },
                  {"code":"KH-9", "value" :"Koh Kong"   },
                  {"code":"KI-G", "value" :"Gilbert Islands"   },
                  {"code":"KI-L", "value" :"Line Islands"   },
                  {"code":"KI-P", "value" :"Phoenix Islands"   },
                  {"code":"KM-A", "value" :"Anjouan"},
                  {"code":"KM-G", "value" :"Grande Comore"},
                  {"code":"KM-M", "value" :"Mohéli" },
                  {"code":"KN-01", "value" :"Christ Church Nichola Town"   },
                  {"code":"KN-02", "value" :"Saint Anne Sandy Point"   },
                  {"code":"KN-03", "value" :"Saint George Basseterre"   },
                  {"code":"KN-04", "value" :"Saint George Gingerland"   },
                  {"code":"KN-05", "value" :"Saint James Windward"   },
                  {"code":"KN-06", "value" :"Saint John Capisterre"   },
                  {"code":"KN-07", "value" :"Saint John Figtree"   },
                  {"code":"KN-08", "value" :"Saint Mary Cayon"   },
                  {"code":"KN-09", "value" :"Saint Paul Capisterre"   },
                  {"code":"KN-10", "value" :"Saint Paul Charlestown"   },
                  {"code":"KN-11", "value" :"Saint Peter Basseterre"   },
                  {"code":"KN-12", "value" :"Saint Thomas Lowland"   },
                  {"code":"KN-13", "value" :"Saint Thomas Middle Island"   },
                  {"code":"KN-15", "value" :"Trinity Palmetto Point"   },
                  {"code":"KP-CHA", "value" :"Chagang"   },
                  {"code":"KP-HAB", "value" :"North Hamgyong"   },
                  {"code":"KP-HAN", "value" :"South Hamgyong"   },
                  {"code":"KP-HWB", "value" :"North Hwanghae"   },
                  {"code":"KP-HWN", "value" :"South Hwanghae"   },
                  {"code":"KP-KAE", "value" :"Kaesong"   },
                  {"code":"KP-KAN", "value" :"Kangwon"   },
                  {"code":"KP-NAJ", "value" :"Rason"   },
                  {"code":"KP-NAM", "value" :"Nampho"   },
                  {"code":"KP-PYB", "value" :"North Pyongan"   },
                  {"code":"KP-PYN", "value" :"South Pyongan"   },
                  {"code":"KP-PYO", "value" :"Pyongyang"   },
                  {"code":"KP-YAN", "value" :"Ryanggang"   },
                  {"code":"KR-11", "value" :"Seoul"   },
                  {"code":"KR-26", "value" :"Busan"   },
                  {"code":"KR-27", "value" :"Daegu"   },
                  {"code":"KR-28", "value" :"Incheon"   },
                  {"code":"KR-29", "value" :"Gwangju"   },
                  {"code":"KR-30", "value" :"Daejeon"   },
                  {"code":"KR-31", "value" :"Ulsan"   },
                  {"code":"KR-41", "value" :"Gyeonggi-do"   },
                  {"code":"KR-42", "value" :"Gangwon-do"   },
                  {"code":"KR-43", "value" :"Chungcheongbuk-do"   },
                  {"code":"KR-44", "value" :"Chungcheongnam-do"   },
                  {"code":"KR-45", "value" :"Jeollabuk-do"   },
                  {"code":"KR-46", "value" :"Jeollanam-do"   },
                  {"code":"KR-47", "value" :"Gyeongsangbuk-do"   },
                  {"code":"KR-48", "value" :"Gyeongsangnam-do"   },
                  {"code":"KR-49", "value" :"Jeju-do"   },
                  {"code":"KW-AH", "value" :"Al Ahmadi"   },
                  {"code":"KW-FA", "value" :"Al Farwaniyah"   },
                  {"code":"KW-HA", "value" :"Hawalli"   },
                  {"code":"KW-JA", "value" :"Al Jahra"   },
                  {"code":"KW-KU", "value" :"Al Asimah"   },
                  {"code":"KW-MU", "value" :"Mubarak Al-Kabeer"   },
                  {"code":"KY-01", "value" :"Bodden Town"   },
                  {"code":"KY-02", "value" :"Cayman Brac"   },
                  {"code":"KY-03", "value" :"East End"   },
                  {"code":"KY-04", "value" :"George Town"   },
                  {"code":"KY-05", "value" :"Little Cayman"   },
                  {"code":"KY-06", "value" :"North Side"   },
                  {"code":"KY-07", "value" :"West Bay"   },
                  {"code":"KZ-AKM", "value" :"Akmola"   },
                  {"code":"KZ-AKT", "value" :"Aktobe"   },
                  {"code":"KZ-ALA", "value" :"Almaty City"   },
                  {"code":"KZ-ALM", "value" :"Almaty Region"   },
                  {"code":"KZ-AST", "value" :"Astana City"   },
                  {"code":"KZ-ATY", "value" :"Atyrau"   },
                  {"code":"KZ-KAR", "value" :"Karagandy"   },
                  {"code":"KZ-KUS", "value" :"Kostanay"   },
                  {"code":"KZ-KZY", "value" :"Kyzylorda"   },
                  {"code":"KZ-MAN", "value" :"Mangystau Region"   },
                  {"code":"KZ-PAV", "value" :"Pavlodar"   },
                  {"code":"KZ-SEV", "value" :"North Kazakhstan"   },
                  {"code":"KZ-VOS", "value" :"East Kazakhstan"   },
                  {"code":"KZ-YUZ", "value" :"South Kazakhstan"   },
                  {"code":"KZ-ZAP", "value" :"West Kazakhstan"   },
                  {"code":"KZ-ZHA", "value" :"Zhambyl"   },
                  {"code":"LA-AT", "value" :"Attapu"   },
                  {"code":"LA-BK", "value" :"Bokèo"   },
                  {"code":"LA-BL", "value" :"Bolikhamxai"   },
                  {"code":"LA-CH", "value" :"Champasak"   },
                  {"code":"LA-HO", "value" :"Houaphan"   },
                  {"code":"LA-KH", "value" :"Khammouan"   },
                  {"code":"LA-LM", "value" :"Louang Namtha"   },
                  {"code":"LA-LP", "value" :"Louangphabang"   },
                  {"code":"LA-OU", "value" :"Oudômxai"   },
                  {"code":"LA-PH", "value" :"Phôngsali"   },
                  {"code":"LA-SL", "value" :"Salavan"   },
                  {"code":"LA-SV", "value" :"Savannakhét"   },
                  {"code":"LA-VI", "value" :"Vientiane Province"   },
                  {"code":"LA-VT", "value" :"Vientiane Prefecture"   },
                  {"code":"LA-XA", "value" :"Sainyabuli"   },
                  {"code":"LA-XE", "value" :"Sekong"   },
                  {"code":"LA-XI", "value" :"Xiangkhouang"   },
                  {"code":"LA-XN", "value" :"Xaisomboun"   },
                  {"code":"LB-AS", "value" :"North"   },
                  {"code":"LB-BA", "value" :"Beirut"   },
                  {"code":"LB-BI", "value" :"Beqaa"   },
                  {"code":"LB-JA", "value" :"South"   },
                  {"code":"LB-JL", "value" :"Mount Lebanon"   },
                  {"code":"LB-NA", "value" :"Nabatieh"   },
                  {"code":"LC-01", "value" :"Anse la Raye"   },
                  {"code":"LC-02", "value" :"Castries"  },
                  {"code":"LC-03", "value" :"Choiseul"  },
                  {"code":"LC-04", "value" :"Dauphin"  },
                  {"code":"LC-05", "value" :"Dennery"  },
                  {"code":"LC-06", "value" :"Gros Islet"  },
                  {"code":"LC-07", "value" :"Laborie"  },
                  {"code":"LC-08", "value" :"Micoud"  },
                  {"code":"LC-09", "value" :"Praslin"  },
                  {"code":"LC-10", "value" :"Soufrière"  },
                  {"code":"LC-11", "value" :"Vieux Fort"  },
                  {"code":"LI-01", "value" :"Balzers"   },
                  {"code":"LI-02", "value" :"Eschen"   },
                  {"code":"LI-03", "value" :"Gamprin"   },
                  {"code":"LI-04", "value" :"Mauren"   },
                  {"code":"LI-05", "value" :"Planken"   },
                  {"code":"LI-06", "value" :"Ruggell"   },
                  {"code":"LI-07", "value" :"Schaan"   },
                  {"code":"LI-08", "value" :"Schellenberg"   },
                  {"code":"LI-09", "value" :"Triesen"   },
                  {"code":"LI-10", "value" :"Triesenberg"   },
                  {"code":"LI-11", "value" :"Vaduz"   },
                  {"code":"LK-11", "value" :"Colombo"   },
                  {"code":"LK-12", "value" :"Gampaha"   },
                  {"code":"LK-13", "value" :"Kalutara"   },
                  {"code":"LK-21", "value" :"Kandy"   },
                  {"code":"LK-22", "value" :"Matale"   },
                  {"code":"LK-23", "value" :"Nuwara Eliya"   },
                  {"code":"LK-31", "value" :"Galle"   },
                  {"code":"LK-32", "value" :"Matara"   },
                  {"code":"LK-33", "value" :"Hambantota"   },
                  {"code":"LK-41", "value" :"Jaffna"   },
                  {"code":"LK-42", "value" :"Kilinochchi"   },
                  {"code":"LK-43", "value" :"Mannar"   },
                  {"code":"LK-44", "value" :"Vavuniya"   },
                  {"code":"LK-45", "value" :"Mullaitivu"   },
                  {"code":"LK-51", "value" :"Batticaloa"   },
                  {"code":"LK-52", "value" :"Ampara"   },
                  {"code":"LK-53", "value" :"Trincomalee"   },
                  {"code":"LK-61", "value" :"Kurunegala"   },
                  {"code":"LK-62", "value" :"Puttalam"   },
                  {"code":"LK-71", "value" :"Anuradhapura"   },
                  {"code":"LK-72", "value" :"Polonnaruwa"   },
                  {"code":"LK-81", "value" :"Badulla"   },
                  {"code":"LK-82", "value" :"Moneragala"   },
                  {"code":"LK-91", "value" :"Ratnapura"   },
                  {"code":"LK-92", "value" :"Kegalle"   },
                  {"code":"LR-BG", "value" :"Bong"   },
                  {"code":"LR-BM", "value" :"Bomi"   },
                  {"code":"LR-CM", "value" :"Grand Cape Mount"   },
                  {"code":"LR-GB", "value" :"Grand Bassa"   },
                  {"code":"LR-GG", "value" :"Grand Gedeh"   },
                  {"code":"LR-GK", "value" :"Grand Kru"   },
                  {"code":"LR-GP", "value" :"Gbarpolu"   },
                  {"code":"LR-LO", "value" :"Lofa"   },
                  {"code":"LR-MG", "value" :"Margibi"   },
                  {"code":"LR-MO", "value" :"Montserrado"   },
                  {"code":"LR-MY", "value" :"Maryland"   },
                  {"code":"LR-NI", "value" :"Nimba"   },
                  {"code":"LR-RG", "value" :"River Gee"   },
                  {"code":"LR-RI", "value" :"Rivercess"   },
                  {"code":"LR-SI", "value" :"Sinoe"   },
                  {"code":"LS-A", "value" :"Maseru"   },
                  {"code":"LS-B", "value" :"Butha-Buthe"   },
                  {"code":"LS-C", "value" :"Leribe"   },
                  {"code":"LS-D", "value" :"Berea"   },
                  {"code":"LS-E", "value" :"Mafeteng"   },
                  {"code":"LS-F", "value" :"Mohale's Hoek"   },
                  {"code":"LS-G", "value" :"Quthing"   },
                  {"code":"LS-H", "value" :"Qacha's Nek"   },
                  {"code":"LS-J", "value" :"Mokhotlong"   },
                  {"code":"LS-K", "value" :"Thaba-Tseka"   },
                  {"code":"LT-AL", "value" :"Alytaus"   },
                  {"code":"LT-KL", "value" :"Klaipėdos"   },
                  {"code":"LT-KU", "value" :"Kauno"   },
                  {"code":"LT-MR", "value" :"Marijampolės"   },
                  {"code":"LT-PN", "value" :"Panevėžio"   },
                  {"code":"LT-SA", "value" :"Šiaulių"   },
                  {"code":"LT-TA", "value" :"Tauragės"   },
                  {"code":"LT-TE", "value" :"Telšių"   },
                  {"code":"LT-UT", "value" :"Utenos"   },
                  {"code":"LT-VL", "value" :"Vilniaus"   },
                  {"code":"LU-D", "value" :"Diekirch"   },
                  {"code":"LU-G", "value" :"Grevenmacher"   },
                  {"code":"LU-L", "value" :"Luxembourg"   },
                  {"code":"LV-AI", "value" :"Aizkraukles"   },
                  {"code":"LV-AL", "value" :"Alūksnes"   },
                  {"code":"LV-BL", "value" :"Balvu"   },
                  {"code":"LV-BU", "value" :"Bauskas"   },
                  {"code":"LV-CE", "value" :"Cēsu"   },
                  {"code":"LV-DA", "value" :"Daugavpils"   },
                  {"code":"LV-DGV", "value" :"Daugavpils"   },
                  {"code":"LV-DO", "value" :"Dobeles"   },
                  {"code":"LV-GU", "value" :"Gulbenes"   },
                  {"code":"LV-JEL", "value" :"Jelgava"   },
                  {"code":"LV-JK", "value" :"Jēkabpils"   },
                  {"code":"LV-JL", "value" :"Jelgavas"   },
                  {"code":"LV-JUR", "value" :"Jūrmala"   },
                  {"code":"LV-KR", "value" :"Krāslavas"   },
                  {"code":"LV-KU", "value" :"Kuldīgas"   },
                  {"code":"LV-LE", "value" :"Liepājas"   },
                  {"code":"LV-LM", "value" :"Limbažu"   },
                  {"code":"LV-LPX", "value" :"Liepājas"   },
                  {"code":"LV-LU", "value" :"Ludzas"   },
                  {"code":"LV-MA", "value" :"Madonas"   },
                  {"code":"LV-OG", "value" :"Ogres"   },
                  {"code":"LV-PR", "value" :"Preiļu"   },
                  {"code":"LV-RE", "value" :"Rēzeknes"   },
                  {"code":"LV-REZ", "value" :"Rezekne"   },
                  {"code":"LV-RI", "value" :"Rīgas"   },
                  {"code":"LV-RIX", "value" :"Rīga"   },
                  {"code":"LV-SA", "value" :"Saldus"   },
                  {"code":"LV-TA", "value" :"Talsu"   },
                  {"code":"LV-TU", "value" :"Tukuma"   },
                  {"code":"LV-VE", "value" :"Ventspils"   },
                  {"code":"LV-VEN", "value" :"Ventspils"   },
                  {"code":"LV-VK", "value" :"Valkas"   },
                  {"code":"LV-VM", "value" :"Valmieras"   },
                  {"code":"LY-BA", "value" :"Banghazi"   },
                  {"code":"LY-BU", "value" :"Al Butnan"   },
                  {"code":"LY-DR", "value" :"Darnah"   },
                  {"code":"LY-GT", "value" :"Ghat"   },
                  {"code":"LY-JA", "value" :"Al Jabal al Akhdar"   },
                  {"code":"LY-JG", "value" :"Al Jabal al Gharbi"   },
                  {"code":"LY-JI", "value" :"Al Jifarah"   },
                  {"code":"LY-JU", "value" :"Al Jufrah"   },
                  {"code":"LY-KF", "value" :"Al Kufrah"   },
                  {"code":"LY-MB", "value" :"Al Marqab"   },
                  {"code":"LY-MI", "value" :"Misratah"   },
                  {"code":"LY-MJ", "value" :"Al Marj"   },
                  {"code":"LY-MQ", "value" :"Murzuq"   },
                  {"code":"LY-NL", "value" :"Nalut"   },
                  {"code":"LY-NQ", "value" :"An Nuqat al Khams"   },
                  {"code":"LY-SB", "value" :"Sabha"   },
                  {"code":"LY-SR", "value" :"Surt"   },
                  {"code":"LY-TB", "value" :"Tarabulus"   },
                  {"code":"LY-WA", "value" :"Al Wahat"   },
                  {"code":"LY-WD", "value" :"Wadi Al Hayaa"   },
                  {"code":"LY-WS", "value" :"Wadi ash Shati"   },
                  {"code":"LY-ZA", "value" :"Az Zawiyah"   },
                  {"code":"MA-AGD", "value" :"Agadir Ida-Outanane"   },
                  {"code":"MA-AOU", "value" :"Aousserd"   },
                  {"code":"MA-ASZ", "value" :"Assa-Zag"   },
                  {"code":"MA-AZI", "value" :"Azilal"   },
                  {"code":"MA-BEM", "value" :"Beni Mellal"   },
                  {"code":"MA-BER", "value" :"Berkane"   },
                  {"code":"MA-BES", "value" :"Ben Slimane"   },
                  {"code":"MA-BOD", "value" :"Boujdour"   },
                  {"code":"MA-BOM", "value" :"Boulmane"   },
                  {"code":"MA-CAS", "value" :"Casablanca"   },
                  {"code":"MA-CHE", "value" :"Chefchaouen"   },
                  {"code":"MA-CHI", "value" :"Chichaoua"   },
                  {"code":"MA-CHT", "value" :"Chtouka-Aït Baha"   },
                  {"code":"MA-ERR", "value" :"Errachidia"   },
                  {"code":"MA-ESI", "value" :"Essaouira"   },
                  {"code":"MA-ESM", "value" :"Es-Semara"   },
                  {"code":"MA-FAH", "value" :"Fahs-Beni Makada"   },
                  {"code":"MA-FES", "value" :"Fès-Dar-Dbibegh"   },
                  {"code":"MA-FIG", "value" :"Figuig"   },
                  {"code":"MA-GUE", "value" :"Guelmim"   },
                  {"code":"MA-HAJ", "value" :"El Hajeb"   },
                  {"code":"MA-HAO", "value" :"Al Haouz"   },
                  {"code":"MA-HOC", "value" :"Al-Hoceima"   },
                  {"code":"MA-IFR", "value" :"Ifrane"   },
                  {"code":"MA-INE", "value" :"Inezgane-Aït Melloul"   },
                  {"code":"MA-JDI", "value" :"El Jadida"   },
                  {"code":"MA-JRA", "value" :"Jerada"   },
                  {"code":"MA-KEN", "value" :"Kénitra"   },
                  {"code":"MA-KES", "value" :"Kelâat Es-Sraghna"   },
                  {"code":"MA-KHE", "value" :"Khémisset"   },
                  {"code":"MA-KHN", "value" :"Khénifra"   },
                  {"code":"MA-KHO", "value" :"Khouribga"   },
                  {"code":"MA-LAA", "value" :"Laâyoune"   },
                  {"code":"MA-LAR", "value" :"Larache"   },
                  {"code":"MA-MED", "value" :"Médiouna"   },
                  {"code":"MA-MEK", "value" :"Meknès"   },
                  {"code":"MA-MMD", "value" :"Marrakech-Médina"   },
                  {"code":"MA-MMN", "value" :"Marrakech-Ménara"   },
                  {"code":"MA-MOH", "value" :"Mohammédia"   },
                  {"code":"MA-MOU", "value" :"Moulay Yacoub"   },
                  {"code":"MA-NAD", "value" :"Nador"   },
                  {"code":"MA-NOU", "value" :"Nouaceur"   },
                  {"code":"MA-OUA", "value" :"Ouarzazate"   },
                  {"code":"MA-OUD", "value" :"Oued Ed-Dahab-Lagouira"   },
                  {"code":"MA-OUJ", "value" :"Oujda-Angad"   },
                  {"code":"MA-RAB", "value" :"Rabat"   },
                  {"code":"MA-SAF", "value" :"Safi"   },
                  {"code":"MA-SAL", "value" :"Salé"   },
                  {"code":"MA-SEF", "value" :"Sefrou"   },
                  {"code":"MA-SET", "value" :"Settat"   },
                  {"code":"MA-SIK", "value" :"Sidi Kacem"   },
                  {"code":"MA-SKH", "value" :"Skhirat-Témara"   },
                  {"code":"MA-SYB", "value" :"Sidi Youssef Ben Ali"   },
                  {"code":"MA-TAI", "value" :"Taourirt"   },
                  {"code":"MA-TAO", "value" :"Taounate"   },
                  {"code":"MA-TAR", "value" :"Taroudant"   },
                  {"code":"MA-TAT", "value" :"Tata"   },
                  {"code":"MA-TAZ", "value" :"Taza"   },
                  {"code":"MA-TET", "value" :"Tétouan"   },
                  {"code":"MA-TIZ", "value" :"Tiznit"   },
                  {"code":"MA-TNG", "value" :"Tanger-Asilah"   },
                  {"code":"MA-TNT", "value" :"Tan-Tan"   },
                  {"code":"MA-ZAG", "value" :"Zagora"   },
                  {"code":"MD-AN", "value" :"Anenii Noi"   },
                  {"code":"MD-BA", "value" :"Bălţi"   },
                  {"code":"MD-BD", "value" :"Tighina"   },
                  {"code":"MD-BR", "value" :"Briceni"   },
                  {"code":"MD-BS", "value" :"Basarabeasca"   },
                  {"code":"MD-CA", "value" :"Cahul"   },
                  {"code":"MD-CL", "value" :"Călăraşi"   },
                  {"code":"MD-CM", "value" :"Cimişlia"   },
                  {"code":"MD-CR", "value" :"Criuleni"   },
                  {"code":"MD-CS", "value" :"Căuşeni"   },
                  {"code":"MD-CT", "value" :"Cantemir"   },
                  {"code":"MD-CU", "value" :"Chişinău"   },
                  {"code":"MD-DO", "value" :"Donduşeni"   },
                  {"code":"MD-DR", "value" :"Drochia"   },
                  {"code":"MD-DU", "value" :"Dubăsari"   },
                  {"code":"MD-ED", "value" :"Edineţ"   },
                  {"code":"MD-FA", "value" :"Făleşti"   },
                  {"code":"MD-FL", "value" :"Floreşti"   },
                  {"code":"MD-GA", "value" :"Gagauzia"   },
                  {"code":"MD-GL", "value" :"Glodeni"   },
                  {"code":"MD-HI", "value" :"Hînceşti"   },
                  {"code":"MD-IA", "value" :"Ialoveni"   },
                  {"code":"MD-LE", "value" :"Leova"   },
                  {"code":"MD-NI", "value" :"Nisporeni"   },
                  {"code":"MD-OC", "value" :"Ocniţa"   },
                  {"code":"MD-OR", "value" :"Orhei"   },
                  {"code":"MD-RE", "value" :"Rezina"   },
                  {"code":"MD-RI", "value" :"Rîşcani"   },
                  {"code":"MD-SD", "value" :"Şoldăneşti"   },
                  {"code":"MD-SI", "value" :"Sîngerei"   },
                  {"code":"MD-SO", "value" :"Soroca"   },
                  {"code":"MD-ST", "value" :"Străşeni"   },
                  {"code":"MD-SV", "value" :"Ştefan Vodă"   },
                  {"code":"MD-TA", "value" :"Taraclia"   },
                  {"code":"MD-TE", "value" :"Teleneşti"   },
                  {"code":"MD-UN", "value" :"Ungheni"   },
                  {"code":"ME-01", "value" :"Andrijevica"   },
                  {"code":"ME-02", "value" :"Bar"   },
                  {"code":"ME-03", "value" :"Berane"   },
                  {"code":"ME-04", "value" :"Bijelo Polje"   },
                  {"code":"ME-05", "value" :"Budva"   },
                  {"code":"ME-06", "value" :"Cetinje"   },
                  {"code":"ME-07", "value" :"Danilovgrad"   },
                  {"code":"ME-08", "value" :"Herceg Novi"   },
                  {"code":"ME-09", "value" :"Kolašin"   },
                  {"code":"ME-10", "value" :"Kotor"   },
                  {"code":"ME-11", "value" :"Mojkovac"   },
                  {"code":"ME-12", "value" :"Nikšić"   },
                  {"code":"ME-13", "value" :"Plav"   },
                  {"code":"ME-14", "value" :"Pljevlja"   },
                  {"code":"ME-15", "value" :"Plužine"   },
                  {"code":"ME-16", "value" :"Podgorica"   },
                  {"code":"ME-17", "value" :"Rožaje"   },
                  {"code":"ME-18", "value" :"Šavnik"   },
                  {"code":"ME-19", "value" :"Tivat"   },
                  {"code":"ME-20", "value" :"Ulcinj"   },
                  {"code":"ME-21", "value" :"Žabljak"   },
                  {"code":"MG-A", "value" :"Toamasina"   },
                  {"code":"MG-D", "value" :"Antsiranana"   },
                  {"code":"MG-F", "value" :"Fianarantsoa"   },
                  {"code":"MG-M", "value" :"Mahajanga"   },
                  {"code":"MG-T", "value" :"Antananarivo"   },
                  {"code":"MG-U", "value" :"Toliara"   },
                  {"code":"MH-ALK", "value" :"Ailuk"   },
                  {"code":"MH-ALL", "value" :"Ailinglapalap"   },
                  {"code":"MH-ARN", "value" :"Arno"   },
                  {"code":"MH-AUR", "value" :"Aur"   },
                  {"code":"MH-EBO", "value" :"Ebon"   },
                  {"code":"MH-ENI", "value" :"Eniwetok"   },
                  {"code":"MH-JAL", "value" :"Jaluit"   },
                  {"code":"MH-KIL", "value" :"Kili"   },
                  {"code":"MH-KWA", "value" :"Kwajalein"   },
                  {"code":"MH-LAE", "value" :"Lae"   },
                  {"code":"MH-LIB", "value" :"Lib"   },
                  {"code":"MH-LIK", "value" :"Likiep"   },
                  {"code":"MH-MAJ", "value" :"Majuro"   },
                  {"code":"MH-MAL", "value" :"Maloelap"   },
                  {"code":"MH-MEJ", "value" :"Mejit"   },
                  {"code":"MH-MIL", "value" :"Mili"   },
                  {"code":"MH-NMK", "value" :"Namorik"   },
                  {"code":"MH-NMU", "value" :"Namu"   },
                  {"code":"MH-RON", "value" :"Rongelap"   },
                  {"code":"MH-UJA", "value" :"Ujae"   },
                  {"code":"MH-UJL", "value" :"Ujelang"   },
                  {"code":"MH-UTI", "value" :"Utirik"   },
                  {"code":"MH-WTH", "value" :"Wotho"   },
                  {"code":"MH-WTJ", "value" :"Wotje"   },
                  {"code":"MK-AD", "value" :"Aerodrom"   },
                  {"code":"MK-AJ", "value" :"Saraj"   },
                  {"code":"MK-AR", "value" :"Aračinovo"   },
                  {"code":"MK-AV", "value" :"Kavadarci"   },
                  {"code":"MK-BG", "value" :"Bogdanci"   },
                  {"code":"MK-BN", "value" :"Brvenica"   },
                  {"code":"MK-BR", "value" :"Berovo"   },
                  {"code":"MK-BS", "value" :"Bosilovo"   },
                  {"code":"MK-BU", "value" :"Butel"   },
                  {"code":"MK-CA", "value" :"Čaška"   },
                  {"code":"MK-CE", "value" :"Centar"   },
                  {"code":"MK-CH", "value" :"Češinovo-Obleševo"   },
                  {"code":"MK-CI", "value" :"Čair"   },
                  {"code":"MK-CS", "value" :"Čučer-Sandevo"   },
                  {"code":"MK-CZ", "value" :"Centar Župa"   },
                  {"code":"MK-DA", "value" :"Debarca"   },
                  {"code":"MK-DB", "value" :"Debar"   },
                  {"code":"MK-DE", "value" :"Dolneni"   },
                  {"code":"MK-DK", "value" :"Demir Kapija"   },
                  {"code":"MK-DL", "value" :"Delčevo"   },
                  {"code":"MK-DM", "value" :"Demir Hisar"   },
                  {"code":"MK-DR", "value" :"Drugovo"   },
                  {"code":"MK-ET", "value" :"Tetovo"   },
                  {"code":"MK-GB", "value" :"Gazi Baba"   },
                  {"code":"MK-GP", "value" :"Gjorče Petrov"   },
                  {"code":"MK-GR", "value" :"Gradsko"   },
                  {"code":"MK-GT", "value" :"Gostivar"   },
                  {"code":"MK-GV", "value" :"Gevgelija"   },
                  {"code":"MK-IL", "value" :"Ilinden"   },
                  {"code":"MK-JG", "value" :"Jegunovce"   },
                  {"code":"MK-KB", "value" :"Karbinci"   },
                  {"code":"MK-KG", "value" :"Krivogaštani"   },
                  {"code":"MK-KH", "value" :"Kicevo"   },
                  {"code":"MK-KN", "value" :"Konče"   },
                  {"code":"MK-KS", "value" :"Kruševo"   },
                  {"code":"MK-KX", "value" :"Karpoš"   },
                  {"code":"MK-KY", "value" :"Kratovo"   },
                  {"code":"MK-KZ", "value" :"Kriva Palanka"   },
                  {"code":"MK-LI", "value" :"Lipkovo"   },
                  {"code":"MK-LO", "value" :"Lozovo"   },
                  {"code":"MK-MD", "value" :"Makedonski Brod"   },
                  {"code":"MK-MG", "value" :"Mogila"   },
                  {"code":"MK-MK", "value" :"Makedonska Kamenica"   },
                  {"code":"MK-MR", "value" :"Mavrovo and Rostuša"   },
                  {"code":"MK-NA", "value" :"Staro Nagoričane"   },
                  {"code":"MK-NG", "value" :"Negotino"   },
                  {"code":"MK-NI", "value" :"Vinica"   },
                  {"code":"MK-NS", "value" :"Novo Selo"   },
                  {"code":"MK-NV", "value" :"Novaci"   },
                  {"code":"MK-OC", "value" :"Kocani"   },
                  {"code":"MK-OD", "value" :"Ohrid"   },
                  {"code":"MK-OS", "value" :"Oslomej"   },
                  {"code":"MK-PE", "value" :"Petrovec"   },
                  {"code":"MK-PH", "value" :"Pehčevo"   },
                  {"code":"MK-PN", "value" :"Plasnica"   },
                  {"code":"MK-PP", "value" :"Prilep"   },
                  {"code":"MK-PT", "value" :"Probištip"   },
                  {"code":"MK-RE", "value" :"Resen"   },
                  {"code":"MK-RM", "value" :"Rosoman"   },
                  {"code":"MK-RN", "value" :"Rankovce"   },
                  {"code":"MK-RU", "value" :"Strumica"   },
                  {"code":"MK-RV", "value" :"Radoviš"   },
                  {"code":"MK-SD", "value" :"Doјran"   },
                  {"code":"MK-SL", "value" :"Sveti Nikole"   },
                  {"code":"MK-SO", "value" :"Šuto Orizari"   },
                  {"code":"MK-SS", "value" :"Sopište"   },
                  {"code":"MK-ST", "value" :"Štip"   },
                  {"code":"MK-SU", "value" :"Studeničani"   },
                  {"code":"MK-TL", "value" :"Bitola"   },
                  {"code":"MK-TR", "value" :"Tearce"   },
                  {"code":"MK-UG", "value" :"Struga"   },
                  {"code":"MK-UM", "value" :"Kumanovo"   },
                  {"code":"MK-VA", "value" :"Valandovo"   },
                  {"code":"MK-VC", "value" :"Vraneštica"   },
                  {"code":"MK-VD", "value" :"Kisela Voda"   },
                  {"code":"MK-VE", "value" :"Veles"   },
                  {"code":"MK-VH", "value" :"Vrapčište"   },
                  {"code":"MK-VJ", "value" :"Bogovinje"   },
                  {"code":"MK-VL", "value" :"Vasilevo"   },
                  {"code":"MK-VV", "value" :"Vevčani"   },
                  {"code":"MK-ZA", "value" :"Zajas"   },
                  {"code":"MK-ZE", "value" :"Želino"   },
                  {"code":"MK-ZK", "value" :"Zelenikovo"   },
                  {"code":"MK-ZR", "value" :"Zrnovci"   },
                  {"code":"ML-1", "value" :"Kayes"   },
                  {"code":"ML-2", "value" :"Koulikoro"   },
                  {"code":"ML-3", "value" :"Sikasso"   },
                  {"code":"ML-4", "value" :"Ségou"   },
                  {"code":"ML-5", "value" :"Mopti"   },
                  {"code":"ML-6", "value" :"Tombouctou"   },
                  {"code":"ML-7", "value" :"Gao"   },
                  {"code":"ML-8", "value" :"Kidal"   },
                  {"code":"ML-BKO", "value" :"Bamako"   },
                  {"code":"MM-01", "value" :"Sagaing"   },
                  {"code":"MM-02", "value" :"Bago"   },
                  {"code":"MM-03", "value" :"Magway"   },
                  {"code":"MM-04", "value" :"Mandalay"   },
                  {"code":"MM-05", "value" :"Tanintharyi"   },
                  {"code":"MM-06", "value" :"Yangon"   },
                  {"code":"MM-07", "value" :"Ayeyarwady"   },
                  {"code":"MM-11", "value" :"Kachin"   },
                  {"code":"MM-12", "value" :"Kayah"   },
                  {"code":"MM-13", "value" :"Kayin"   },
                  {"code":"MM-14", "value" :"Chin"   },
                  {"code":"MM-15", "value" :"Mon"   },
                  {"code":"MM-16", "value" :"Rakhine"   },
                  {"code":"MM-17", "value" :"Shan"   },
                  {"code":"MN-035", "value" :"Orhon"   },
                  {"code":"MN-037", "value" :"Darhan-Uul"   },
                  {"code":"MN-039", "value" :"Hentii"   },
                  {"code":"MN-041", "value" :"Huvsgul"   },
                  {"code":"MN-043", "value" :"Hovd"   },
                  {"code":"MN-046", "value" :"Uvs"   },
                  {"code":"MN-047", "value" :"Tuv"   },
                  {"code":"MN-049", "value" :"Selenge"   },
                  {"code":"MN-051", "value" :"Syhbaatar"   },
                  {"code":"MN-053", "value" :"Umnugovi"   },
                  {"code":"MN-055", "value" :"Uvurhangai"   },
                  {"code":"MN-057", "value" :"Zavhan"   },
                  {"code":"MN-059", "value" :"Dundgovi"   },
                  {"code":"MN-061", "value" :"Dornod"   },
                  {"code":"MN-063", "value" :"Dornogovi"   },
                  {"code":"MN-064", "value" :"Govisymber"   },
                  {"code":"MN-065", "value" :"Govi-Altai"   },
                  {"code":"MN-067", "value" :"Bulgan"   },
                  {"code":"MN-069", "value" :"Bayunhongor"   },
                  {"code":"MN-071", "value" :"Bayun-Ulgii"   },
                  {"code":"MN-073", "value" :"Arhangai"   },
                  {"code":"MN-1", "value" :"Ulaanbaatar"   },
                  {"code":"MR-01", "value" :"Hodh ech Chargui"   },
                  {"code":"MR-02", "value" :"Hodh el Gharbi"   },
                  {"code":"MR-03", "value" :"Assaba"   },
                  {"code":"MR-04", "value" :"Gorgol"   },
                  {"code":"MR-05", "value" :"Brakna"   },
                  {"code":"MR-06", "value" :"Trarza"   },
                  {"code":"MR-07", "value" :"Adrar"   },
                  {"code":"MR-08", "value" :"Dakhlet Nouâdhibou"   },
                  {"code":"MR-09", "value" :"Tagant"   },
                  {"code":"MR-10", "value" :"Guidimaka"   },
                  {"code":"MR-11", "value" :"Tiris Zemmour"   },
                  {"code":"MR-12", "value" :"Inchiri"   },
                  {"code":"MR-NKC", "value" :"Nouakchott"   },
                  {"code":"MT-01", "value" :"Attard"   },
                  {"code":"MT-02", "value" :"Balzan"   },
                  {"code":"MT-03", "value" :"Birgu"   },
                  {"code":"MT-04", "value" :"Birkirkara"   },
                  {"code":"MT-05", "value" :"Birzebbuga"   },
                  {"code":"MT-06", "value" :"Bormla"   },
                  {"code":"MT-07", "value" :"Dingli"   },
                  {"code":"MT-08", "value" :"Fgura"   },
                  {"code":"MT-09", "value" :"Floriana"   },
                  {"code":"MT-10", "value" :"Fontana"   },
                  {"code":"MT-11", "value" :"Gudja"   },
                  {"code":"MT-12", "value" :"Gzira"   },
                  {"code":"MT-13", "value" :"Għajnsielem"   },
                  {"code":"MT-14", "value" :"Għarb"   },
                  {"code":"MT-15", "value" :"Għargħur"   },
                  {"code":"MT-16", "value" :"Għasri"   },
                  {"code":"MT-17", "value" :"Għaxaq"   },
                  {"code":"MT-18", "value" :"Ħamrun"   },
                  {"code":"MT-19", "value" :"Iklin"   },
                  {"code":"MT-20", "value" :"Isla"   },
                  {"code":"MT-21", "value" :"Kalkara"   },
                  {"code":"MT-22", "value" :"Kercem"   },
                  {"code":"MT-23", "value" :"Kirkop"   },
                  {"code":"MT-24", "value" :"Lija"   },
                  {"code":"MT-25", "value" :"Luqa"   },
                  {"code":"MT-26", "value" :"Marsa"   },
                  {"code":"MT-27", "value" :"Marsaskala"   },
                  {"code":"MT-28", "value" :"Marsaxlokk"   },
                  {"code":"MT-29", "value" :"Mdina"   },
                  {"code":"MT-30", "value" :"Mellieħa"   },
                  {"code":"MT-31", "value" :"Mgarr"   },
                  {"code":"MT-32", "value" :"Mosta"   },
                  {"code":"MT-33", "value" :"Mqabba"   },
                  {"code":"MT-34", "value" :"Msida"   },
                  {"code":"MT-35", "value" :"Mtarfa"   },
                  {"code":"MT-36", "value" :"Munxar"   },
                  {"code":"MT-37", "value" :"Nadur"   },
                  {"code":"MT-38", "value" :"Naxxar"   },
                  {"code":"MT-39", "value" :"Paola"   },
                  {"code":"MT-40", "value" :"Pembroke"   },
                  {"code":"MT-41", "value" :"Pietà"   },
                  {"code":"MT-42", "value" :"Qala"   },
                  {"code":"MT-43", "value" :"Qormi"   },
                  {"code":"MT-44", "value" :"Qrendi"   },
                  {"code":"MT-45", "value" :"Rabat (Għawdex)"   },
                  {"code":"MT-46", "value" :"Rabat (Malta)"   },
                  {"code":"MT-47", "value" :"Safi"   },
                  {"code":"MT-48", "value" :"San Ġiljan"   },
                  {"code":"MT-49", "value" :"San Ġwann"   },
                  {"code":"MT-50", "value" :"San Lawrenz"   },
                  {"code":"MT-51", "value" :"San Pawl il-Baħar"   },
                  {"code":"MT-52", "value" :"Sannat"   },
                  {"code":"MT-53", "value" :"Santa Lucija"   },
                  {"code":"MT-54", "value" :"Santa Venera"   },
                  {"code":"MT-55", "value" :"Siggiewi"   },
                  {"code":"MT-56", "value" :"Sliema"   },
                  {"code":"MT-57", "value" :"Swieqi"   },
                  {"code":"MT-58", "value" :"Ta' Xbiex"   },
                  {"code":"MT-59", "value" :"Tarxien"   },
                  {"code":"MT-60", "value" :"Valletta"   },
                  {"code":"MT-61", "value" :"Xagħra"   },
                  {"code":"MT-62", "value" :"Xewkija"   },
                  {"code":"MT-63", "value" :"Xgħajra"   },
                  {"code":"MT-64", "value" :"Żabbar"   },
                  {"code":"MT-65", "value" :"Żebbuġ (Għawdex)"   },
                  {"code":"MT-66", "value" :"Żebbuġ (Malta)"   },
                  {"code":"MT-67", "value" :"Zejtun"   },
                  {"code":"MT-68", "value" :"Zurrieq"   },
                  {"code":"MU-AG", "value" :"Agalega Islands"   },
                  {"code":"MU-BL", "value" :"Black River"   },
                  {"code":"MU-BR", "value" :"Beau Bassin-Rose Hill"   },
                  {"code":"MU-CC", "value" :"Cargados Carajos"   },
                  {"code":"MU-CU", "value" :"Curepipe"   },
                  {"code":"MU-FL", "value" :"Flacq"   },
                  {"code":"MU-GP", "value" :"Grand Port"   },
                  {"code":"MU-MO", "value" :"Moka"   },
                  {"code":"MU-PA", "value" :"Pamplemousses"   },
                  {"code":"MU-PL", "value" :"Port Louis City"   },
                  {"code":"MU-PU", "value" :"Port Louis District"   },
                  {"code":"MU-PW", "value" :"Plaines Wilhems"   },
                  {"code":"MU-QB", "value" :"Quatre Bornes"   },
                  {"code":"MU-RO", "value" :"Rodrigues Island"   },
                  {"code":"MU-RR", "value" :"Rivière du Rempart"   },
                  {"code":"MU-SA", "value" :"Savanne"   },
                  {"code":"MU-VP", "value" :"Vacoas-Phoenix"   },
                  {"code":"MV-00", "value" :"Alif Dhaalu"   },
                  {"code":"MV-01", "value" :"Seenu"   },
                  {"code":"MV-02", "value" :"Alif Alif"   },
                  {"code":"MV-03", "value" :"Lhaviyani"   },
                  {"code":"MV-04", "value" :"Vaavu"   },
                  {"code":"MV-05", "value" :"Laamu"   },
                  {"code":"MV-07", "value" :"Haa Alif"   },
                  {"code":"MV-08", "value" :"Thaa"   },
                  {"code":"MV-12", "value" :"Meemu"   },
                  {"code":"MV-13", "value" :"Raa"   },
                  {"code":"MV-14", "value" :"Faafu"   },
                  {"code":"MV-17", "value" :"Dhaalu Atoll"   },
                  {"code":"MV-20", "value" :"Baa"   },
                  {"code":"MV-23", "value" :"Haa Dhaalu"   },
                  {"code":"MV-24", "value" :"Shaviyani"   },
                  {"code":"MV-25", "value" :"Noonu"   },
                  {"code":"MV-26", "value" :"Kaafu"   },
                  {"code":"MV-27", "value" :"Gaafu Alif"   },
                  {"code":"MV-28", "value" :"Gaafu Dhaalu"   },
                  {"code":"MV-29", "value" :"Gnaviyani"   },
                  {"code":"MV-MLE", "value" :"Malé"   },
                  {"code":"MW-BA", "value" :"Balaka"   },
                  {"code":"MW-BL", "value" :"Blantyre"   },
                  {"code":"MW-CK", "value" :"Chikwawa"   },
                  {"code":"MW-CR", "value" :"Chiradzulu"   },
                  {"code":"MW-CT", "value" :"Chitipa"   },
                  {"code":"MW-DE", "value" :"Dedza"   },
                  {"code":"MW-DO", "value" :"Dowa"   },
                  {"code":"MW-KR", "value" :"Karonga"   },
                  {"code":"MW-KS", "value" :"Kasungu"   },
                  {"code":"MW-LI", "value" :"Lilongwe"   },
                  {"code":"MW-LK", "value" :"Likoma"   },
                  {"code":"MW-MC", "value" :"Mchinji"   },
                  {"code":"MW-MG", "value" :"Mangochi"   },
                  {"code":"MW-MH", "value" :"Machinga"   },
                  {"code":"MW-MU", "value" :"Mulanje"   },
                  {"code":"MW-MW", "value" :"Mwanza"   },
                  {"code":"MW-MZ", "value" :"Mzimba"   },
                  {"code":"MW-NB", "value" :"Nkhata Bay"   },
                  {"code":"MW-NE", "value" :"Neno"   },
                  {"code":"MW-NI", "value" :"Ntchisi"   },
                  {"code":"MW-NK", "value" :"Nkhotakota"   },
                  {"code":"MW-NS", "value" :"Nsanje"   },
                  {"code":"MW-NU", "value" :"Ntcheu"   },
                  {"code":"MW-PH", "value" :"Phalombe"   },
                  {"code":"MW-RU", "value" :"Rumphi"   },
                  {"code":"MW-SA", "value" :"Salima"   },
                  {"code":"MW-TH", "value" :"Thyolo"   },
                  {"code":"MW-ZO", "value" :"Zomba"   },
                  {"code":"MX-AGU", "value" :"Aguascalientes"   },
                  {"code":"MX-BCN", "value" :"Baja California"   },
                  {"code":"MX-BCS", "value" :"Baja California Sur"   },
                  {"code":"MX-CAM", "value" :"Campeche"   },
                  {"code":"MX-CHH", "value" :"Chihuahua"   },
                  {"code":"MX-CHP", "value" :"Chiapas"   },
                  {"code":"MX-COA", "value" :"Coahuila de Zaragoza"   },
                  {"code":"MX-COL", "value" :"Colima"   },
                  {"code":"MX-DIF", "value" :"Distrito Federal"   },
                  {"code":"MX-DUR", "value" :"Durango"   },
                  {"code":"MX-GRO", "value" :"Guerrero"   },
                  {"code":"MX-GUA", "value" :"Guanajuato"   },
                  {"code":"MX-HID", "value" :"Hidalgo"   },
                  {"code":"MX-JAL", "value" :"Jalisco"   },
                  {"code":"MX-MEX", "value" :"México"   },
                  {"code":"MX-MIC", "value" :"Michoacán de Ocampo"   },
                  {"code":"MX-MOR", "value" :"Morelos"   },
                  {"code":"MX-NAY", "value" :"Nayarit"   },
                  {"code":"MX-NLE", "value" :"Nuevo León"   },
                  {"code":"MX-OAX", "value" :"Oaxaca"   },
                  {"code":"MX-PUE", "value" :"Puebla"   },
                  {"code":"MX-QUE", "value" :"Querétaro Arteaga"   },
                  {"code":"MX-ROO", "value" :"Quintana Roo"   },
                  {"code":"MX-SIN", "value" :"Sinaloa"   },
                  {"code":"MX-SLP", "value" :"San Luís Potosí"   },
                  {"code":"MX-SON", "value" :"Sonora"   },
                  {"code":"MX-TAB", "value" :"Tabasco"   },
                  {"code":"MX-TAM", "value" :"Tamaulipas"   },
                  {"code":"MX-TLA", "value" :"Tlaxcala"   },
                  {"code":"MX-VER", "value" :"Veracruz Llave"   },
                  {"code":"MX-YUC", "value" :"Yucatán"   },
                  {"code":"MX-ZAC", "value" :"Zacatecas"   },
                  {"code":"MY-01", "value" :"Johor"   },
                  {"code":"MY-02", "value" :"Kedah"   },
                  {"code":"MY-03", "value" :"Kelantan"   },
                  {"code":"MY-04", "value" :"Melaka"   },
                  {"code":"MY-05", "value" :"Negeri Sembilan"   },
                  {"code":"MY-06", "value" :"Pahang"   },
                  {"code":"MY-07", "value" :"Pulau Pinang"   },
                  {"code":"MY-08", "value" :"Perak"   },
                  {"code":"MY-09", "value" :"Perlis"   },
                  {"code":"MY-10", "value" :"Selangor"   },
                  {"code":"MY-11", "value" :"Terengganu"   },
                  {"code":"MY-12", "value" :"Sabah"   },
                  {"code":"MY-13", "value" :"Sarawak"   },
                  {"code":"MY-14", "value" :"Wilayah Persekutuan Kuala Lumpur"   },
                  {"code":"MY-15", "value" :"Wilayah Persekutuan Labuan"   },
                  {"code":"MY-16", "value" :"Wilayah Persekutuan Putra Jaya"   },
                  {"code":"MZ-A", "value" :"Niassa"   },
                  {"code":"MZ-B", "value" :"Manica"   },
                  {"code":"MZ-G", "value" :"Gaza"   },
                  {"code":"MZ-I", "value" :"Inhambane"   },
                  {"code":"MZ-L", "value" :"Maputo"   },
                  {"code":"MZ-N", "value" :"Nampula"   },
                  {"code":"MZ-P", "value" :"Cabo Delgado"   },
                  {"code":"MZ-Q", "value" :"Zambézia"   },
                  {"code":"MZ-S", "value" :"Sofala"   },
                  {"code":"MZ-T", "value" :"Tete"   },
                  {"code":"NA-CA", "value" :"Caprivi"   },
                  {"code":"NA-ER", "value" :"Erongo"   },
                  {"code":"NA-HA", "value" :"Hardap"   },
                  {"code":"NA-KA", "value" :"Karas"   },
                  {"code":"NA-KH", "value" :"Khomas"   },
                  {"code":"NA-KU", "value" :"Kunene"   },
                  {"code":"NA-OD", "value" :"Otjozondjupa"   },
                  {"code":"NA-OH", "value" :"Omaheke"   },
                  {"code":"NA-OK", "value" :"Okavango"   },
                  {"code":"NA-ON", "value" :"Oshana"   },
                  {"code":"NA-OS", "value" :"Omusati"   },
                  {"code":"NA-OT", "value" :"Oshikoto"   },
                  {"code":"NA-OW", "value" :"Ohangwena"   },
                  {"code":"NE-1", "value" :"Agadez"   },
                  {"code":"NE-2", "value" :"Diffa"   },
                  {"code":"NE-3", "value" :"Dosso"   },
                  {"code":"NE-4", "value" :"Maradi"   },
                  {"code":"NE-5", "value" :"Tahoua"   },
                  {"code":"NE-6", "value" :"Tillabéri"   },
                  {"code":"NE-7", "value" :"Zinder"   },
                  {"code":"NE-8", "value" :"Niamey"   },
                  {"code":"NG-AB", "value" :"Abia"   },
                  {"code":"NG-AD", "value" :"Adamawa"   },
                  {"code":"NG-AK", "value" :"Akwa Ibom"   },
                  {"code":"NG-AN", "value" :"Anambra"   },
                  {"code":"NG-BA", "value" :"Bauchi"   },
                  {"code":"NG-BE", "value" :"Benue"   },
                  {"code":"NG-BO", "value" :"Borno"   },
                  {"code":"NG-BY", "value" :"Bayelsa"   },
                  {"code":"NG-CR", "value" :"Cross River"   },
                  {"code":"NG-DE", "value" :"Delta"   },
                  {"code":"NG-EB", "value" :"Ebonyi"   },
                  {"code":"NG-ED", "value" :"Edo"   },
                  {"code":"NG-EK", "value" :"Ekiti"   },
                  {"code":"NG-EN", "value" :"Enugu"   },
                  {"code":"NG-FC", "value" :"Abuja (FCT)"   },
                  {"code":"NG-GO", "value" :"Gombe"   },
                  {"code":"NG-IM", "value" :"Imo"   },
                  {"code":"NG-JI", "value" :"Jigawa"   },
                  {"code":"NG-KD", "value" :"Kaduna"   },
                  {"code":"NG-KE", "value" :"Kebbi"   },
                  {"code":"NG-KN", "value" :"Kano"   },
                  {"code":"NG-KO", "value" :"Kogi"   },
                  {"code":"NG-KT", "value" :"Katsina"   },
                  {"code":"NG-KW", "value" :"Kwara"   },
                  {"code":"NG-LA", "value" :"Lagos"   },
                  {"code":"NG-NA", "value" :"Nasarawa"   },
                  {"code":"NG-NI", "value" :"Niger"   },
                  {"code":"NG-OG", "value" :"Ogun"   },
                  {"code":"NG-ON", "value" :"Ondo"   },
                  {"code":"NG-OS", "value" :"Osun"   },
                  {"code":"NG-OY", "value" :"Oyo"   },
                  {"code":"NG-PL", "value" :"Plateau"   },
                  {"code":"NG-RI", "value" :"Rivers"   },
                  {"code":"NG-SO", "value" :"Sokoto"   },
                  {"code":"NG-TA", "value" :"Taraba"   },
                  {"code":"NG-YO", "value" :"Yobe"   },
                  {"code":"NG-ZA", "value" :"Zamfara"   },
                  {"code":"NI-AN", "value" :"Atlántico Norte"   },
                  {"code":"NI-AS", "value" :"Atlántico Sur"   },
                  {"code":"NI-BO", "value" :"Boaco"   },
                  {"code":"NI-CA", "value" :"Carazo"   },
                  {"code":"NI-CI", "value" :"Chinandega"   },
                  {"code":"NI-CO", "value" :"Chontales"   },
                  {"code":"NI-ES", "value" :"Estelí"   },
                  {"code":"NI-GR", "value" :"Granada"   },
                  {"code":"NI-JI", "value" :"Jinotega"   },
                  {"code":"NI-LE", "value" :"León"   },
                  {"code":"NI-MD", "value" :"Madriz"   },
                  {"code":"NI-MN", "value" :"Managua"   },
                  {"code":"NI-MS", "value" :"Masaya"   },
                  {"code":"NI-MT", "value" :"Matagalpa"   },
                  {"code":"NI-NS", "value" :"Nueva Segovia"   },
                  {"code":"NI-RI", "value" :"Rivas"   },
                  {"code":"NI-SJ", "value" :"Río San Juan"   },
                  {"code":"NL-DR", "value" :"Drenthe"   },
                  {"code":"NL-FL", "value" :"Flevoland"   },
                  {"code":"NL-FR", "value" :"Friesland"   },
                  {"code":"NL-GE", "value" :"Gelderland"   },
                  {"code":"NL-GR", "value" :"Groningen"   },
                  {"code":"NL-LI", "value" :"Limburg"   },
                  {"code":"NL-NB", "value" :"Noord-Brabant"   },
                  {"code":"NL-NH", "value" :"Noord-Holland"   },
                  {"code":"NL-OV", "value" :"Overijssel"   },
                  {"code":"NL-UT", "value" :"Utrecht"   },
                  {"code":"NL-ZE", "value" :"Zeeland"   },
                  {"code":"NL-ZH", "value" :"Zuid-Holland"   },
                  {"code":"NO-01", "value" :"Østfold"   },
                  {"code":"NO-02", "value" :"Akershus"   },
                  {"code":"NO-03", "value" :"Oslo"   },
                  {"code":"NO-04", "value" :"Hedmark"   },
                  {"code":"NO-05", "value" :"Oppland"   },
                  {"code":"NO-06", "value" :"Buskerud"   },
                  {"code":"NO-07", "value" :"Vestfold"   },
                  {"code":"NO-08", "value" :"Telemark"   },
                  {"code":"NO-09", "value" :"Aust-Agder"   },
                  {"code":"NO-10", "value" :"Vest-Agder"   },
                  {"code":"NO-11", "value" :"Rogaland"   },
                  {"code":"NO-12", "value" :"Hordaland"   },
                  {"code":"NO-14", "value" :"Sogn og Fjordane"   },
                  {"code":"NO-15", "value" :"Møre og Romsdal"   },
                  {"code":"NO-16", "value" :"Sør-Trøndelag"   },
                  {"code":"NO-17", "value" :"Nord-Trøndelag"   },
                  {"code":"NO-18", "value" :"Nordland"   },
                  {"code":"NO-19", "value" :"Troms"   },
                  {"code":"NO-20", "value" :"Finnmark"   },
                  {"code":"NO-21", "value" :"Svalbard"   },
                  {"code":"NO-22", "value" :"Jan Mayen"   },
                  {"code":"NP-BA", "value" :"Bagmati"   },
                  {"code":"NP-BH", "value" :"Bheri"   },
                  {"code":"NP-DH", "value" :"Dhawalagiri"   },
                  {"code":"NP-GA", "value" :"Gandaki"   },
                  {"code":"NP-JA", "value" :"Janakpur"   },
                  {"code":"NP-KA", "value" :"Karnali"   },
                  {"code":"NP-KO", "value" :"Kosi"   },
                  {"code":"NP-LU", "value" :"Lumbini"   },
                  {"code":"NP-MA", "value" :"Mahakali"   },
                  {"code":"NP-ME", "value" :"Mechi"   },
                  {"code":"NP-NA", "value" :"Narayani"   },
                  {"code":"NP-RA", "value" :"Rapti"   },
                  {"code":"NP-SA", "value" :"Sagarmatha"   },
                  {"code":"NP-SE", "value" :"Seti"   },
                  {"code":"NR-01", "value" :"Aiwo"   },
                  {"code":"NR-02", "value" :"Anabar"   },
                  {"code":"NR-03", "value" :"Anetan"   },
                  {"code":"NR-04", "value" :"Anibare"   },
                  {"code":"NR-05", "value" :"Baiti"   },
                  {"code":"NR-06", "value" :"Boe"   },
                  {"code":"NR-07", "value" :"Buada"   },
                  {"code":"NR-08", "value" :"Denigomodu"   },
                  {"code":"NR-09", "value" :"Ewa"   },
                  {"code":"NR-10", "value" :"Ijuw"   },
                  {"code":"NR-11", "value" :"Meneng"   },
                  {"code":"NR-12", "value" :"Nibok"   },
                  {"code":"NR-13", "value" :"Uaboe"   },
                  {"code":"NR-14", "value" :"Yaren"   },
                  {"code":"NZ-AUK", "value" :"Auckland"   },
                  {"code":"NZ-BOP", "value" :"Bay of Plenty"   },
                  {"code":"NZ-CAN", "value" :"Canterbury"   },
                  {"code":"NZ-GIS", "value" :"Gisborne"   },
                  {"code":"NZ-HKB", "value" :"Hawke's Bay"   },
                  {"code":"NZ-MBH", "value" :"Marlborough"   },
                  {"code":"NZ-MWT", "value" :"Manawatu-Wanganui"   },
                  {"code":"NZ-NSN", "value" :"Nelson"   },
                  {"code":"NZ-NTL", "value" :"Northland"   },
                  {"code":"NZ-OTA", "value" :"Otago"   },
                  {"code":"NZ-STL", "value" :"Southland"   },
                  {"code":"NZ-TAS", "value" :"Tasman"   },
                  {"code":"NZ-TKI", "value" :"Taranaki"   },
                  {"code":"NZ-WGN", "value" :"Wellington"   },
                  {"code":"NZ-WKO", "value" :"Waikato"   },
                  {"code":"NZ-WTC", "value" :"West Coast"   },
                  {"code":"OM-BA", "value" :"Al Batinah"   },
                  {"code":"OM-BU", "value" :"Al Buraymi"   },
                  {"code":"OM-DA", "value" :"Ad Dakhiliyah"   },
                  {"code":"OM-MA", "value" :"Masqat"   },
                  {"code":"OM-MU", "value" :"Musandam"   },
                  {"code":"OM-SH", "value" :"Ash Sharqiyah"   },
                  {"code":"OM-WU", "value" :"Al Wustá"   },
                  {"code":"OM-ZA", "value" :"Az Zahirah"   },
                  {"code":"OM-ZU", "value" :"Zhufar"   },
                  {"code":"PA-1", "value" :"Bocas del Toro"   },
                  {"code":"PA-2", "value" :"Coclé"   },
                  {"code":"PA-3", "value" :"Colón"   },
                  {"code":"PA-4", "value" :"Chiriquí"   },
                  {"code":"PA-5", "value" :"Darién"   },
                  {"code":"PA-6", "value" :"Herrera"   },
                  {"code":"PA-7", "value" :"Los Santos"   },
                  {"code":"PA-8", "value" :"Panamá"   },
                  {"code":"PA-9", "value" :"Veraguas"   },
                  {"code":"PE-AMA", "value" :"Amazonas"   },
                  {"code":"PE-ANC", "value" :"Ancash"   },
                  {"code":"PE-APU", "value" :"Apurimac"   },
                  {"code":"PE-ARE", "value" :"Arequipa"   },
                  {"code":"PE-AYA", "value" :"Ayacucho"   },
                  {"code":"PE-CAJ", "value" :"Cajamarca"   },
                  {"code":"PE-CAL", "value" :"Callao"   },
                  {"code":"PE-CUS", "value" :"Cusco"   },
                  {"code":"PE-HUC", "value" :"Huanuco"   },
                  {"code":"PE-HUV", "value" :"Huancavelica"   },
                  {"code":"PE-ICA", "value" :"Ica"   },
                  {"code":"PE-JUN", "value" :"Junín"   },
                  {"code":"PE-LAL", "value" :"La Libertad"   },
                  {"code":"PE-LAM", "value" :"Lambayeque"   },
                  {"code":"PE-LIM", "value" :"Lima"   },
                  {"code":"PE-LOR", "value" :"Loreto"   },
                  {"code":"PE-MDD", "value" :"Madre de Dios"   },
                  {"code":"PE-MOQ", "value" :"Moquegua"   },
                  {"code":"PE-PAS", "value" :"Pasco"   },
                  {"code":"PE-PIU", "value" :"Piura"   },
                  {"code":"PE-PUN", "value" :"Puno"   },
                  {"code":"PE-SAM", "value" :"San Martin"   },
                  {"code":"PE-TAC", "value" :"Tacna"   },
                  {"code":"PE-TUM", "value" :"Tumbes"   },
                  {"code":"PE-UCA", "value" :"Ucayali"   },
                  {"code":"PG-CPK", "value" :"Simbu"   },
                  {"code":"PG-CPM", "value" :"Central"   },
                  {"code":"PG-EBR", "value" :"East New Britain"   },
                  {"code":"PG-EHG", "value" :"Eastern Highlands"   },
                  {"code":"PG-EPW", "value" :"Enga"   },
                  {"code":"PG-ESW", "value" :"East Sepik"   },
                  {"code":"PG-GPK", "value" :"Gulf"   },
                  {"code":"PG-MBA", "value" :"Milne Bay"   },
                  {"code":"PG-MPL", "value" :"Morobe"   },
                  {"code":"PG-MPM", "value" :"Madang"   },
                  {"code":"PG-MRL", "value" :"Manus"   },
                  {"code":"PG-NCD", "value" :"National Capital District"   },
                  {"code":"PG-NIK", "value" :"New Ireland"   },
                  {"code":"PG-NPP", "value" :"Oro"   },
                  {"code":"PG-NSA", "value" :"North Solomons"   },
                  {"code":"PG-SAN", "value" :"Sandaun"   },
                  {"code":"PG-SHM", "value" :"Southern Highlands"   },
                  {"code":"PG-WBK", "value" :"West New Britain"   },
                  {"code":"PG-WHM", "value" :"Western Highlands"   },
                  {"code":"PG-WPD", "value" :"Western"   },
                  {"code":"PH-00", "value" :"National Capital Region (NCR)"   },
                  {"code":"PH-01", "value" :"Ilocos Region (Region I)"   },
                  {"code":"PH-02", "value" :"Cagayan Valley (Region II)"   },
                  {"code":"PH-03", "value" :"Central Luzon (Region III)"   },
                  {"code":"PH-05", "value" :"Bicol Region (Region V)"   },
                  {"code":"PH-06", "value" :"Western Visayas (Region VI)"   },
                  {"code":"PH-07", "value" :"Central Visayas (Region VII)"   },
                  {"code":"PH-08", "value" :"Eastern Visayas (Region VIII)"   },
                  {"code":"PH-09", "value" :"Zamboanga Peninsula (Region IX)"   },
                  {"code":"PH-10", "value" :"Northern Mindanao (Region X)"   },
                  {"code":"PH-11", "value" :"Davao Region (Region XI)"   },
                  {"code":"PH-12", "value" :"Soccsksargen (Region XII)"   },
                  {"code":"PH-13", "value" :"Caraga (Region XIII)"   },
                  {"code":"PH-14", "value" :"Autonomous Region in Muslim Mindanao (ARMM)"   },
                  {"code":"PH-15", "value" :"Cordillera Administrative Region (CAR)"   },
                  {"code":"PH-40", "value" :"Calabarzon (Region IV-A)"   },
                  {"code":"PH-41", "value" :"Mimaropa (Region IV-B)"   },
                  {"code":"PH-ABR", "value" :"Abra"   },
                  {"code":"PH-AGN", "value" :"Agusan del Norte"   },
                  {"code":"PH-AGS", "value" :"Agusan del Sur"   },
                  {"code":"PH-AKL", "value" :"Aklan"   },
                  {"code":"PH-ALB", "value" :"Albay"   },
                  {"code":"PH-ANT", "value" :"Antique"   },
                  {"code":"PH-APA", "value" :"Apayao"   },
                  {"code":"PH-AUR", "value" :"Aurora"   },
                  {"code":"PH-BAN", "value" :"Bataan"   },
                  {"code":"PH-BAS", "value" :"Basilan"   },
                  {"code":"PH-BEN", "value" :"Benguet"   },
                  {"code":"PH-BIL", "value" :"Biliran"   },
                  {"code":"PH-BOH", "value" :"Bohol"   },
                  {"code":"PH-BTG", "value" :"Batangas"   },
                  {"code":"PH-BTN", "value" :"Batanes"   },
                  {"code":"PH-BUK", "value" :"Bukidnon"   },
                  {"code":"PH-BUL", "value" :"Bulacan"   },
                  {"code":"PH-CAG", "value" :"Cagayan"   },
                  {"code":"PH-CAM", "value" :"Camiguin"   },
                  {"code":"PH-CAN", "value" :"Camarines Norte"   },
                  {"code":"PH-CAP", "value" :"Capiz"   },
                  {"code":"PH-CAS", "value" :"Camarines Sur"   },
                  {"code":"PH-CAT", "value" :"Catanduanes"   },
                  {"code":"PH-CAV", "value" :"Cavite"   },
                  {"code":"PH-CEB", "value" :"Cebu"   },
                  {"code":"PH-COM", "value" :"Compostela Valley"   },
                  {"code":"PH-DAO", "value" :"Davao Oriental"   },
                  {"code":"PH-DAS", "value" :"Davao del Sur"   },
                  {"code":"PH-DAV", "value" :"Davao del Norte"   },
                  {"code":"PH-DIN", "value" :"Dinagat Islands"   },
                  {"code":"PH-EAS", "value" :"Eastern Samar"   },
                  {"code":"PH-GUI", "value" :"Guimaras"   },
                  {"code":"PH-IFU", "value" :"Ifugao"   },
                  {"code":"PH-ILI", "value" :"Iloilo"   },
                  {"code":"PH-ILN", "value" :"Ilocos Norte"   },
                  {"code":"PH-ILS", "value" :"Ilocos Sur"   },
                  {"code":"PH-ISA", "value" :"Isabela"   },
                  {"code":"PH-KAL", "value" :"Kalinga"   },
                  {"code":"PH-LAG", "value" :"Laguna"   },
                  {"code":"PH-LAN", "value" :"Lanao del Norte"   },
                  {"code":"PH-LAS", "value" :"Lanao del Sur"   },
                  {"code":"PH-LEY", "value" :"Leyte"   },
                  {"code":"PH-LUN", "value" :"La Union"   },
                  {"code":"PH-MAD", "value" :"Marinduque"   },
                  {"code":"PH-MAG", "value" :"Maguindanao"   },
                  {"code":"PH-MAS", "value" :"Masbate"   },
                  {"code":"PH-MDC", "value" :"Occidental Mindoro"   },
                  {"code":"PH-MDR", "value" :"Oriental Mindoro"   },
                  {"code":"PH-MOU", "value" :"Mountain Province"   },
                  {"code":"PH-MSC", "value" :"Misamis Occidental"   },
                  {"code":"PH-MSR", "value" :"Misamis Oriental"   },
                  {"code":"PH-NCO", "value" :"Cotabato"   },
                  {"code":"PH-NEC", "value" :"Negros Occidental"   },
                  {"code":"PH-NER", "value" :"Negros Oriental"   },
                  {"code":"PH-NSA", "value" :"Northern Samar"   },
                  {"code":"PH-NUE", "value" :"Nueva Ecija"   },
                  {"code":"PH-NUV", "value" :"Nueva Vizcaya"   },
                  {"code":"PH-PAM", "value" :"Pampanga"   },
                  {"code":"PH-PAN", "value" :"Pangasinan"   },
                  {"code":"PH-PLW", "value" :"Palawan"   },
                  {"code":"PH-QUE", "value" :"Quezon"   },
                  {"code":"PH-QUI", "value" :"Quirino"   },
                  {"code":"PH-RIZ", "value" :"Rizal"   },
                  {"code":"PH-ROM", "value" :"Romblon"   },
                  {"code":"PH-SAR", "value" :"Sarangani"   },
                  {"code":"PH-SCO", "value" :"South Cotabato"   },
                  {"code":"PH-SIG", "value" :"Siquijor"   },
                  {"code":"PH-SLE", "value" :"Southern Leyte"   },
                  {"code":"PH-SLU", "value" :"Sulu"   },
                  {"code":"PH-SOR", "value" :"Sorsogon"   },
                  {"code":"PH-SUK", "value" :"Sultan Kudarat"   },
                  {"code":"PH-SUN", "value" :"Surigao del Norte"   },
                  {"code":"PH-SUR", "value" :"Surigao del Sur"   },
                  {"code":"PH-TAR", "value" :"Tarlac"   },
                  {"code":"PH-TAW", "value" :"Tawi-Tawi"   },
                  {"code":"PH-WSA", "value" :"Samar"   },
                  {"code":"PH-ZAN", "value" :"Zamboanga del Norte"   },
                  {"code":"PH-ZAS", "value" :"Zamboanga del Sur"   },
                  {"code":"PH-ZMB", "value" :"Zambales"   },
                  {"code":"PH-ZSI", "value" :"Zamboanga Sibugay"   },
                  {"code":"PK-BA", "value" :"Balochisan"   },
                  {"code":"PK-IS", "value" :"Islamabad"   },
                  {"code":"PK-JK", "value" :"Azad Kashmir"   },
                  {"code":"PK-NA", "value" :"Gilgit-Baltistan"   },
                  {"code":"PK-NW", "value" :"Khyber Pakhtunkhwa"   },
                  {"code":"PK-PB", "value" :"Punjab"   },
                  {"code":"PK-SD", "value" :"Sindh"   },
                  {"code":"PK-TA", "value" :"Federally Administered Tribal Areas"   },
                  {"code":"PL-DS", "value" :"Dolnośląskie"   },
                  {"code":"PL-KP", "value" :"Kujawsko-Pomorskie"   },
                  {"code":"PL-LB", "value" :"Lubuskie"   },
                  {"code":"PL-LD", "value" :"Łódzkie"   },
                  {"code":"PL-LU", "value" :"Lubelskie"   },
                  {"code":"PL-MA", "value" :"Małopolskie"   },
                  {"code":"PL-MZ", "value" :"Mazowieckie"   },
                  {"code":"PL-OP", "value" :"Opolskie"   },
                  {"code":"PL-PD", "value" :"Podlaskie"   },
                  {"code":"PL-PK", "value" :"Podkarpackie"   },
                  {"code":"PL-PM", "value" :"Pomorskie"   },
                  {"code":"PL-SK", "value" :"Świętokrzyskie"   },
                  {"code":"PL-SL", "value" :"Śląskie"   },
                  {"code":"PL-WN", "value" :"Warmińsko-Mazurskie"   },
                  {"code":"PL-WP", "value" :"Wielkopolskie"   },
                  {"code":"PL-ZP", "value" :"Zachodniopomorskie"   },
                  {"code":"PT-01", "value" :"Aveiro"   },
                  {"code":"PT-02", "value" :"Beja"   },
                  {"code":"PT-03", "value" :"Braga"   },
                  {"code":"PT-04", "value" :"Bragança"   },
                  {"code":"PT-05", "value" :"Castelo Branco"   },
                  {"code":"PT-06", "value" :"Coimbra"   },
                  {"code":"PT-07", "value" :"Évora"   },
                  {"code":"PT-08", "value" :"Faro"   },
                  {"code":"PT-09", "value" :"Guarda"   },
                  {"code":"PT-10", "value" :"Leiria"   },
                  {"code":"PT-11", "value" :"Lisboa"   },
                  {"code":"PT-12", "value" :"Portalegre"   },
                  {"code":"PT-13", "value" :"Porto"   },
                  {"code":"PT-14", "value" :"Santarém"   },
                  {"code":"PT-15", "value" :"Setúbal"   },
                  {"code":"PT-16", "value" :"Viana do Castelo"   },
                  {"code":"PT-17", "value" :"Vila Real"   },
                  {"code":"PT-18", "value" :"Viseu"   },
                  {"code":"PT-20", "value" :"Açores"   },
                  {"code":"PT-30", "value" :"Madeira"   },
                  {"code":"PW-002", "value" :"Aimeliik"   },
                  {"code":"PW-004", "value" :"Airai"   },
                  {"code":"PW-010", "value" :"Angaur"   },
                  {"code":"PW-050", "value" :"Hatobohei"   },
                  {"code":"PW-100", "value" :"Kayangel"   },
                  {"code":"PW-150", "value" :"Koror"   },
                  {"code":"PW-212", "value" :"Melekeok"   },
                  {"code":"PW-214", "value" :"Ngaraard"   },
                  {"code":"PW-218", "value" :"Ngarchelong"   },
                  {"code":"PW-222", "value" :"Ngardmau"   },
                  {"code":"PW-224", "value" :"Ngatpang"   },
                  {"code":"PW-226", "value" :"Ngchesar"   },
                  {"code":"PW-227", "value" :"Ngeremlengui"   },
                  {"code":"PW-228", "value" :"Ngiwal"   },
                  {"code":"PW-350", "value" :"Peleliu"   },
                  {"code":"PW-370", "value" :"Sonsorol"   },
                  {"code":"PY-1", "value" :"Concepción"   },
                  {"code":"PY-10", "value" :"Alto Paraná"   },
                  {"code":"PY-11", "value" :"Central"   },
                  {"code":"PY-12", "value" :"Ñeembucú"   },
                  {"code":"PY-13", "value" :"Amambay"   },
                  {"code":"PY-14", "value" :"Canindeyú"   },
                  {"code":"PY-15", "value" :"Presidente Hayes"   },
                  {"code":"PY-16", "value" :"Alto Paraguay"   },
                  {"code":"PY-19", "value" :"Boquerón"   },
                  {"code":"PY-2", "value" :"San Pedro"   },
                  {"code":"PY-3", "value" :"Cordillera"   },
                  {"code":"PY-4", "value" :"Guairá"   },
                  {"code":"PY-5", "value" :"Caaguazú"   },
                  {"code":"PY-6", "value" :"Caazapá"   },
                  {"code":"PY-7", "value" :"Itapúa"   },
                  {"code":"PY-8", "value" :"Misiones"   },
                  {"code":"PY-9", "value" :"Paraguarí"   },
                  {"code":"PY-ASU", "value" :"Asunción - Distrito Capital"   },
                  {"code":"QA-DA", "value" :"Ad Dawhah"   },
                  {"code":"QA-GH", "value" :"Al Ghuwayriyah"   },
                  {"code":"QA-JB", "value" :"Jariyan al Batnah"   },
                  {"code":"QA-JU", "value" :"Al Jumayliyah"   },
                  {"code":"QA-KH", "value" :"Al Khawr"   },
                  {"code":"QA-MS", "value" :"Madinat ash Shamal"   },
                  {"code":"QA-RA", "value" :"Ar Rayyan"   },
                  {"code":"QA-US", "value" :"Umm Salal"   },
                  {"code":"QA-WA", "value" :"Al Wakrah"   },
                  {"code":"RO-AB", "value" :"Alba"   },
                  {"code":"RO-AG", "value" :"Argeş"   },
                  {"code":"RO-AR", "value" :"Arad"   },
                  {"code":"RO-B", "value" :"Bucureşti"   },
                  {"code":"RO-BC", "value" :"Bacău"   },
                  {"code":"RO-BH", "value" :"Bihor"   },
                  {"code":"RO-BN", "value" :"Bistriţa-Năsăud"   },
                  {"code":"RO-BR", "value" :"Brăila"   },
                  {"code":"RO-BT", "value" :"Botoşani"   },
                  {"code":"RO-BV", "value" :"Braşov"   },
                  {"code":"RO-BZ", "value" :"Buzău"   },
                  {"code":"RO-CJ", "value" :"Cluj"   },
                  {"code":"RO-CL", "value" :"Călăraşi"   },
                  {"code":"RO-CS", "value" :"Caraş-Severin"   },
                  {"code":"RO-CT", "value" :"Constanţa"   },
                  {"code":"RO-CV", "value" :"Covasna"   },
                  {"code":"RO-DB", "value" :"Dâmboviţa"   },
                  {"code":"RO-DJ", "value" :"Dolj"   },
                  {"code":"RO-GJ", "value" :"Gorj"   },
                  {"code":"RO-GL", "value" :"Galaţi"   },
                  {"code":"RO-GR", "value" :"Giurgiu"   },
                  {"code":"RO-HD", "value" :"Hunedoara"   },
                  {"code":"RO-HR", "value" :"Harghita"   },
                  {"code":"RO-IF", "value" :"Ilfov"   },
                  {"code":"RO-IL", "value" :"Ialomiţa"   },
                  {"code":"RO-IS", "value" :"Iaşi"   },
                  {"code":"RO-MH", "value" :"Mehedinţi"   },
                  {"code":"RO-MM", "value" :"Maramureş"   },
                  {"code":"RO-MS", "value" :"Mureş"   },
                  {"code":"RO-NT", "value" :"Neamţ"   },
                  {"code":"RO-OT", "value" :"Olt"   },
                  {"code":"RO-PH", "value" :"Prahova"   },
                  {"code":"RO-SB", "value" :"Sibiu"   },
                  {"code":"RO-SJ", "value" :"Sălaj"   },
                  {"code":"RO-SM", "value" :"Satu Mare"   },
                  {"code":"RO-SV", "value" :"Suceava"   },
                  {"code":"RO-TL", "value" :"Tulcea"   },
                  {"code":"RO-TM", "value" :"Timiş"   },
                  {"code":"RO-TR", "value" :"Teleorman"   },
                  {"code":"RO-VL", "value" :"Valcea"   },
                  {"code":"RO-VN", "value" :"Vrancea"   },
                  {"code":"RO-VS", "value" :"Vaslui"   },
                  {"code":"RS-00", "value" :"Beograd"   },
                  {"code":"RS-01", "value" :"Severnobački"   },
                  {"code":"RS-02", "value" :"Srednje-banatski"   },
                  {"code":"RS-03", "value" :"Severno-banatski"   },
                  {"code":"RS-04", "value" :"Južno-Banatski"   },
                  {"code":"RS-05", "value" :"Zapadno-Bački"   },
                  {"code":"RS-06", "value" :"Južnobački"   },
                  {"code":"RS-07", "value" :"Sremski"   },
                  {"code":"RS-08", "value" :"Mačvanski"   },
                  {"code":"RS-09", "value" :"Kolubarski"   },
                  {"code":"RS-10", "value" :"Podunavski"   },
                  {"code":"RS-11", "value" :"Braničevski"   },
                  {"code":"RS-12", "value" :"Šumadijski"   },
                  {"code":"RS-13", "value" :"Pomoravski"   },
                  {"code":"RS-14", "value" :"Borski"   },
                  {"code":"RS-15", "value" :"Zaječarski"   },
                  {"code":"RS-16", "value" :"Zlatiborski"   },
                  {"code":"RS-17", "value" :"Moravički"   },
                  {"code":"RS-18", "value" :"Raški"   },
                  {"code":"RS-19", "value" :"Rasinski"   },
                  {"code":"RS-20", "value" :"Nišavski"   },
                  {"code":"RS-21", "value" :"Toplički"   },
                  {"code":"RS-22", "value" :"Pirotski"   },
                  {"code":"RS-23", "value" :"Jablanički"   },
                  {"code":"RS-24", "value" :"Pčinjski"   },
                  {"code":"RS-25", "value" :"Kosovski"   },
                  {"code":"RS-26", "value" :"Pećki"   },
                  {"code":"RS-27", "value" :"Prizrenski"   },
                  {"code":"RS-28", "value" :"Kosovsko-Mitrovački"   },
                  {"code":"RS-29", "value" :"Kosovsko-Pomoravski"   },
                  {"code":"RS-KM", "value" :"Kosovo"   },
                  {"code":"RS-VO", "value" :"Vojvodina"   },
                  {"code":"RU-AD", "value" :"Adygea Republic"   },
                  {"code":"RU-AL", "value" :"Altai Republic"   },
                  {"code":"RU-ALT", "value" :"Altai Krai"   },
                  {"code":"RU-AMU", "value" :"Amur Oblast"   },
                  {"code":"RU-ARK", "value" :"Arkhangelsk Oblast"   },
                  {"code":"RU-AST", "value" :"Astrakhan Oblast"   },
                  {"code":"RU-BA", "value" :"Bashkortostan Republic"   },
                  {"code":"RU-BEL", "value" :"Belgorod Oblast"   },
                  {"code":"RU-BRY", "value" :"Bryansk Oblast"   },
                  {"code":"RU-BU", "value" :"Buryatia Republic"   },
                  {"code":"RU-CE", "value" :"Chechen Republic"   },
                  {"code":"RU-CHE", "value" :"Chelyabinsk Oblast"   },
                  {"code":"RU-CHU", "value" :"Chukotka AO"   },
                  {"code":"RU-CU", "value" :"Chuvashia Republic"   },
                  {"code":"RU-DA", "value" :"Dagestan Republic"   },
                  {"code":"RU-IN", "value" :"Ingushetia Republic"   },
                  {"code":"RU-IRK", "value" :"Irkutsk Oblast"   },
                  {"code":"RU-IVA", "value" :"Ivanovo Oblast"   },
                  {"code":"RU-KAM", "value" :"Kamchatka Krai"   },
                  {"code":"RU-KB", "value" :"Kabardino-Balkar Republic"   },
                  {"code":"RU-KC", "value" :"Karachay-Cherkess Republic"   },
                  {"code":"RU-KDA", "value" :"Krasnodar Krai"   },
                  {"code":"RU-KEM", "value" :"Kemerovo Oblast"   },
                  {"code":"RU-KGD", "value" :"Kaliningrad Oblast"   },
                  {"code":"RU-KGN", "value" :"Kurgan Oblast"   },
                  {"code":"RU-KHA", "value" :"Khabarovsk Krai"   },
                  {"code":"RU-KHM", "value" :"Khanty-Mansiyskiy avtonomnyy okrug"   },
                  {"code":"RU-KIR", "value" :"Kirov Oblast"   },
                  {"code":"RU-KK", "value" :"Khakassia Republic"   },
                  {"code":"RU-KL", "value" :"Kalmykia Republic"   },
                  {"code":"RU-KLU", "value" :"Kaluga Oblast"   },
                  {"code":"RU-KO", "value" :"Komi Republic"   },
                  {"code":"RU-KOS", "value" :"Kostroma Oblast"   },
                  {"code":"RU-KR", "value" :"Karelia Republic"   },
                  {"code":"RU-KRS", "value" :"Kursk Oblast"   },
                  {"code":"RU-KYA", "value" :"Krasnoyarsk Krai"   },
                  {"code":"RU-LEN", "value" :"Leningrad Oblast"   },
                  {"code":"RU-LIP", "value" :"Lipetsk Oblast"   },
                  {"code":"RU-MAG", "value" :"Magadan Oblast"   },
                  {"code":"RU-ME", "value" :"Mari El Republic"   },
                  {"code":"RU-MO", "value" :"Mordovia Republic"   },
                  {"code":"RU-MOS", "value" :"Moscow Oblast"   },
                  {"code":"RU-MOW", "value" :"Moscow"   },
                  {"code":"RU-MUR", "value" :"Murmansk Oblast"   },
                  {"code":"RU-NEN", "value" :"Nenetskiy avtonomnyy okrug"   },
                  {"code":"RU-NGR", "value" :"Novgorod Oblast"   },
                  {"code":"RU-NIZ", "value" :"Nizhny Novgorod Oblast"   },
                  {"code":"RU-NVS", "value" :"Novosibirsk Oblast"   },
                  {"code":"RU-OMS", "value" :"Omsk Oblast"   },
                  {"code":"RU-ORE", "value" :"Orenburg Oblast"   },
                  {"code":"RU-ORL", "value" :"Oryol Oblast"   },
                  {"code":"RU-PER", "value" :"Perm Krai"   },
                  {"code":"RU-PNZ", "value" :"Penza Oblast"   },
                  {"code":"RU-PRI", "value" :"Primorski Krai"   },
                  {"code":"RU-PSK", "value" :"Pskov Oblast"   },
                  {"code":"RU-ROS", "value" :"Rostov Oblast"   },
                  {"code":"RU-RYA", "value" :"Ryazan Oblast"   },
                  {"code":"RU-SA", "value" :"Sakha Republic"   },
                  {"code":"RU-SAK", "value" :"Sakhalin Oblast"   },
                  {"code":"RU-SAM", "value" :"Samara Oblast"   },
                  {"code":"RU-SAR", "value" :"Saratov Oblast"   },
                  {"code":"RU-SE", "value" :"North Ossetia-Alania Republic"   },
                  {"code":"RU-SMO", "value" :"Smolensk Oblast"   },
                  {"code":"RU-SPE", "value" :"Saint Petersburg"   },
                  {"code":"RU-STA", "value" :"Stavropol Krai"   },
                  {"code":"RU-SVE", "value" :"Sverdlovsk Oblast"   },
                  {"code":"RU-TA", "value" :"Tatarstan Republic"   },
                  {"code":"RU-TAM", "value" :"Tambov Oblast"   },
                  {"code":"RU-TOM", "value" :"Tomsk Oblast"   },
                  {"code":"RU-TUL", "value" :"Tula Oblast"   },
                  {"code":"RU-TVE", "value" :"Tver Oblast"   },
                  {"code":"RU-TY", "value" :"Tuva Republic"   },
                  {"code":"RU-TYU", "value" :"Tyumens Oblast"   },
                  {"code":"RU-UD", "value" :"Udmurtia Republic"   },
                  {"code":"RU-ULY", "value" :"Ulyanovsk Oblast"   },
                  {"code":"RU-VGG", "value" :"Volgograd Oblast"   },
                  {"code":"RU-VLA", "value" :"Vladimir Oblast"   },
                  {"code":"RU-VLG", "value" :"Vologda Oblast"   },
                  {"code":"RU-VOR", "value" :"Voronezh Oblast"   },
                  {"code":"RU-YAN", "value" :"Yamalo-Nenetskiy avtonomnyy okrug"   },
                  {"code":"RU-YAR", "value" :"Yaroslavl Oblast"   },
                  {"code":"RU-YEV", "value" :"Yevreyskaya avtonomnaya Oblast"   },
                  {"code":"RU-ZAB", "value" :"Zabaykalsky Krai"   },
                  {"code":"RW-01", "value" :"Kigali"   },
                  {"code":"RW-02", "value" :"Est"   },
                  {"code":"RW-03", "value" :"Nord"   },
                  {"code":"RW-04", "value" :"Ouest"   },
                  {"code":"RW-05", "value" :"Sud"   },
                  {"code":"SA-01", "value" :"Al Riyadh"   },
                  {"code":"SA-02", "value" :"Makkah"   },
                  {"code":"SA-03", "value" :"Al Madinah"   },
                  {"code":"SA-04", "value" :"Eastern Province"   },
                  {"code":"SA-05", "value" :"Al Qasim"   },
                  {"code":"SA-06", "value" :"Ha'il"   },
                  {"code":"SA-07", "value" :"Tabuk"   },
                  {"code":"SA-08", "value" :"Northern Border"   },
                  {"code":"SA-09", "value" :"Jizan"   },
                  {"code":"SA-10", "value" :"Najran"   },
                  {"code":"SA-11", "value" :"Al Bahah"   },
                  {"code":"SA-12", "value" :"Al Jawf"   },
                  {"code":"SA-14", "value" :"Asir"   },
                  {"code":"SB-CE", "value" :"Central"   },
                  {"code":"SB-CH", "value" :"Choiseul"   },
                  {"code":"SB-CT", "value" :"Honiara"   },
                  {"code":"SB-GU", "value" :"Guadalcanal"   },
                  {"code":"SB-IS", "value" :"Isabel"   },
                  {"code":"SB-MK", "value" :"Makira"   },
                  {"code":"SB-ML", "value" :"Malaita"   },
                  {"code":"SB-RB", "value" :"Rennell and Bellona"   },
                  {"code":"SB-TE", "value" :"Temotu"   },
                  {"code":"SB-WE", "value" :"Western"   },
                  {"code":"SC-01", "value" :"Anse aux Pins"   },
                  {"code":"SC-02", "value" :"Anse Boileau"   },
                  {"code":"SC-03", "value" :"Anse Étoile"   },
                  {"code":"SC-04", "value" :"Anse Louis"   },
                  {"code":"SC-05", "value" :"Anse Royale"   },
                  {"code":"SC-06", "value" :"Baie Lazare"   },
                  {"code":"SC-07", "value" :"Baie Sainte Anne"   },
                  {"code":"SC-08", "value" :"Beau Vallon"   },
                  {"code":"SC-09", "value" :"Bel Air"   },
                  {"code":"SC-10", "value" :"Bel Ombre"   },
                  {"code":"SC-11", "value" :"Cascade"   },
                  {"code":"SC-12", "value" :"Glacis"   },
                  {"code":"SC-13", "value" :"Grand'Anse (Mahé)"   },
                  {"code":"SC-14", "value" :"Grand'Anse (Praslin)"   },
                  {"code":"SC-15", "value" :"La Digue"   },
                  {"code":"SC-16", "value" :"La Rivière Anglaise"   },
                  {"code":"SC-17", "value" :"Mont Buxton"   },
                  {"code":"SC-18", "value" :"Mont Fleuri"   },
                  {"code":"SC-19", "value" :"Plaisance"   },
                  {"code":"SC-20", "value" :"Pointe La Rue"   },
                  {"code":"SC-21", "value" :"Port Glaud"   },
                  {"code":"SC-22", "value" :"Saint Louis"   },
                  {"code":"SC-23", "value" :"Takamaka"   },
                  {"code":"SC-24", "value" :"Les Mamelles"   },
                  {"code":"SC-25", "value" :"Roche Caiman"   },
                  {"code":"SD-01", "value" :"Northern"   },
                  {"code":"SD-02", "value" :"North Darfur"   },
                  {"code":"SD-03", "value" :"Khartoum"   },
                  {"code":"SD-04", "value" :"River Nile"   },
                  {"code":"SD-05", "value" :"Kassala"   },
                  {"code":"SD-06", "value" :"Al Qadarif"   },
                  {"code":"SD-07", "value" :"Al Jazirah"   },
                  {"code":"SD-08", "value" :"White Nile"   },
                  {"code":"SD-09", "value" :"North Kurdufan"   },
                  {"code":"SD-10", "value" :"West Kurdufan"   },
                  {"code":"SD-11", "value" :"South Darfur"   },
                  {"code":"SD-12", "value" :"West Darfur"   },
                  {"code":"SD-13", "value" :"South Kurdufan"   },
                  {"code":"SD-14", "value" :"West Bahr al Ghazal"   },
                  {"code":"SD-15", "value" :"North Bahr al Ghazal"   },
                  {"code":"SD-16", "value" :"West Equatoria"   },
                  {"code":"SD-17", "value" :"Bahr al Jebel"   },
                  {"code":"SD-18", "value" :"Lakes"   },
                  {"code":"SD-19", "value" :"East Equatoria"   },
                  {"code":"SD-20", "value" :"Jonglei"   },
                  {"code":"SD-21", "value" :"Warab"   },
                  {"code":"SD-22", "value" :"Unity"   },
                  {"code":"SD-23", "value" :"Upper Nile"   },
                  {"code":"SD-24", "value" :"Blue Nile"   },
                  {"code":"SD-25", "value" :"Sennar"   },
                  {"code":"SD-26", "value" :"Red Sea"   },
                  {"code":"SE-AB", "value" :"Stockholms län"   },
                  {"code":"SE-AC", "value" :"Västerbottens län"   },
                  {"code":"SE-BD", "value" :"Norrbottens län"   },
                  {"code":"SE-C", "value" :"Uppsala län"   },
                  {"code":"SE-D", "value" :"Södermanlands län"   },
                  {"code":"SE-E", "value" :"Östergötlands län"   },
                  {"code":"SE-F", "value" :"Jönköpings län"   },
                  {"code":"SE-G", "value" :"Kronobergs län"   },
                  {"code":"SE-H", "value" :"Kalmar län"   },
                  {"code":"SE-I", "value" :"Gotlands län"   },
                  {"code":"SE-K", "value" :"Blekinge län"   },
                  {"code":"SE-M", "value" :"Skåne län"   },
                  {"code":"SE-N", "value" :"Hallands län"   },
                  {"code":"SE-O", "value" :"Västra Götalands län"   },
                  {"code":"SE-S", "value" :"Värmlands län"   },
                  {"code":"SE-T", "value" :"Örebro län"   },
                  {"code":"SE-U", "value" :"Västmanlands län"   },
                  {"code":"SE-W", "value" :"Dalarnas län"   },
                  {"code":"SE-X", "value" :"Gävleborgs län"   },
                  {"code":"SE-Y", "value" :"Västernorrlands län"   },
                  {"code":"SE-Z", "value" :"Jämtlands län"   },
                  {"code":"SG-01", "value" :"Central Singapore"   },
                  {"code":"SG-02", "value" :"North-East"   },
                  {"code":"SG-03", "value" :"North-West"   },
                  {"code":"SG-04", "value" :"South-East"   },
                  {"code":"SG-05", "value" :"South-West"   },
                  {"code":"SI-001", "value" :"Ajdovščina"   },
                  {"code":"SI-002", "value" :"Beltinci"   },
                  {"code":"SI-003", "value" :"Bled"   },
                  {"code":"SI-004", "value" :"Bohinj"   },
                  {"code":"SI-005", "value" :"Borovnica"   },
                  {"code":"SI-006", "value" :"Bovec"   },
                  {"code":"SI-007", "value" :"Brda"   },
                  {"code":"SI-008", "value" :"Brezovica"   },
                  {"code":"SI-009", "value" :"Brežice"   },
                  {"code":"SI-010", "value" :"Tišina"   },
                  {"code":"SI-011", "value" :"Celje"   },
                  {"code":"SI-012", "value" :"Cerklje na Gorenjskem"   },
                  {"code":"SI-013", "value" :"Cerknica"   },
                  {"code":"SI-014", "value" :"Cerkno"   },
                  {"code":"SI-015", "value" :"Črenšovci"   },
                  {"code":"SI-016", "value" :"Črna na Koroškem"   },
                  {"code":"SI-017", "value" :"Črnomelj"   },
                  {"code":"SI-018", "value" :"Destrnik"   },
                  {"code":"SI-019", "value" :"Divača"   },
                  {"code":"SI-020", "value" :"Dobrepolje"   },
                  {"code":"SI-021", "value" :"Dobrova-Polhov Gradec"   },
                  {"code":"SI-022", "value" :"Dol pri Ljubljani"   },
                  {"code":"SI-023", "value" :"Domžale"   },
                  {"code":"SI-024", "value" :"Dornava"   },
                  {"code":"SI-025", "value" :"Dravograd"   },
                  {"code":"SI-026", "value" :"Duplek"   },
                  {"code":"SI-027", "value" :"Gorenja vas-Poljane"   },
                  {"code":"SI-028", "value" :"Gorišnica"   },
                  {"code":"SI-029", "value" :"Gornja Radgona"   },
                  {"code":"SI-030", "value" :"Gornji Grad"   },
                  {"code":"SI-031", "value" :"Gornji Petrovci"   },
                  {"code":"SI-032", "value" :"Grosuplje"   },
                  {"code":"SI-033", "value" :"Šalovci"   },
                  {"code":"SI-034", "value" :"Hrastnik"   },
                  {"code":"SI-035", "value" :"Hrpelje-Kozina"   },
                  {"code":"SI-036", "value" :"Idrija"   },
                  {"code":"SI-037", "value" :"Ig"   },
                  {"code":"SI-038", "value" :"Ilirska Bistrica"   },
                  {"code":"SI-039", "value" :"Ivančna Gorica"   },
                  {"code":"SI-040", "value" :"Izola"   },
                  {"code":"SI-041", "value" :"Jesenice"   },
                  {"code":"SI-042", "value" :"Juršinci"   },
                  {"code":"SI-043", "value" :"Kamnik"   },
                  {"code":"SI-044", "value" :"Kanal"   },
                  {"code":"SI-045", "value" :"Kidričevo"   },
                  {"code":"SI-046", "value" :"Kobarid"   },
                  {"code":"SI-047", "value" :"Kobilje"   },
                  {"code":"SI-048", "value" :"Kočevje"   },
                  {"code":"SI-049", "value" :"Komen"   },
                  {"code":"SI-050", "value" :"Koper"   },
                  {"code":"SI-051", "value" :"Kozje"   },
                  {"code":"SI-052", "value" :"Kranj"   },
                  {"code":"SI-053", "value" :"Kranjska Gora"   },
                  {"code":"SI-054", "value" :"Krško"   },
                  {"code":"SI-055", "value" :"Kungota"   },
                  {"code":"SI-056", "value" :"Kuzma"   },
                  {"code":"SI-057", "value" :"Laško"   },
                  {"code":"SI-058", "value" :"Lenart"   },
                  {"code":"SI-059", "value" :"Lendava"   },
                  {"code":"SI-060", "value" :"Litija"   },
                  {"code":"SI-061", "value" :"Ljubljana"   },
                  {"code":"SI-062", "value" :"Ljubno"   },
                  {"code":"SI-063", "value" :"Ljutomer"   },
                  {"code":"SI-064", "value" :"Logatec"   },
                  {"code":"SI-065", "value" :"Loška dolina"   },
                  {"code":"SI-066", "value" :"Loški Potok"   },
                  {"code":"SI-067", "value" :"Luče"   },
                  {"code":"SI-068", "value" :"Lukovica"   },
                  {"code":"SI-069", "value" :"Majšperk"   },
                  {"code":"SI-070", "value" :"Maribor"   },
                  {"code":"SI-071", "value" :"Medvode"   },
                  {"code":"SI-072", "value" :"Mengeš"   },
                  {"code":"SI-073", "value" :"Metlika"   },
                  {"code":"SI-074", "value" :"Mežica"   },
                  {"code":"SI-075", "value" :"Miren-Kostanjevica"   },
                  {"code":"SI-076", "value" :"Mislinja"   },
                  {"code":"SI-077", "value" :"Moravče"   },
                  {"code":"SI-078", "value" :"Moravske Toplice"   },
                  {"code":"SI-079", "value" :"Mozirje"   },
                  {"code":"SI-080", "value" :"Murska Sobota"   },
                  {"code":"SI-081", "value" :"Muta"   },
                  {"code":"SI-082", "value" :"Naklo"   },
                  {"code":"SI-083", "value" :"Nazarje"   },
                  {"code":"SI-084", "value" :"Nova Gorica"   },
                  {"code":"SI-085", "value" :"Novo mesto"   },
                  {"code":"SI-086", "value" :"Odranci"   },
                  {"code":"SI-087", "value" :"Ormož"   },
                  {"code":"SI-088", "value" :"Osilnica"   },
                  {"code":"SI-089", "value" :"Pesnica"   },
                  {"code":"SI-090", "value" :"Piran"   },
                  {"code":"SI-091", "value" :"Pivka"   },
                  {"code":"SI-092", "value" :"Podčetrtek"   },
                  {"code":"SI-093", "value" :"Podvelka"   },
                  {"code":"SI-094", "value" :"Postojna"   },
                  {"code":"SI-095", "value" :"Preddvor"   },
                  {"code":"SI-096", "value" :"Ptuj"   },
                  {"code":"SI-097", "value" :"Puconci"   },
                  {"code":"SI-098", "value" :"Rače-Fram"   },
                  {"code":"SI-099", "value" :"Radeče"   },
                  {"code":"SI-100", "value" :"Radenci"   },
                  {"code":"SI-101", "value" :"Radlje ob Dravi"   },
                  {"code":"SI-102", "value" :"Radovljica"   },
                  {"code":"SI-103", "value" :"Ravne na Koroškem"   },
                  {"code":"SI-104", "value" :"Ribnica"   },
                  {"code":"SI-105", "value" :"Rogašovci"   },
                  {"code":"SI-106", "value" :"Rogaška Slatina"   },
                  {"code":"SI-107", "value" :"Rogatec"   },
                  {"code":"SI-108", "value" :"Ruše"   },
                  {"code":"SI-109", "value" :"Semič"   },
                  {"code":"SI-110", "value" :"Sevnica"   },
                  {"code":"SI-111", "value" :"Sežana"   },
                  {"code":"SI-112", "value" :"Slovenj Gradec"   },
                  {"code":"SI-113", "value" :"Slovenska Bistrica"   },
                  {"code":"SI-114", "value" :"Slovenske Konjice"   },
                  {"code":"SI-115", "value" :"Starše"   },
                  {"code":"SI-116", "value" :"Sveti Jurij ob Ščavnici"   },
                  {"code":"SI-117", "value" :"Šenčur"   },
                  {"code":"SI-118", "value" :"Šentilj"   },
                  {"code":"SI-119", "value" :"Šentjernej"   },
                  {"code":"SI-120", "value" :"Šentjur"   },
                  {"code":"SI-121", "value" :"Škocjan"   },
                  {"code":"SI-122", "value" :"Škofja Loka"   },
                  {"code":"SI-123", "value" :"Škofljica"   },
                  {"code":"SI-124", "value" :"Šmarje pri Jelšah"   },
                  {"code":"SI-125", "value" :"Šmartno ob Paki"   },
                  {"code":"SI-126", "value" :"Šoštanj"   },
                  {"code":"SI-127", "value" :"Štore"   },
                  {"code":"SI-128", "value" :"Tolmin"   },
                  {"code":"SI-129", "value" :"Trbovlje"   },
                  {"code":"SI-130", "value" :"Trebnje"   },
                  {"code":"SI-131", "value" :"Tržič"   },
                  {"code":"SI-132", "value" :"Turnišče"   },
                  {"code":"SI-133", "value" :"Velenje"   },
                  {"code":"SI-134", "value" :"Velike Lašče"   },
                  {"code":"SI-135", "value" :"Videm"   },
                  {"code":"SI-136", "value" :"Vipava"   },
                  {"code":"SI-137", "value" :"Vitanje"   },
                  {"code":"SI-138", "value" :"Vodice"   },
                  {"code":"SI-139", "value" :"Vojnik"   },
                  {"code":"SI-140", "value" :"Vrhnika"   },
                  {"code":"SI-141", "value" :"Vuzenica"   },
                  {"code":"SI-142", "value" :"Zagorje ob Savi"   },
                  {"code":"SI-143", "value" :"Zavrč"   },
                  {"code":"SI-144", "value" :"Zreče"   },
                  {"code":"SI-146", "value" :"Železniki"   },
                  {"code":"SI-147", "value" :"Žiri"   },
                  {"code":"SI-148", "value" :"Benedikt"   },
                  {"code":"SI-149", "value" :"Bistrica ob Sotli"   },
                  {"code":"SI-150", "value" :"Bloke"   },
                  {"code":"SI-151", "value" :"Braslovče"   },
                  {"code":"SI-152", "value" :"Cankova"   },
                  {"code":"SI-153", "value" :"Cerkvenjak"   },
                  {"code":"SI-154", "value" :"Dobje"   },
                  {"code":"SI-155", "value" :"Dobrna"   },
                  {"code":"SI-156", "value" :"Dobrovnik"   },
                  {"code":"SI-157", "value" :"Dolenjske Toplice"   },
                  {"code":"SI-158", "value" :"Grad"   },
                  {"code":"SI-159", "value" :"Hajdina"   },
                  {"code":"SI-160", "value" :"Hoče-Slivnica"   },
                  {"code":"SI-161", "value" :"Hodoš"   },
                  {"code":"SI-162", "value" :"Horjul"   },
                  {"code":"SI-163", "value" :"Jezersko"   },
                  {"code":"SI-164", "value" :"Komenda"   },
                  {"code":"SI-165", "value" :"Kostel"   },
                  {"code":"SI-166", "value" :"Križevci"   },
                  {"code":"SI-167", "value" :"Lovrenc na Pohorju"   },
                  {"code":"SI-168", "value" :"Markovci"   },
                  {"code":"SI-169", "value" :"Miklavž na Dravskem polju"   },
                  {"code":"SI-170", "value" :"Mirna Peč"   },
                  {"code":"SI-171", "value" :"Oplotnica"   },
                  {"code":"SI-172", "value" :"Podlehnik"   },
                  {"code":"SI-173", "value" :"Polzela"   },
                  {"code":"SI-174", "value" :"Prebold"   },
                  {"code":"SI-175", "value" :"Prevalje"   },
                  {"code":"SI-176", "value" :"Razkrižje"   },
                  {"code":"SI-177", "value" :"Ribnica na Pohorju"   },
                  {"code":"SI-178", "value" :"Selnica ob Dravi"   },
                  {"code":"SI-179", "value" :"Sodražica"   },
                  {"code":"SI-180", "value" :"Solčava"   },
                  {"code":"SI-181", "value" :"Sveta Ana"   },
                  {"code":"SI-182", "value" :"Sveti Andraž v Slovenskih Goricah"   },
                  {"code":"SI-183", "value" :"Šempeter-Vrtojba"   },
                  {"code":"SI-184", "value" :"Tabor"   },
                  {"code":"SI-185", "value" :"Trnovska vas"   },
                  {"code":"SI-186", "value" :"Trzin"   },
                  {"code":"SI-187", "value" :"Velika Polana"   },
                  {"code":"SI-188", "value" :"Veržej"   },
                  {"code":"SI-189", "value" :"Vransko"   },
                  {"code":"SI-190", "value" :"Žalec"   },
                  {"code":"SI-191", "value" :"Žetale"   },
                  {"code":"SI-192", "value" :"Žirovnica"   },
                  {"code":"SI-193", "value" :"Žužemberk"   },
                  {"code":"SI-194", "value" :"Šmartno pri Litiji"   },
                  {"code":"SI-195", "value" :"Apače"   },
                  {"code":"SI-196", "value" :"Cirkulane"   },
                  {"code":"SI-197", "value" :"Kostanjevica na Krki"   },
                  {"code":"SI-198", "value" :"Makole"   },
                  {"code":"SI-199", "value" :"Mokronog-Trebelno"   },
                  {"code":"SI-200", "value" :"Poljčane"   },
                  {"code":"SI-201", "value" :"Renče-Vogrsko"   },
                  {"code":"SI-202", "value" :"Središče ob Dravi"   },
                  {"code":"SI-203", "value" :"Straža"   },
                  {"code":"SI-204", "value" :"Sveta Trojica v Slovenskih Goricah"   },
                  {"code":"SI-205", "value" :"Sveti Tomaž"   },
                  {"code":"SI-206", "value" :"Šmarješke Toplice"   },
                  {"code":"SI-207", "value" :"Gorje"   },
                  {"code":"SI-208", "value" :"Log-Dragomer"   },
                  {"code":"SI-209", "value" :"Rečica ob Savinji"   },
                  {"code":"SI-210", "value" :"Sveti Jurij v Slovenskih Goricah"   },
                  {"code":"SI-211", "value" :"Šentrupert"   },
                  {"code":"SK-BC", "value" :"Banskobystrický Kraj"   },
                  {"code":"SK-BL", "value" :"Bratislavský Kraj"   },
                  {"code":"SK-KI", "value" :"Košický Kraj"   },
                  {"code":"SK-NI", "value" :"Nitriansky Kraj"   },
                  {"code":"SK-PV", "value" :"Prešovský Kraj"   },
                  {"code":"SK-TA", "value" :"Trnavský Kraj"   },
                  {"code":"SK-TC", "value" :"Trenčiansky Kraj"   },
                  {"code":"SK-ZI", "value" :"Žilinský Kraj"   },
                  {"code":"SL-E", "value" :"Eastern"   },
                  {"code":"SL-N", "value" :"Northern"   },
                  {"code":"SL-S", "value" :"Southern"   },
                  {"code":"SL-W", "value" :"Western Area"   },
                  {"code":"SM-01", "value" :"Acquaviva"   },
                  {"code":"SM-02", "value" :"Chiesanuova"   },
                  {"code":"SM-03", "value" :"Domagnano"   },
                  {"code":"SM-04", "value" :"Faetano"   },
                  {"code":"SM-05", "value" :"Fiorentino"   },
                  {"code":"SM-06", "value" :"Borgo Maggiore"   },
                  {"code":"SM-07", "value" :"San Marino"   },
                  {"code":"SM-08", "value" :"Montegiardino"   },
                  {"code":"SM-09", "value" :"Serravalle"   },
                  {"code":"SN-DB", "value" :"Diourbel"   },
                  {"code":"SN-DK", "value" :"Dakar"   },
                  {"code":"SN-FK", "value" :"Fatick"   },
                  {"code":"SN-KA", "value" :"Kaffrine"   },
                  {"code":"SN-KD", "value" :"Kolda"   },
                  {"code":"SN-KE", "value" :"Kédougou"   },
                  {"code":"SN-KL", "value" :"Kaolack"   },
                  {"code":"SN-LG", "value" :"Louga"   },
                  {"code":"SN-MT", "value" :"Matam"   },
                  {"code":"SN-SE", "value" :"Sédhiou"   },
                  {"code":"SN-SL", "value" :"Saint-Louis"   },
                  {"code":"SN-TC", "value" :"Tambacounda"   },
                  {"code":"SN-TH", "value" :"Thiès"   },
                  {"code":"SN-ZG", "value" :"Ziguinchor"   },
                  {"code":"SO-AW", "value" :"Awdal"   },
                  {"code":"SO-BK", "value" :"Bakool"   },
                  {"code":"SO-BN", "value" :"Banaadir"   },
                  {"code":"SO-BR", "value" :"Bari"   },
                  {"code":"SO-BY", "value" :"Bay"   },
                  {"code":"SO-GA", "value" :"Galguduud"   },
                  {"code":"SO-GE", "value" :"Gedo"   },
                  {"code":"SO-HI", "value" :"Hiiraan"   },
                  {"code":"SO-JD", "value" :"Jubbada Dhexe"   },
                  {"code":"SO-JH", "value" :"Jubbada Hoose"   },
                  {"code":"SO-MU", "value" :"Mudug"   },
                  {"code":"SO-NU", "value" :"Nugaal"   },
                  {"code":"SO-SA", "value" :"Sanaag"   },
                  {"code":"SO-SD", "value" :"Shabeellaha Dhexe"   },
                  {"code":"SO-SH", "value" :"Shabeellaha Hoose"   },
                  {"code":"SO-SO", "value" :"Sool"   },
                  {"code":"SO-TO", "value" :"Togdheer"   },
                  {"code":"SO-WO", "value" :"Woqooyi Galbeed"   },
                  {"code":"SR-BR", "value" :"Brokopondo"   },
                  {"code":"SR-CM", "value" :"Commewijne"   },
                  {"code":"SR-CR", "value" :"Coronie"   },
                  {"code":"SR-MA", "value" :"Marowijne"   },
                  {"code":"SR-NI", "value" :"Nickerie"   },
                  {"code":"SR-PM", "value" :"Paramaribo"   },
                  {"code":"SR-PR", "value" :"Para"   },
                  {"code":"SR-SA", "value" :"Saramacca"   },
                  {"code":"SR-SI", "value" :"Sipaliwini"   },
                  {"code":"SR-WA", "value" :"Wanica"   },
                  {"code":"ST-P", "value" :"Príncipe"   },
                  {"code":"ST-S", "value" :"São Tomé"   },
                  {"code":"SV-AH", "value" :"Ahuachapán"   },
                  {"code":"SV-CA", "value" :"Cabañas"   },
                  {"code":"SV-CH", "value" :"Chalatenango"   },
                  {"code":"SV-CU", "value" :"Cuscatlán"   },
                  {"code":"SV-LI", "value" :"La Libertad"   },
                  {"code":"SV-MO", "value" :"Morazán"   },
                  {"code":"SV-PA", "value" :"La Paz"   },
                  {"code":"SV-SA", "value" :"Santa Ana"   },
                  {"code":"SV-SM", "value" :"San Miguel"   },
                  {"code":"SV-SO", "value" :"Sonsonate"   },
                  {"code":"SV-SS", "value" :"San Salvador"   },
                  {"code":"SV-SV", "value" :"San Vicente"   },
                  {"code":"SV-UN", "value" :"La Unión"   },
                  {"code":"SV-US", "value" :"Usulután"   },
                  {"code":"SY-DI", "value" :"Dimashq"   },
                  {"code":"SY-DR", "value" :"Daraa"   },
                  {"code":"SY-DY", "value" :"Deir ez-Zor"   },
                  {"code":"SY-HA", "value" :"Al-Hasakah"   },
                  {"code":"SY-HI", "value" :"Hims"   },
                  {"code":"SY-HL", "value" :"Aleppo"   },
                  {"code":"SY-HM", "value" :"Hama"   },
                  {"code":"SY-ID", "value" :"Idlib"   },
                  {"code":"SY-LA", "value" :"Latakia"   },
                  {"code":"SY-QU", "value" :"Quneitra"   },
                  {"code":"SY-RA", "value" :"Ar-Raqqah"   },
                  {"code":"SY-RD", "value" :"Rif Dimashq"   },
                  {"code":"SY-SU", "value" :"As-Suwayda"   },
                  {"code":"SY-TA", "value" :"Tartus"   },
                  {"code":"SZ-HH", "value" :"Hhohho"   },
                  {"code":"SZ-LU", "value" :"Lubombo"   },
                  {"code":"SZ-MA", "value" :"Manzini"   },
                  {"code":"SZ-SH", "value" :"Shiselweni"   },
                  {"code":"TD-BA", "value" :"Batha"   },
                  {"code":"TD-BG", "value" :"Bahr el Gazel"   },
                  {"code":"TD-BO", "value" :"Borkou"   },
                  {"code":"TD-CB", "value" :"Chari-Baguirmi"   },
                  {"code":"TD-EN", "value" :"Ennedi"   },
                  {"code":"TD-GR", "value" :"Guéra"   },
                  {"code":"TD-HL", "value" :"Hadjer-Lamis"   },
                  {"code":"TD-KA", "value" :"Kanem"   },
                  {"code":"TD-LC", "value" :"Lac"   },
                  {"code":"TD-LO", "value" :"Logone Occidental"   },
                  {"code":"TD-LR", "value" :"Logone Oriental"   },
                  {"code":"TD-MA", "value" :"Mandoul"   },
                  {"code":"TD-MC", "value" :"Moyen-Chari"   },
                  {"code":"TD-ME", "value" :"Mayo-Kébbi Est"   },
                  {"code":"TD-MO", "value" :"Mayo-Kébbi Ouest"   },
                  {"code":"TD-ND", "value" :"N'Djamena"   },
                  {"code":"TD-OD", "value" :"Ouaddaï"   },
                  {"code":"TD-SA", "value" :"Salamat"   },
                  {"code":"TD-SI", "value" :"Sila"   },
                  {"code":"TD-TA", "value" :"Tandjilé"   },
                  {"code":"TD-TI", "value" :"Tibesti"   },
                  {"code":"TD-WF", "value" :"Wadi Fira"   },
                  {"code":"TG-C", "value" :"Centre"   },
                  {"code":"TG-K", "value" :"Kara"   },
                  {"code":"TG-M", "value" :"Région Maritime"   },
                  {"code":"TG-P", "value" :"Plateaux"   },
                  {"code":"TG-S", "value" :"Savannes"   },
                  {"code":"TH-10", "value" :"Bangkok"   },
                  {"code":"TH-11", "value" :"Samut Prakan"   },
                  {"code":"TH-12", "value" :"Nonthaburi"   },
                  {"code":"TH-13", "value" :"Pathum Thani"   },
                  {"code":"TH-14", "value" :"Phra Nakhon Si Ayutthaya"   },
                  {"code":"TH-15", "value" :"Ang Thong"   },
                  {"code":"TH-16", "value" :"Lopburi"   },
                  {"code":"TH-17", "value" :"Sing Buri"   },
                  {"code":"TH-18", "value" :"Chai Nat"   },
                  {"code":"TH-19", "value" :"Saraburi"   },
                  {"code":"TH-20", "value" :"Chonburi"   },
                  {"code":"TH-21", "value" :"Rayong"   },
                  {"code":"TH-22", "value" :"Chanthaburi"   },
                  {"code":"TH-23", "value" :"Trat"   },
                  {"code":"TH-24", "value" :"Chachoengsao"   },
                  {"code":"TH-25", "value" :"Prachin Buri"   },
                  {"code":"TH-26", "value" :"Nakhon Nayok"   },
                  {"code":"TH-27", "value" :"Sa Kaeo"   },
                  {"code":"TH-30", "value" :"Nakhon Ratchasima"   },
                  {"code":"TH-31", "value" :"Buri Ram"   },
                  {"code":"TH-32", "value" :"Surin"   },
                  {"code":"TH-33", "value" :"Sisaket"   },
                  {"code":"TH-34", "value" :"Ubon Ratchathani"   },
                  {"code":"TH-35", "value" :"Yasothon"   },
                  {"code":"TH-36", "value" :"Chaiyaphum"   },
                  {"code":"TH-37", "value" :"Amnat Charoen"   },
                  {"code":"TH-39", "value" :"Nong Bua Lamphu"   },
                  {"code":"TH-40", "value" :"Khon Kaen"   },
                  {"code":"TH-41", "value" :"Udon Thani"   },
                  {"code":"TH-42", "value" :"Loei"   },
                  {"code":"TH-43", "value" :"Nong Khai"   },
                  {"code":"TH-44", "value" :"Maha Sarakham"   },
                  {"code":"TH-45", "value" :"Roi Et"   },
                  {"code":"TH-46", "value" :"Kalasin"   },
                  {"code":"TH-47", "value" :"Sakon Nakhon"   },
                  {"code":"TH-48", "value" :"Nakhon Phanom"   },
                  {"code":"TH-49", "value" :"Mukdahan"   },
                  {"code":"TH-50", "value" :"Chiang Mai"   },
                  {"code":"TH-51", "value" :"Lamphun"   },
                  {"code":"TH-52", "value" :"Lampang"   },
                  {"code":"TH-53", "value" :"Uttaradit"   },
                  {"code":"TH-54", "value" :"Phrae"   },
                  {"code":"TH-55", "value" :"Nan"   },
                  {"code":"TH-56", "value" :"Phayao"   },
                  {"code":"TH-57", "value" :"Chiang Rai"   },
                  {"code":"TH-58", "value" :"Mae Hong Son"   },
                  {"code":"TH-60", "value" :"Nakhon Sawan"   },
                  {"code":"TH-61", "value" :"Uthai Thani"   },
                  {"code":"TH-62", "value" :"Kamphaeng Phet"   },
                  {"code":"TH-63", "value" :"Tak"   },
                  {"code":"TH-64", "value" :"Sukhothai"   },
                  {"code":"TH-65", "value" :"Phitsanulok"   },
                  {"code":"TH-66", "value" :"Phichit"   },
                  {"code":"TH-67", "value" :"Phetchabun"   },
                  {"code":"TH-70", "value" :"Ratchaburi"   },
                  {"code":"TH-71", "value" :"Kanchanaburi"   },
                  {"code":"TH-72", "value" :"Suphan Buri"   },
                  {"code":"TH-73", "value" :"Nakhon Pathom"   },
                  {"code":"TH-74", "value" :"Samut Sakhon"   },
                  {"code":"TH-75", "value" :"Samut Songkhram"   },
                  {"code":"TH-76", "value" :"Phetchaburi"   },
                  {"code":"TH-77", "value" :"Prachuap Khiri Khan"   },
                  {"code":"TH-80", "value" :"Nakhon Si Thammarat"   },
                  {"code":"TH-81", "value" :"Krabi"   },
                  {"code":"TH-82", "value" :"Phang Nga"   },
                  {"code":"TH-83", "value" :"Phuket"   },
                  {"code":"TH-84", "value" :"Surat Thani"   },
                  {"code":"TH-85", "value" :"Ranong"   },
                  {"code":"TH-86", "value" :"Chumphon"   },
                  {"code":"TH-90", "value" :"Songkhla"   },
                  {"code":"TH-91", "value" :"Satun"   },
                  {"code":"TH-92", "value" :"Trang"   },
                  {"code":"TH-93", "value" :"Phatthalung"   },
                  {"code":"TH-94", "value" :"Pattani"   },
                  {"code":"TH-95", "value" :"Yala"   },
                  {"code":"TH-96", "value" :"Narathiwat"   },
                  {"code":"TH-S", "value" :"Pattaya"   },
                  {"code":"TJ-GB", "value" :"Gorno-Badakhshan"   },
                  {"code":"TJ-KT", "value" :"Khatlon"   },
                  {"code":"TJ-SU", "value" :"Sughd"   },
                  {"code":"TL-AL", "value" :"Aileu"   },
                  {"code":"TL-AN", "value" :"Ainaro"   },
                  {"code":"TL-BA", "value" :"Baucau"   },
                  {"code":"TL-BO", "value" :"Bobonaro"   },
                  {"code":"TL-CO", "value" :"Cova Lima"   },
                  {"code":"TL-DI", "value" :"Dili"   },
                  {"code":"TL-ER", "value" :"Ermera"   },
                  {"code":"TL-LA", "value" :"Lautem"   },
                  {"code":"TL-LI", "value" :"Liquiça"   },
                  {"code":"TL-MF", "value" :"Manufahi"   },
                  {"code":"TL-MT", "value" :"Manatuto"   },
                  {"code":"TL-OE", "value" :"Oecussi"   },
                  {"code":"TL-VI", "value" :"Viqueque"   },
                  {"code":"TM-A", "value" :"Ahal"   },
                  {"code":"TM-B", "value" :"Balkan"   },
                  {"code":"TM-D", "value" :"Dasoguz"   },
                  {"code":"TM-L", "value" :"Lebap"   },
                  {"code":"TM-M", "value" :"Mary"   },
                  {"code":"TN-11", "value" :"Tunis"   },
                  {"code":"TN-12", "value" :"Ariana"   },
                  {"code":"TN-13", "value" :"Ben Arous"   },
                  {"code":"TN-14", "value" :"La Manouba"   },
                  {"code":"TN-21", "value" :"Nabeul"   },
                  {"code":"TN-22", "value" :"Zaghouan"   },
                  {"code":"TN-23", "value" :"Bizerte"   },
                  {"code":"TN-31", "value" :"Béja"   },
                  {"code":"TN-32", "value" :"Jendouba"   },
                  {"code":"TN-33", "value" :"Le Kef"   },
                  {"code":"TN-34", "value" :"Siliana"   },
                  {"code":"TN-41", "value" :"Kairouan"   },
                  {"code":"TN-42", "value" :"Kasserine"   },
                  {"code":"TN-43", "value" :"Sidi Bouzid"   },
                  {"code":"TN-51", "value" :"Sousse"   },
                  {"code":"TN-52", "value" :"Monastir"   },
                  {"code":"TN-53", "value" :"Mahdia"   },
                  {"code":"TN-61", "value" :"Sfax"   },
                  {"code":"TN-71", "value" :"Gafsa"   },
                  {"code":"TN-72", "value" :"Tozeur"   },
                  {"code":"TN-73", "value" :"Kebili"   },
                  {"code":"TN-81", "value" :"Gabes"   },
                  {"code":"TN-82", "value" :"Médenine"   },
                  {"code":"TN-83", "value" :"Tataouine"   },
                  {"code":"TO-01", "value" :"Eua"   },
                  {"code":"TO-02", "value" :"Ha'apai"   },
                  {"code":"TO-03", "value" :"Niuas"   },
                  {"code":"TO-04", "value" :"Tongatapu"   },
                  {"code":"TO-05", "value" :"Vava'u"   },
                  {"code":"TR-01", "value" :"Adana"   },
                  {"code":"TR-02", "value" :"Adıyaman"   },
                  {"code":"TR-03", "value" :"Afyonkarahisar"   },
                  {"code":"TR-04", "value" :"Ağrı"   },
                  {"code":"TR-05", "value" :"Amasya"   },
                  {"code":"TR-06", "value" :"Ankara"   },
                  {"code":"TR-07", "value" :"Antalya"   },
                  {"code":"TR-08", "value" :"Artvin"   },
                  {"code":"TR-09", "value" :"Aydın"   },
                  {"code":"TR-10", "value" :"Balıkesir"   },
                  {"code":"TR-11", "value" :"Bilecik"   },
                  {"code":"TR-12", "value" :"Bingöl"   },
                  {"code":"TR-13", "value" :"Bitlis"   },
                  {"code":"TR-14", "value" :"Bolu"   },
                  {"code":"TR-15", "value" :"Burdur"   },
                  {"code":"TR-16", "value" :"Bursa"   },
                  {"code":"TR-17", "value" :"Çanakkale"   },
                  {"code":"TR-18", "value" :"Çankırı"   },
                  {"code":"TR-19", "value" :"Çorum"   },
                  {"code":"TR-20", "value" :"Denizli"   },
                  {"code":"TR-21", "value" :"Diyarbakır"   },
                  {"code":"TR-22", "value" :"Edirne"   },
                  {"code":"TR-23", "value" :"Elazığ"   },
                  {"code":"TR-24", "value" :"Erzincan"   },
                  {"code":"TR-25", "value" :"Erzurum"   },
                  {"code":"TR-26", "value" :"Eskişehir"   },
                  {"code":"TR-27", "value" :"Gaziantep"   },
                  {"code":"TR-28", "value" :"Giresun"   },
                  {"code":"TR-29", "value" :"Gümüşhane"   },
                  {"code":"TR-30", "value" :"Hakkari"   },
                  {"code":"TR-31", "value" :"Hatay"   },
                  {"code":"TR-32", "value" :"Isparta"   },
                  {"code":"TR-33", "value" :"Mersin"   },
                  {"code":"TR-34", "value" :"İstanbul"   },
                  {"code":"TR-35", "value" :"İzmir"   },
                  {"code":"TR-36", "value" :"Kars"   },
                  {"code":"TR-37", "value" :"Kastamonu"   },
                  {"code":"TR-38", "value" :"Kayseri"   },
                  {"code":"TR-39", "value" :"Kırklareli"   },
                  {"code":"TR-40", "value" :"Kırşehir"   },
                  {"code":"TR-41", "value" :"Kocaeli"   },
                  {"code":"TR-42", "value" :"Konya"   },
                  {"code":"TR-43", "value" :"Kütahya"   },
                  {"code":"TR-44", "value" :"Malatya"   },
                  {"code":"TR-45", "value" :"Manisa"   },
                  {"code":"TR-46", "value" :"Kahramanmaraş"   },
                  {"code":"TR-47", "value" :"Mardin"   },
                  {"code":"TR-48", "value" :"Muğla"   },
                  {"code":"TR-49", "value" :"Muş"   },
                  {"code":"TR-50", "value" :"Nevşehir"   },
                  {"code":"TR-51", "value" :"Niğde"   },
                  {"code":"TR-52", "value" :"Ordu"   },
                  {"code":"TR-53", "value" :"Rize"   },
                  {"code":"TR-54", "value" :"Sakarya"   },
                  {"code":"TR-55", "value" :"Samsun"   },
                  {"code":"TR-56", "value" :"Siirt"   },
                  {"code":"TR-57", "value" :"Sinop"   },
                  {"code":"TR-58", "value" :"Sivas"   },
                  {"code":"TR-59", "value" :"Tekirdağ"   },
                  {"code":"TR-60", "value" :"Tokat"   },
                  {"code":"TR-61", "value" :"Trabzon"   },
                  {"code":"TR-62", "value" :"Tunceli"   },
                  {"code":"TR-63", "value" :"Şanlıurfa"   },
                  {"code":"TR-64", "value" :"Uşak"   },
                  {"code":"TR-65", "value" :"Van"   },
                  {"code":"TR-66", "value" :"Yozgat"   },
                  {"code":"TR-67", "value" :"Zonguldak"   },
                  {"code":"TR-68", "value" :"Aksaray"   },
                  {"code":"TR-69", "value" :"Bayburt"   },
                  {"code":"TR-70", "value" :"Karaman"   },
                  {"code":"TR-71", "value" :"Kırıkkale"   },
                  {"code":"TR-72", "value" :"Batman"   },
                  {"code":"TR-73", "value" :"Şırnak"   },
                  {"code":"TR-74", "value" :"Bartın"   },
                  {"code":"TR-75", "value" :"Ardahan"   },
                  {"code":"TR-76", "value" :"İğdir"   },
                  {"code":"TR-77", "value" :"Yalova"   },
                  {"code":"TR-78", "value" :"Karabük"   },
                  {"code":"TR-79", "value" :"Kilis"   },
                  {"code":"TR-80", "value" :"Osmaniye"   },
                  {"code":"TR-81", "value" :"Düzce"   },
                  {"code":"TT-ARI", "value" :"Arima"   },
                  {"code":"TT-CHA", "value" :"Chaguanas"   },
                  {"code":"TT-CTT", "value" :"Couva-Tabaquite-Talparo"   },
                  {"code":"TT-DMN", "value" :"Diego Martin"   },
                  {"code":"TT-ETO", "value" :"Eastern Tobago"   },
                  {"code":"TT-PED", "value" :"Penal-Debe"   },
                  {"code":"TT-POS", "value" :"Port of Spain"   },
                  {"code":"TT-PRT", "value" :"Princes Town"   },
                  {"code":"TT-PTF", "value" :"Point Fortin"   },
                  {"code":"TT-RCM", "value" :"Rio Claro-Mayaro"   },
                  {"code":"TT-SFO", "value" :"San Fernando"   },
                  {"code":"TT-SGE", "value" :"Sangre Grande"   },
                  {"code":"TT-SIP", "value" :"Siparia"   },
                  {"code":"TT-SJL", "value" :"San Juan-Laventille"   },
                  {"code":"TT-TUP", "value" :"Tunapuna-Piarco"   },
                  {"code":"TT-WTO", "value" :"Western Tobago"   },
                  {"code":"TV-FUN", "value" :"Funafuti" },
                  {"code":"TV-NIT", "value" :"Niutao" },
                  {"code":"TV-NIU", "value" :"Nui" },
                  {"code":"TV-NKF", "value" :"Nukufetau" },
                  {"code":"TV-NKL", "value" :"Nukulaelae" },
                  {"code":"TV-NMA", "value" :"Nanumea" },
                  {"code":"TV-NMG", "value" :"Nanumanga" },
                  {"code":"TV-VAI", "value" :"Vaitupu" },
                  {"code":"TW-CHA", "value" :"Changhua County"   },
                  {"code":"TW-CYI", "value" :"Chiayi City"   },
                  {"code":"TW-CYQ", "value" :"Chiayi County"   },
                  {"code":"TW-HSQ", "value" :"Hsinchu County"   },
                  {"code":"TW-HSZ", "value" :"Hsinchu City"   },
                  {"code":"TW-HUA", "value" :"Hualien County"   },
                  {"code":"TW-ILA", "value" :"Yilan County"   },
                  {"code":"TW-KEE", "value" :"Keelung City"   },
                  {"code":"TW-KHH", "value" :"Kaohsiung City"   },
                  {"code":"TW-KHQ", "value" :"Kaohsiung County"   },
                  {"code":"TW-MIA", "value" :"Miaoli County"   },
                  {"code":"TW-NA2", "value" :"Lienchiang County"   },
                  {"code":"TW-NA3", "value" :"Nanhai Islands"   },
                  {"code":"TW-NAN", "value" :"Nantou County"   },
                  {"code":"TW-PEN", "value" :"Penghu County"   },
                  {"code":"TW-PIF", "value" :"Pingtung County"   },
                  {"code":"TW-TAO", "value" :"Taoyuan County"   },
                  {"code":"TW-TNN", "value" :"Tainan City"   },
                  {"code":"TW-TNQ", "value" :"Tainan County"   },
                  {"code":"TW-TPE", "value" :"Taipei City"   },
                  {"code":"TW-TPQ", "value" :"Taipei County"   },
                  {"code":"TW-TTT", "value" :"Taitung County"   },
                  {"code":"TW-TXG", "value" :"Taichung City"   },
                  {"code":"TW-TXQ", "value" :"Taichung County"   },
                  {"code":"TW-YUN", "value" :"Yunlin County"   },
                  {"code":"TZ-01", "value" :"Arusha"   },
                  {"code":"TZ-02", "value" :"Dar es Salaam"   },
                  {"code":"TZ-03", "value" :"Dodoma"   },
                  {"code":"TZ-04", "value" :"Iringa"   },
                  {"code":"TZ-05", "value" :"Kagera"   },
                  {"code":"TZ-06", "value" :"Kaskazini Pemba"   },
                  {"code":"TZ-07", "value" :"Kaskazini Unguja"   },
                  {"code":"TZ-08", "value" :"Kigoma"   },
                  {"code":"TZ-09", "value" :"Kilimanjaro"   },
                  {"code":"TZ-10", "value" :"Kusini Pemba"   },
                  {"code":"TZ-11", "value" :"Kusini Unguja"   },
                  {"code":"TZ-12", "value" :"Lindi"   },
                  {"code":"TZ-13", "value" :"Mara"   },
                  {"code":"TZ-14", "value" :"Mbeya"   },
                  {"code":"TZ-15", "value" :"Mjini Magharibi"   },
                  {"code":"TZ-16", "value" :"Morogoro"   },
                  {"code":"TZ-17", "value" :"Mtwara"   },
                  {"code":"TZ-18", "value" :"Mwanza"   },
                  {"code":"TZ-19", "value" :"Pwani"   },
                  {"code":"TZ-20", "value" :"Rukwa"   },
                  {"code":"TZ-21", "value" :"Ruvuma"   },
                  {"code":"TZ-22", "value" :"Shinyanga"   },
                  {"code":"TZ-23", "value" :"Singida"   },
                  {"code":"TZ-24", "value" :"Tabora"   },
                  {"code":"TZ-25", "value" :"Tanga"   },
                  {"code":"TZ-26", "value" :"Manyara"   },
                  {"code":"UA-05", "value" :"Vinnytsia Oblast"   },
                  {"code":"UA-07", "value" :"Volyn Oblast"   },
                  {"code":"UA-09", "value" :"Luhansk Oblast"   },
                  {"code":"UA-12", "value" :"Dnipropetrovsk Oblast"   },
                  {"code":"UA-14", "value" :"Donetsk Oblast"   },
                  {"code":"UA-18", "value" :"Zhytomyr Oblast"   },
                  {"code":"UA-21", "value" :"Zakarpattia Oblast"   },
                  {"code":"UA-23", "value" :"Zaporizhia Oblast"   },
                  {"code":"UA-26", "value" :"Ivano-Frankivsk Oblast"   },
                  {"code":"UA-30", "value" :"Kiev"   },
                  {"code":"UA-32", "value" :"Kiev Oblast"   },
                  {"code":"UA-35", "value" :"Kirovohrad Oblast"   },
                  {"code":"UA-40", "value" :"Sevastopol"   },
                  {"code":"UA-43", "value" :"Autonomous Republic of Crimea"   },
                  {"code":"UA-46", "value" :"Lviv Oblast"   },
                  {"code":"UA-48", "value" :"Mykolaiv Oblast"   },
                  {"code":"UA-51", "value" :"Odessa Oblast"   },
                  {"code":"UA-53", "value" :"Poltava Oblast"   },
                  {"code":"UA-56", "value" :"Rivne Oblast"   },
                  {"code":"UA-59", "value" :"Sumy Oblast"   },
                  {"code":"UA-61", "value" :"Ternopil Oblast"   },
                  {"code":"UA-63", "value" :"Kharkiv Oblast"   },
                  {"code":"UA-65", "value" :"Kherson Oblast"   },
                  {"code":"UA-68", "value" :"Khmelnytskyi Oblast"   },
                  {"code":"UA-71", "value" :"Cherkasy Oblast"   },
                  {"code":"UA-74", "value" :"Chernihiv Oblast"   },
                  {"code":"UA-77", "value" :"Chernivtsi Oblast"   },
                  {"code":"UG-101", "value" :"Kalangala"   },
                  {"code":"UG-102", "value" :"Kampala"   },
                  {"code":"UG-103", "value" :"Kiboga"   },
                  {"code":"UG-104", "value" :"Luwero"   },
                  {"code":"UG-105", "value" :"Masaka"   },
                  {"code":"UG-106", "value" :"Mpigi"   },
                  {"code":"UG-107", "value" :"Mubende"   },
                  {"code":"UG-108", "value" :"Mukono"   },
                  {"code":"UG-109", "value" :"Nakasongola"   },
                  {"code":"UG-110", "value" :"Rakai"   },
                  {"code":"UG-111", "value" :"Sembabule"   },
                  {"code":"UG-112", "value" :"Kayunga"   },
                  {"code":"UG-113", "value" :"Wakiso"   },
                  {"code":"UG-201", "value" :"Bugiri"   },
                  {"code":"UG-202", "value" :"Busia"   },
                  {"code":"UG-203", "value" :"Iganga"   },
                  {"code":"UG-204", "value" :"Jinja"   },
                  {"code":"UG-205", "value" :"Kamuli"   },
                  {"code":"UG-206", "value" :"Kapchorwa"   },
                  {"code":"UG-207", "value" :"Katakwi"   },
                  {"code":"UG-208", "value" :"Kumi"   },
                  {"code":"UG-209", "value" :"Mbale"   },
                  {"code":"UG-210", "value" :"Pallisa"   },
                  {"code":"UG-211", "value" :"Soroti"   },
                  {"code":"UG-212", "value" :"Tororo"   },
                  {"code":"UG-213", "value" :"Kaberamaido"   },
                  {"code":"UG-214", "value" :"Mayuge"   },
                  {"code":"UG-215", "value" :"Sironko"   },
                  {"code":"UG-301", "value" :"Adjumani"   },
                  {"code":"UG-302", "value" :"Apac"   },
                  {"code":"UG-303", "value" :"Arua"   },
                  {"code":"UG-304", "value" :"Gulu"   },
                  {"code":"UG-305", "value" :"Kitgum"   },
                  {"code":"UG-306", "value" :"Kotido"   },
                  {"code":"UG-307", "value" :"Lira"   },
                  {"code":"UG-308", "value" :"Moroto"   },
                  {"code":"UG-309", "value" :"Moyo"   },
                  {"code":"UG-310", "value" :"Nebbi"   },
                  {"code":"UG-311", "value" :"Nakapiripirit"   },
                  {"code":"UG-312", "value" :"Pader"   },
                  {"code":"UG-313", "value" :"Yumbe"   },
                  {"code":"UG-401", "value" :"Bundibugyo"   },
                  {"code":"UG-402", "value" :"Bushenyi"   },
                  {"code":"UG-403", "value" :"Hoima"   },
                  {"code":"UG-404", "value" :"Kabale"   },
                  {"code":"UG-405", "value" :"Kabarole"   },
                  {"code":"UG-406", "value" :"Kasese"   },
                  {"code":"UG-407", "value" :"Kibale"   },
                  {"code":"UG-408", "value" :"Kisoro"   },
                  {"code":"UG-409", "value" :"Masindi"   },
                  {"code":"UG-410", "value" :"Mbarara"   },
                  {"code":"UG-411", "value" :"Ntungamo"   },
                  {"code":"UG-412", "value" :"Rukungiri"   },
                  {"code":"UG-413", "value" :"Kamwenge"   },
                  {"code":"UG-414", "value" :"Kanungu"   },
                  {"code":"UG-415", "value" :"Kyenjojo"   },
                  {"code":"US-AK", "value" :"Alaska"   },
                  {"code":"US-AL", "value" :"Alabama"   },
                  {"code":"US-AR", "value" :"Arkansas"   },
                  {"code":"US-AS", "value" :"American Samoa"   },
                  {"code":"US-AZ", "value" :"Arizona"   },
                  {"code":"US-CA", "value" :"California"   },
                  {"code":"US-CO", "value" :"Colorado"   },
                  {"code":"US-CT", "value" :"Connecticut"   },
                  {"code":"US-DC", "value" :"District Of Columbia"   },
                  {"code":"US-DE", "value" :"Delaware"   },
                  {"code":"US-FL", "value" :"Florida"   },
                  {"code":"US-FM", "value" :"Federated States of Micronesia"   },
                  {"code":"US-GA", "value" :"Georgia"   },
                  {"code":"US-GU", "value" :"Guam"   },
                  {"code":"US-HI", "value" :"Hawaii"   },
                  {"code":"US-IA", "value" :"Iowa"   },
                  {"code":"US-ID", "value" :"Idaho"   },
                  {"code":"US-IL", "value" :"Illinois"   },
                  {"code":"US-IN", "value" :"Indiana"   },
                  {"code":"US-KS", "value" :"Kansas"   },
                  {"code":"US-KY", "value" :"Kentucky"   },
                  {"code":"US-LA", "value" :"Louisiana"   },
                  {"code":"US-MA", "value" :"Massachusetts"   },
                  {"code":"US-MD", "value" :"Maryland"   },
                  {"code":"US-ME", "value" :"Maine"   },
                  {"code":"US-MH", "value" :"Marshall Islands"   },
                  {"code":"US-MI", "value" :"Michigan"   },
                  {"code":"US-MN", "value" :"Minnesota"   },
                  {"code":"US-MO", "value" :"Missouri"   },
                  {"code":"US-MP", "value" :"Northern Mariana Islands"   },
                  {"code":"US-MS", "value" :"Mississippi"   },
                  {"code":"US-MT", "value" :"Montana"   },
                  {"code":"US-NC", "value" :"North Carolina"   },
                  {"code":"US-ND", "value" :"North Dakota"   },
                  {"code":"US-NE", "value" :"Nebraska"   },
                  {"code":"US-NH", "value" :"New Hampshire"   },
                  {"code":"US-NJ", "value" :"New Jersey"   },
                  {"code":"US-NM", "value" :"New Mexico"   },
                  {"code":"US-NV", "value" :"Nevada"   },
                  {"code":"US-NY", "value" :"New York"   },
                  {"code":"US-OH", "value" :"Ohio"   },
                  {"code":"US-OK", "value" :"Oklahoma"   },
                  {"code":"US-OR", "value" :"Oregon"   },
                  {"code":"US-PA", "value" :"Pennsylvania"   },
                  {"code":"US-PR", "value" :"Puerto Rico"   },
                  {"code":"US-PW", "value" :"Palau"   },
                  {"code":"US-RI", "value" :"Rhode Island"   },
                  {"code":"US-SC", "value" :"South Carolina"   },
                  {"code":"US-SD", "value" :"South Dakota"   },
                  {"code":"US-TN", "value" :"Tennessee"   },
                  {"code":"US-TX", "value" :"Texas"   },
                  {"code":"US-UM", "value" :"Minor Outlying Islands"   },
                  {"code":"US-UT", "value" :"Utah"   },
                  {"code":"US-VA", "value" :"Virginia"   },
                  {"code":"US-VI", "value" :"Virgin Islands"   },
                  {"code":"US-VT", "value" :"Vermont"   },
                  {"code":"US-WA", "value" :"Washington"   },
                  {"code":"US-WI", "value" :"Wisconsin"   },
                  {"code":"US-WV", "value" :"West Virginia"   },
                  {"code":"US-WY", "value" :"Wyoming"   },
                  {"code":"UY-AR", "value" :"Artigas"   },
                  {"code":"UY-CA", "value" :"Canelones"   },
                  {"code":"UY-CL", "value" :"Cerro Largo"   },
                  {"code":"UY-CO", "value" :"Colonia"   },
                  {"code":"UY-DU", "value" :"Durazno"   },
                  {"code":"UY-FD", "value" :"Florida"   },
                  {"code":"UY-FS", "value" :"Flores"   },
                  {"code":"UY-LA", "value" :"Lavalleja"   },
                  {"code":"UY-MA", "value" :"Maldonado"   },
                  {"code":"UY-MO", "value" :"Montevideo"   },
                  {"code":"UY-PA", "value" :"Paysandú"   },
                  {"code":"UY-RN", "value" :"Rio Negro"   },
                  {"code":"UY-RO", "value" :"Rocha"   },
                  {"code":"UY-RV", "value" :"Rivera"   },
                  {"code":"UY-SA", "value" :"Salto"   },
                  {"code":"UY-SJ", "value" :"San José"   },
                  {"code":"UY-SO", "value" :"Soriano"   },
                  {"code":"UY-TA", "value" :"Tacuarembó"   },
                  {"code":"UY-TT", "value" :"Treinta y Tres"   },
                  {"code":"UZ-AN", "value" :"Andijan Province"   },
                  {"code":"UZ-BU", "value" :"Bukhara Province"   },
                  {"code":"UZ-FA", "value" :"Fergana Province"   },
                  {"code":"UZ-JI", "value" :"Jizzakh Province"   },
                  {"code":"UZ-NG", "value" :"Namangan Province"   },
                  {"code":"UZ-NW", "value" :"Navoiy Province"   },
                  {"code":"UZ-QA", "value" :"Qashqadaryo Province"   },
                  {"code":"UZ-QR", "value" :"Karakalpakstan Republic"   },
                  {"code":"UZ-SA", "value" :"Samarqand Province"   },
                  {"code":"UZ-SI", "value" :"Sirdaryo Province"   },
                  {"code":"UZ-SU", "value" :"Surxondaryo Province"   },
                  {"code":"UZ-TK", "value" :"Tashkent City"   },
                  {"code":"UZ-TO", "value" :"Tashkent Province"   },
                  {"code":"UZ-XO", "value" :"Xorazm Province"   },
                  {"code":"VC-01", "value" :"Charlotte"   },
                  {"code":"VC-02", "value" :"Saint Andrew"   },
                  {"code":"VC-03", "value" :"Saint David"   },
                  {"code":"VC-04", "value" :"Saint George"   },
                  {"code":"VC-05", "value" :"Saint Patrick"   },
                  {"code":"VC-06", "value" :"Grenadines"   },
                  {"code":"VE-A", "value" :"Caracas"   },
                  {"code":"VE-B", "value" :"Anzoátegui"   },
                  {"code":"VE-C", "value" :"Apure"   },
                  {"code":"VE-D", "value" :"Aragua"   },
                  {"code":"VE-E", "value" :"Barinas"   },
                  {"code":"VE-F", "value" :"Bolívar"   },
                  {"code":"VE-G", "value" :"Carabobo"   },
                  {"code":"VE-H", "value" :"Cojedes"   },
                  {"code":"VE-I", "value" :"Falcón"   },
                  {"code":"VE-J", "value" :"Guárico"   },
                  {"code":"VE-K", "value" :"Lara"   },
                  {"code":"VE-L", "value" :"Mérida"   },
                  {"code":"VE-M", "value" :"Miranda"   },
                  {"code":"VE-N", "value" :"Monagas"   },
                  {"code":"VE-O", "value" :"Nueva Esparta"   },
                  {"code":"VE-P", "value" :"Portuguesa"   },
                  {"code":"VE-R", "value" :"Sucre"   },
                  {"code":"VE-S", "value" :"Táchira"   },
                  {"code":"VE-T", "value" :"Trujillo"   },
                  {"code":"VE-U", "value" :"Yaracuy"   },
                  {"code":"VE-V", "value" :"Zulia"   },
                  {"code":"VE-W", "value" :"Dependencias Federales"   },
                  {"code":"VE-X", "value" :"Vargas"   },
                  {"code":"VE-Y", "value" :"Delta Amacuro"   },
                  {"code":"VE-Z", "value" :"Amazonas"   },
                  {"code":"VN-01", "value" :"Lai Châu"   },
                  {"code":"VN-02", "value" :"Lào Cai"   },
                  {"code":"VN-03", "value" :"Hà Giang"   },
                  {"code":"VN-04", "value" :"Cao Bằng"   },
                  {"code":"VN-05", "value" :"Sơn La"   },
                  {"code":"VN-06", "value" :"Yên Bái"   },
                  {"code":"VN-07", "value" :"Tuyên Quang"   },
                  {"code":"VN-09", "value" :"Lạng Sơn"   },
                  {"code":"VN-13", "value" :"Quảng Ninh"   },
                  {"code":"VN-14", "value" :"Hòa Bình"   },
                  {"code":"VN-15", "value" :"Hà Tây"   },
                  {"code":"VN-18", "value" :"Ninh Bình"   },
                  {"code":"VN-20", "value" :"Thái Bình"   },
                  {"code":"VN-21", "value" :"Thanh Hóa"   },
                  {"code":"VN-22", "value" :"Nghệ An"   },
                  {"code":"VN-23", "value" :"Hà Tĩnh"   },
                  {"code":"VN-24", "value" :"Quảng Bình"   },
                  {"code":"VN-25", "value" :"Quảng Trị"   },
                  {"code":"VN-26", "value" :"Thừa Thiên - Huế"   },
                  {"code":"VN-27", "value" :"Quảng Nam"   },
                  {"code":"VN-28", "value" :"Kon Tum"   },
                  {"code":"VN-29", "value" :"Quảng Ngãi"   },
                  {"code":"VN-30", "value" :"Gia Lai"   },
                  {"code":"VN-31", "value" :"Bình Định"   },
                  {"code":"VN-32", "value" :"Phú Yên"   },
                  {"code":"VN-33", "value" :"Đắk Lắk"   },
                  {"code":"VN-34", "value" :"Khánh Hòa"   },
                  {"code":"VN-35", "value" :"Lâm Đồng"   },
                  {"code":"VN-36", "value" :"Ninh Thuận"   },
                  {"code":"VN-37", "value" :"Tây Ninh"   },
                  {"code":"VN-39", "value" :"Đồng Nai"   },
                  {"code":"VN-40", "value" :"Bình Thuận"   },
                  {"code":"VN-41", "value" :"Long An"   },
                  {"code":"VN-43", "value" :"Bà Rịa - Vũng Tàu"   },
                  {"code":"VN-44", "value" :"An Giang"   },
                  {"code":"VN-45", "value" :"Đồng Tháp"   },
                  {"code":"VN-46", "value" :"Tiền Giang"   },
                  {"code":"VN-47", "value" :"Kiên Giang"   },
                  {"code":"VN-48", "value" :"Cần Thơ"   },
                  {"code":"VN-49", "value" :"Vĩnh Long"   },
                  {"code":"VN-50", "value" :"Bến Tre"   },
                  {"code":"VN-51", "value" :"Trà Vinh"   },
                  {"code":"VN-52", "value" :"Sóc Trăng"   },
                  {"code":"VN-53", "value" :"Bắc Kạn"   },
                  {"code":"VN-54", "value" :"Bắc Giang"   },
                  {"code":"VN-55", "value" :"Bạc Liêu"   },
                  {"code":"VN-56", "value" :"Bắc Ninh"   },
                  {"code":"VN-57", "value" :"Bình Dương"   },
                  {"code":"VN-58", "value" :"Bình Phước"   },
                  {"code":"VN-59", "value" :"Cà Mau"   },
                  {"code":"VN-60", "value" :"Đà Nẵng"   },
                  {"code":"VN-61", "value" :"Hải Dương"   },
                  {"code":"VN-62", "value" :"Hải Phòng"   },
                  {"code":"VN-63", "value" :"Hà Nam"   },
                  {"code":"VN-64", "value" :"Hà Nội"   },
                  {"code":"VN-65", "value" :"Hồ Chí Minh"   },
                  {"code":"VN-66", "value" :"Hưng Yên"   },
                  {"code":"VN-67", "value" :"Nam Định"   },
                  {"code":"VN-68", "value" :"Phú Thọ"   },
                  {"code":"VN-69", "value" :"Thái Nguyên"   },
                  {"code":"VN-70", "value" :"Vĩnh Phúc"   },
                  {"code":"VN-71", "value" :"Điện Biên"   },
                  {"code":"VN-72", "value" :"Đắk Nông"   },
                  {"code":"VN-73", "value" :"Hậu Giang"   },
                  {"code":"VU-MAP", "value" :"Malampa"   },
                  {"code":"VU-PAM", "value" :"Pénama"   },
                  {"code":"VU-SAM", "value" :"Sanma"   },
                  {"code":"VU-SEE", "value" :"Shéfa"   },
                  {"code":"VU-TAE", "value" :"Taféa"   },
                  {"code":"VU-TOB", "value" :"Torba"   },
                  {"code":"WS-AA", "value" :"A'ana"   },
                  {"code":"WS-AL", "value" :"Aiga-i-le-Tai"   },
                  {"code":"WS-AT", "value" :"Atua"   },
                  {"code":"WS-FA", "value" :"Fa 'asaleleaga"   },
                  {"code":"WS-GE", "value" :"Gaga'emauga"   },
                  {"code":"WS-GI", "value" :"Gagaifomauga"   },
                  {"code":"WS-PA", "value" :"Palauli"   },
                  {"code":"WS-SA", "value" :"Satupa'itea"   },
                  {"code":"WS-TU", "value" :"Tuamasaga"   },
                  {"code":"WS-VF", "value" :"Va'a-o-Fonoti"   },
                  {"code":"WS-VS", "value" :"Vaisigano"   },
                  {"code":"YE-AB", "value" :"Abyan"   },
                  {"code":"YE-AD", "value" :"'Adan"   },
                  {"code":"YE-AM", "value" :"'Amran"   },
                  {"code":"YE-BA", "value" :"Al Bayda"   },
                  {"code":"YE-DA", "value" :"Ad Dali"   },
                  {"code":"YE-DH", "value" :"Dhamar"   },
                  {"code":"YE-HD", "value" :"Hadramaut"   },
                  {"code":"YE-HJ", "value" :"Hajjah"   },
                  {"code":"YE-HU", "value" :"Al Hudaydah"   },
                  {"code":"YE-IB", "value" :"Ibb"   },
                  {"code":"YE-JA", "value" :"Al Jawf"   },
                  {"code":"YE-LA", "value" :"Lahij"   },
                  {"code":"YE-MA", "value" :"Ma 'rib"   },
                  {"code":"YE-MR", "value" :"Al Mahrah"   },
                  {"code":"YE-MW", "value" :"Al Mahwit"   },
                  {"code":"YE-RA", "value" :"Raymah"   },
                  {"code":"YE-SD", "value" :"Sa 'dah"   },
                  {"code":"YE-SH", "value" :"Shabwah"   },
                  {"code":"YE-SN", "value" :"Sana 'a"   },
                  {"code":"YE-TA", "value" :"Ta 'izz"   },
                  {"code":"ZA-EC", "value" :"Eastern Cape"   },
                  {"code":"ZA-FS", "value" :"Free State"   },
                  {"code":"ZA-GT", "value" :"Gauteng"   },
                  {"code":"ZA-LP", "value" :"Limpopo"   },
                  {"code":"ZA-MP", "value" :"Mpumalanga"   },
                  {"code":"ZA-NC", "value" :"Northern Cape"   },
                  {"code":"ZA-NL", "value" :"KwaZulu-Natal"   },
                  {"code":"ZA-NW", "value" :"North West"   },
                  {"code":"ZA-WC", "value" :"Western Cape"   },
                  {"code":"ZM-01", "value" :"Western"   },
                  {"code":"ZM-02", "value" :"Central"   },
                  {"code":"ZM-03", "value" :"Eastern"   },
                  {"code":"ZM-04", "value" :"Luapula"   },
                  {"code":"ZM-05", "value" :"Northern"   },
                  {"code":"ZM-06", "value" :"North-Western"   },
                  {"code":"ZM-07", "value" :"Southern"   },
                  {"code":"ZM-08", "value" :"Copperbelt"   },
                  {"code":"ZM-09", "value" :"Lusaka"   },
                  {"code":"ZW-BU", "value" :"Bulawayo"   },
                  {"code":"ZW-HA", "value" :"Harare"   },
                  {"code":"ZW-MA", "value" :"Manicaland"   },
                  {"code":"ZW-MC", "value" :"Mashonaland Central"   },
                  {"code":"ZW-ME", "value" :"Mashonaland East"   },
                  {"code":"ZW-MI", "value" :"Midlands"   },
                  {"code":"ZW-MN", "value" :"Matabeleland North"   },
                  {"code":"ZW-MS", "value" :"Matabeleland South"   },
                  {"code":"ZW-MV", "value" :"Masvingo"   },
                  {"code":"ZW-MW", "value" :"Mashonaland West" }
              ];
              return province;
          },

          getCountryCodes : function (){
              var countryCodes = [
                  {
                      "country":"United States",
                      "code":"1"
                  }
                  // {
                  //   "country":"India",
                  //   "code":"91"
                  // }

                  // {
                  //   "country":"Afghanistan",
                  //   "code":"93"
                  // },
                  // {
                  //   "country":"Albania",
                  //   "code":"355"
                  // },
                  // {
                  //   "country":"Algeria",
                  //   "code":"213"
                  // },
                  // {
                  //   "country":"American Samoa",
                  //   "code":"1 684"
                  // },
                  // {
                  //   "country":"Andorra",
                  //   "code":"376"
                  // },
                  // {
                  //   "country":"Angola",
                  //   "code":"244"
                  // },
                  // {
                  //   "country":"Anguilla",
                  //   "code":"1 264"
                  // },
                  // {
                  //   "country":"Antarctica",
                  //   "code":"672"
                  // },
                  // {
                  //   "country":"Antigua and Barbuda",
                  //   "code":"1 268"
                  // },
                  // {
                  //   "country":"Argentina",
                  //   "code":"54"
                  // },
                  // {
                  //   "country":"Armenia",
                  //   "code":"374"
                  // },
                  // {
                  //   "country":"Aruba",
                  //   "code":"297"
                  // },
                  // {
                  //   "country":"Australia",
                  //   "code":"61"
                  // },
                  // {
                  //   "country":"Austria",
                  //   "code":"43"
                  // },
                  // {
                  //   "country":"Azerbaijan",
                  //   "code":"994"
                  // },
                  // {
                  //   "country":"Bahamas",
                  //   "code":"1 242"
                  // },
                  // {
                  //   "country":"Bahrain",
                  //   "code":"973"
                  // },
                  // {
                  //   "country":"Bangladesh",
                  //   "code":"880"
                  // },
                  // {
                  //   "country":"Barbados",
                  //   "code":"1 246"
                  // },
                  // {
                  //   "country":"Belarus",
                  //   "code":"375"
                  // },
                  // {
                  //   "country":"Belgium",
                  //   "code":"32"
                  // },
                  // {
                  //   "country":"Belize",
                  //   "code":"501"
                  // },
                  // {
                  //   "country":"Benin",
                  //   "code":"229"
                  // },
                  // {
                  //   "country":"Bermuda",
                  //   "code":"1 441"
                  // },
                  // {
                  //   "country":"Bhutan",
                  //   "code":"975"
                  // },
                  // {
                  //   "country":"Bolivia",
                  //   "code":"591"
                  // },
                  // {
                  //   "country":"Bosnia and Herzegovina",
                  //   "code":"387"
                  // },
                  // {
                  //   "country":"Botswana",
                  //   "code":"267"
                  // },
                  // {
                  //   "country":"Brazil",
                  //   "code":"55"
                  // },
                  // {
                  //   "country":"British Virgin Islands",
                  //   "code":"1 284"
                  // },
                  // {
                  //   "country":"Brunei",
                  //   "code":"673"
                  // },
                  // {
                  //   "country":"Bulgaria",
                  //   "code":"359"
                  // },
                  // {
                  //   "country":"Burkina Faso",
                  //   "code":"226"
                  // },
                  // {
                  //   "country":"Burma (Myanmar)",
                  //   "code":"95"
                  // },
                  // {
                  //   "country":"Burundi",
                  //   "code":"257"
                  // },
                  // {
                  //   "country":"Cambodia",
                  //   "code":"855"
                  // },
                  // {
                  //   "country":"Cameroon",
                  //   "code":"237"
                  // },
                  // {
                  //   "country":"Canada",
                  //   "code":"1"
                  // },
                  // {
                  //   "country":"Cape Verde",
                  //   "code":"238"
                  // },
                  // {
                  //   "country":"Cayman Islands",
                  //   "code":"1 345"
                  // },
                  // {
                  //   "country":"Central African Republic",
                  //   "code":"236"
                  // },
                  // {
                  //   "country":"Chad",
                  //   "code":"235"
                  // },
                  // {
                  //   "country":"Chile",
                  //   "code":"56"
                  // },
                  // {
                  //   "country":"China",
                  //   "code":"86"
                  // },
                  // {
                  //   "country":"Christmas Island",
                  //   "code":"61"
                  // },
                  // {
                  //   "country":"Cocos (Keeling) Islands",
                  //   "code":"61"
                  // },
                  // {
                  //   "country":"Colombia",
                  //   "code":"57"
                  // },
                  // {
                  //   "country":"Comoros",
                  //   "code":"269"
                  // },
                  // {
                  //   "country":"Cook Islands",
                  //   "code":"682"
                  // },
                  // {
                  //   "country":"Costa Rica",
                  //   "code":"506"
                  // },
                  // {
                  //   "country":"Croatia",
                  //   "code":"385"
                  // },
                  // {
                  //   "country":"Cuba",
                  //   "code":"53"
                  // },
                  // {
                  //   "country":"Cyprus",
                  //   "code":"357"
                  // },
                  // {
                  //   "country":"Czech Republic",
                  //   "code":"420"
                  // },
                  // {
                  //   "country":"Democratic Republic of the Congo",
                  //   "code":"243"
                  // },
                  // {
                  //   "country":"Denmark",
                  //   "code":"45"
                  // },
                  // {
                  //   "country":"Djibouti",
                  //   "code":"253"
                  // },
                  // {
                  //   "country":"Dominica",
                  //   "code":"1 767"
                  // },
                  // {
                  //   "country":"Dominican Republic",
                  //   "code":"1 809"
                  // },
                  // {
                  //   "country":"Ecuador",
                  //   "code":"593"
                  // },
                  // {
                  //   "country":"Egypt",
                  //   "code":"20"
                  // },
                  // {
                  //   "country":"El Salvador",
                  //   "code":"503"
                  // },
                  // {
                  //   "country":"Equatorial Guinea",
                  //   "code":"240"
                  // },
                  // {
                  //   "country":"Eritrea",
                  //   "code":"291"
                  // },
                  // {
                  //   "country":"Estonia",
                  //   "code":"372"
                  // },
                  // {
                  //   "country":"Ethiopia",
                  //   "code":"251"
                  // },
                  // {
                  //   "country":"Falkland Islands",
                  //   "code":"500"
                  // },
                  // {
                  //   "country":"Faroe Islands",
                  //   "code":"298"
                  // },
                  // {
                  //   "country":"Fiji",
                  //   "code":"679"
                  // },
                  // {
                  //   "country":"Finland",
                  //   "code":"358"
                  // },
                  // {
                  //   "country":"France",
                  //   "code":"33"
                  // },
                  // {
                  //   "country":"French Polynesia",
                  //   "code":"689"
                  // },
                  // {
                  //   "country":"Gabon",
                  //   "code":"241"
                  // },
                  // {
                  //   "country":"Gambia",
                  //   "code":"220"
                  // },
                  // {
                  //   "country":"Gaza Strip",
                  //   "code":"970"
                  // },
                  // {
                  //   "country":"Georgia",
                  //   "code":"995"
                  // },
                  // {
                  //   "country":"Germany",
                  //   "code":"49"
                  // },
                  // {
                  //   "country":"Ghana",
                  //   "code":"233"
                  // },
                  // {
                  //   "country":"Gibraltar",
                  //   "code":"350"
                  // },
                  // {
                  //   "country":"Greece",
                  //   "code":"30"
                  // },
                  // {
                  //   "country":"Greenland",
                  //   "code":"299"
                  // },
                  // {
                  //   "country":"Grenada",
                  //   "code":"1 473"
                  // },
                  // {
                  //   "country":"Guam",
                  //   "code":"1 671"
                  // },
                  // {
                  //   "country":"Guatemala",
                  //   "code":"502"
                  // },
                  // {
                  //   "country":"Guinea",
                  //   "code":"224"
                  // },
                  // {
                  //   "country":"Guinea-Bissau",
                  //   "code":"245"
                  // },
                  // {
                  //   "country":"Guyana",
                  //   "code":"592"
                  // },
                  // {
                  //   "country":"Haiti",
                  //   "code":"509"
                  // },
                  // {
                  //   "country":"Holy See (Vatican City)",
                  //   "code":"39"
                  // },
                  // {
                  //   "country":"Honduras",
                  //   "code":"504"
                  // },
                  // {
                  //   "country":"Hong Kong",
                  //   "code":"852"
                  // },
                  // {
                  //   "country":"Hungary",
                  //   "code":"36"
                  // },
                  // {
                  //   "country":"Iceland",
                  //   "code":"354"
                  // },
                  // {
                  //   "country":"India",
                  //   "code":"91"
                  // },
                  // {
                  //   "country":"Indonesia",
                  //   "code":"62"
                  // },
                  // {
                  //   "country":"Iran",
                  //   "code":"98"
                  // },
                  // {
                  //   "country":"Iraq",
                  //   "code":"964"
                  // },
                  // {
                  //   "country":"Ireland",
                  //   "code":"353"
                  // },
                  // {
                  //   "country":"Isle of Man",
                  //   "code":"44"
                  // },
                  // {
                  //   "country":"Israel",
                  //   "code":"972"
                  // },
                  // {
                  //   "country":"Italy",
                  //   "code":"39"
                  // },
                  // {
                  //   "country":"Ivory Coast",
                  //   "code":"225"
                  // },
                  // {
                  //   "country":"Jamaica",
                  //   "code":"1 876"
                  // },
                  // {
                  //   "country":"Japan",
                  //   "code":"81"
                  // },
                  // {
                  //   "country":"Jersey",
                  //   "code":""
                  // },
                  // {
                  //   "country":"Jordan",
                  //   "code":"962"
                  // },
                  // {
                  //   "country":"Kazakhstan",
                  //   "code":"7"
                  // },
                  // {
                  //   "country":"Kenya",
                  //   "code":"254"
                  // },
                  // {
                  //   "country":"Kiribati",
                  //   "code":"686"
                  // },
                  // {
                  //   "country":"Kosovo",
                  //   "code":"381"
                  // },
                  // {
                  //   "country":"Kuwait",
                  //   "code":"965"
                  // },
                  // {
                  //   "country":"Kyrgyzstan",
                  //   "code":"996"
                  // },
                  // {
                  //   "country":"Laos",
                  //   "code":"856"
                  // },
                  // {
                  //   "country":"Latvia",
                  //   "code":"371"
                  // },
                  // {
                  //   "country":"Lebanon",
                  //   "code":"961"
                  // },
                  // {
                  //   "country":"Lesotho",
                  //   "code":"266"
                  // },
                  // {
                  //   "country":"Liberia",
                  //   "code":"231"
                  // },
                  // {
                  //   "country":"Libya",
                  //   "code":"218"
                  // },
                  // {
                  //   "country":"Liechtenstein",
                  //   "code":"423"
                  // },
                  // {
                  //   "country":"Lithuania",
                  //   "code":"370"
                  // },
                  // {
                  //   "country":"Luxembourg",
                  //   "code":"352"
                  // },
                  // {
                  //   "country":"Macau",
                  //   "code":"853"
                  // },
                  // {
                  //   "country":"Macedonia",
                  //   "code":"389"
                  // },
                  // {
                  //   "country":"Madagascar",
                  //   "code":"261"
                  // },
                  // {
                  //   "country":"Malawi",
                  //   "code":"265"
                  // },
                  // {
                  //   "country":"Malaysia",
                  //   "code":"60"
                  // },
                  // {
                  //   "country":"Maldives",
                  //   "code":"960"
                  // },
                  // {
                  //   "country":"Mali",
                  //   "code":"223"
                  // },
                  // {
                  //   "country":"Malta",
                  //   "code":"356"
                  // },
                  // {
                  //   "country":"Marshall Islands",
                  //   "code":"692"
                  // },
                  // {
                  //   "country":"Mauritania",
                  //   "code":"222"
                  // },
                  // {
                  //   "country":"Mauritius",
                  //   "code":"230"
                  // },
                  // {
                  //   "country":"Mayotte",
                  //   "code":"262"
                  // },
                  // {
                  //   "country":"Mexico",
                  //   "code":"52"
                  // },
                  // {
                  //   "country":"Micronesia",
                  //   "code":"691"
                  // },
                  // {
                  //   "country":"Moldova",
                  //   "code":"373"
                  // },
                  // {
                  //   "country":"Monaco",
                  //   "code":"377"
                  // },
                  // {
                  //   "country":"Mongolia",
                  //   "code":"976"
                  // },
                  // {
                  //   "country":"Montenegro",
                  //   "code":"382"
                  // },
                  // {
                  //   "country":"Montserrat",
                  //   "code":"1 664"
                  // },
                  // {
                  //   "country":"Morocco",
                  //   "code":"212"
                  // },
                  // {
                  //   "country":"Mozambique",
                  //   "code":"258"
                  // },
                  // {
                  //   "country":"Namibia",
                  //   "code":"264"
                  // },
                  // {
                  //   "country":"Nauru",
                  //   "code":"674"
                  // },
                  // {
                  //   "country":"Nepal",
                  //   "code":"977"
                  // },
                  // {
                  //   "country":"Netherlands",
                  //   "code":"31"
                  // },
                  // {
                  //   "country":"Netherlands Antilles",
                  //   "code":"599"
                  // },
                  // {
                  //   "country":"New Caledonia",
                  //   "code":"687"
                  // },
                  // {
                  //   "country":"New Zealand",
                  //   "code":"64"
                  // },
                  // {
                  //   "country":"Nicaragua",
                  //   "code":"505"
                  // },
                  // {
                  //   "country":"Niger",
                  //   "code":"227"
                  // },
                  // {
                  //   "country":"Nigeria",
                  //   "code":"234"
                  // },
                  // {
                  //   "country":"Niue",
                  //   "code":"683"
                  // },
                  // {
                  //   "country":"Norfolk Island",
                  //   "code":"672"
                  // },
                  // {
                  //   "country":"North Korea",
                  //   "code":"850"
                  // },
                  // {
                  //   "country":"Northern Mariana Islands",
                  //   "code":"1 670"
                  // },
                  // {
                  //   "country":"Norway",
                  //   "code":"47"
                  // },
                  // {
                  //   "country":"Oman",
                  //   "code":"968"
                  // },
                  // {
                  //   "country":"Pakistan",
                  //   "code":"92"
                  // },
                  // {
                  //   "country":"Palau",
                  //   "code":"680"
                  // },
                  // {
                  //   "country":"Panama",
                  //   "code":"507"
                  // },
                  // {
                  //   "country":"Papua New Guinea",
                  //   "code":"675"
                  // },
                  // {
                  //   "country":"Paraguay",
                  //   "code":"595"
                  // },
                  // {
                  //   "country":"Peru",
                  //   "code":"51"
                  // },
                  // {
                  //   "country":"Philippines",
                  //   "code":"63"
                  // },
                  // {
                  //   "country":"Pitcairn Islands",
                  //   "code":"870"
                  // },
                  // {
                  //   "country":"Poland",
                  //   "code":"48"
                  // },
                  // {
                  //   "country":"Portugal",
                  //   "code":"351"
                  // },
                  // {
                  //   "country":"Puerto Rico",
                  //   "code":"1"
                  // },
                  // {
                  //   "country":"Qatar",
                  //   "code":"974"
                  // },
                  // {
                  //   "country":"Republic of the Congo",
                  //   "code":"242"
                  // },
                  // {
                  //   "country":"Romania",
                  //   "code":"40"
                  // },
                  // {
                  //   "country":"Russia",
                  //   "code":"7"
                  // },
                  // {
                  //   "country":"Rwanda",
                  //   "code":"250"
                  // },
                  // {
                  //   "country":"Saint Barthelemy",
                  //   "code":"590"
                  // },
                  // {
                  //   "country":"Saint Helena",
                  //   "code":"290"
                  // },
                  // {
                  //   "country":"Saint Kitts and Nevis",
                  //   "code":"1 869"
                  // },
                  // {
                  //   "country":"Saint Lucia",
                  //   "code":"1 758"
                  // },
                  // {
                  //   "country":"Saint Martin",
                  //   "code":"1 599"
                  // },
                  // {
                  //   "country":"Saint Pierre and Miquelon",
                  //   "code":"508"
                  // },
                  // {
                  //   "country":"Saint Vincent and the Grenadines",
                  //   "code":"1 784"
                  // },
                  // {
                  //   "country":"Samoa",
                  //   "code":"685"
                  // },
                  // {
                  //   "country":"San Marino",
                  //   "code":"378"
                  // },
                  // {
                  //   "country":"Sao Tome and Principe",
                  //   "code":"239"
                  // },
                  // {
                  //   "country":"Saudi Arabia",
                  //   "code":"966"
                  // },
                  // {
                  //   "country":"Senegal",
                  //   "code":"221"
                  // },
                  // {
                  //   "country":"Serbia",
                  //   "code":"381"
                  // },
                  // {
                  //   "country":"Seychelles",
                  //   "code":"248"
                  // },
                  // {
                  //   "country":"Sierra Leone",
                  //   "code":"232"
                  // },
                  // {
                  //   "country":"Singapore",
                  //   "code":"65"
                  // },
                  // {
                  //   "country":"Slovakia",
                  //   "code":"421"
                  // },
                  // {
                  //   "country":"Slovenia",
                  //   "code":"386"
                  // },
                  // {
                  //   "country":"Solomon Islands",
                  //   "code":"677"
                  // },
                  // {
                  //   "country":"Somalia",
                  //   "code":"252"
                  // },
                  // {
                  //   "country":"South Africa",
                  //   "code":"27"
                  // },
                  // {
                  //   "country":"South Korea",
                  //   "code":"82"
                  // },
                  // {
                  //   "country":"Spain",
                  //   "code":"34"
                  // },
                  // {
                  //   "country":"Sri Lanka",
                  //   "code":"94"
                  // },
                  // {
                  //   "country":"Sudan",
                  //   "code":"249"
                  // },
                  // {
                  //   "country":"Suriname",
                  //   "code":"597"
                  // },
                  // {
                  //   "country":"Svalbard",
                  //   "code":""
                  // },
                  // {
                  //   "country":"Swaziland",
                  //   "code":"268"
                  // },
                  // {
                  //   "country":"Sweden",
                  //   "code":"46"
                  // },
                  // {
                  //   "country":"Switzerland",
                  //   "code":"41"
                  // },
                  // {
                  //   "country":"Syria",
                  //   "code":"963"
                  // },
                  // {
                  //   "country":"Taiwan",
                  //   "code":"886"
                  // },
                  // {
                  //   "country":"Tajikistan",
                  //   "code":"992"
                  // },
                  // {
                  //   "country":"Tanzania",
                  //   "code":"255"
                  // },
                  // {
                  //   "country":"Thailand",
                  //   "code":"66"
                  // },
                  // {
                  //   "country":"Timor-Leste",
                  //   "code":"670"
                  // },
                  // {
                  //   "country":"Togo",
                  //   "code":"228"
                  // },
                  // {
                  //   "country":"Tokelau",
                  //   "code":"690"
                  // },
                  // {
                  //   "country":"Tonga",
                  //   "code":"676"
                  // },
                  // {
                  //   "country":"Trinidad and Tobago",
                  //   "code":"1 868"
                  // },
                  // {
                  //   "country":"Tunisia",
                  //   "code":"216"
                  // },
                  // {
                  //   "country":"Turkey",
                  //   "code":"90"
                  // },
                  // {
                  //   "country":"Turkmenistan",
                  //   "code":"993"
                  // },
                  // {
                  //   "country":"Turks and Caicos Islands",
                  //   "code":"1 649"
                  // },
                  // {
                  //   "country":"Tuvalu",
                  //   "code":"688"
                  // },
                  // {
                  //   "country":"Uganda",
                  //   "code":"256"
                  // },
                  // {
                  //   "country":"Ukraine",
                  //   "code":"380"
                  // },
                  // {
                  //   "country":"United Arab Emirates",
                  //   "code":"971"
                  // },
                  // {
                  //   "country":"United Kingdom",
                  //   "code":"44"
                  // },
                  // {
                  //   "country":"Uruguay",
                  //   "code":"598"
                  // },
                  // {
                  //   "country":"US Virgin Islands",
                  //   "code":"1 340"
                  // },
                  // {
                  //   "country":"Uzbekistan",
                  //   "code":"998"
                  // },
                  // {
                  //   "country":"Vanuatu",
                  //   "code":"678"
                  // },
                  // {
                  //   "country":"Venezuela",
                  //   "code":"58"
                  // },
                  // {
                  //   "country":"Vietnam",
                  //   "code":"84"
                  // },
                  // {
                  //   "country":"Wallis and Futuna",
                  //   "code":"681"
                  // },
                  // {
                  //   "country":"West Bank",
                  //   "code":"970"
                  // },
                  // {
                  //   "country":"Western Sahara",
                  //   "code":""
                  // },
                  // {
                  //   "country":"Yemen",
                  //   "code":"967"
                  // },
                  // {
                  //   "country":"Zambia",
                  //   "code":"260"
                  // },
                  // {
                  //   "country":"Zimbabwe",
                  //   "code":"263"
                  // }
              ];
              return countryCodes;
          },

          getAdvertiserSignupCodes : function (){
              var advertiserSignupCodes = {
                  // years_of_experience: [
                  //     {"code": "1_less", "name": "Less Than 1 Year"},
                  //     {"code": "1_2", "name": "1-2 Years"},
                  //     {"code": "3_4", "name": "3-4 Years"},
                  //     {"code": "5_plus", "name": "5+ Years"}
                  // ],
                  // vertical: [
                  //     {"code": "auto_insurance", "name": "Auto Insurance"},
                  //     {"code": "health_insurance", "name": "Health Insurance"},
                  //     {"code": "life_insurance", "name": "Life Insurance"},
                  //     {"code": "home_insurance", "name": "Home Insurance"},
                  //     {"code": "addiction_rehab", "name": "Addiction/Rehab"},
                  //     {"code": "credit_repair", "name": "Credit Repair"},
                  //     {"code": "cable_satellite", "name": "Cable/Satellite"},
                  //     {"code": "mortgage_refinance", "name": "Mortgage/Refinance"},
                  //     {"code": "auto_loans", "name": "Auto Loans"},
                  //     {"code": "home_services", "name": "Home Services"},
                  //     {"code": "other", "name": "Other"}

                  // ],
                  // hear_about_us_from:[
                  //     {"code": "google", "name": "Google"},
                  //     {"code": "bing", "name": "Bing"},
                  //     {"code": "linkedin", "name": "Linkedin"},
                  //     {"code": "twitter", "name": "Twitter"},
                  //     {"code": "tradeshow", "name": "Tradeshow"},
                  //     {"code": "referred_by_a_friend", "name": "Referred by a friend"},
                  //     {"code": "other", "name": "Other"} 
                  // ],
                  // monthly_earnings: [
                  //     {"code": "0_9999", "name": "$0 - $9,999"},
                  //     {"code": "10000_49999", "name": "$10,000 - $49,999"},
                  //     {"code": "50000_149999", "name": "$50,000 - $149,999"},
                  //     {"code": "150000_499999", "name": "$150,000 - $499,999"},
                  //     {"code": "500,000_plus", "name": "$500,000+"}
                  // ],
                  page_data: [
                      {"code": "50", "name": "50"},
                      {"code": "100", "name": "100"},
                      {"code": "150", "name": "150"},
                      {"code": "200", "name": "200"},
                      {"code": "250", "name": "250"},
                      {"code": "300", "name": "300"}
                  ]
              };
              return advertiserSignupCodes;
          },
          
          getPublisherSignupCodes : function (){
              var publisherSignupCodes = {
                  years_of_experience: [
                      {"code": "none", "name": "None"},
                      {"code": "1_2", "name": "1-2 Years"},
                      {"code": "3_4", "name": "3-4 Years"},
                      {"code": "5_plus", "name": "5+ Years"}
                  ],

                  monthly_earnings: [
                      {"code": "0_5000", "name": "$0 - $5,000"},
                      {"code": "5001_15000", "name": "$5,001 - $15,000"},
                      {"code": "15001_25000", "name": "$15,001 - $25,000"},
                      {"code": "25000_plus", "name": "$25,000+"}
                  ]
              };
              return publisherSignupCodes;
          }
      }
  }]);